import {deviceId} from './device-id';
import {setContactContext,contactBlocked,contactMuted,contactScope,type ContactPreference} from './contact-names.mjs';
import {NicknameDialog} from './NicknameDialog';
import {folderMuted,messageNotificationAllowed} from '../notification-policy.mjs';
import './contact-controls.css';
import {mergeSentMessage} from './message-delivery';
import {chatMessagePath,parseChatLocation} from './message-link';
import {ChannelIcon} from './ChannelIcon';
import {ImageViewer} from './ImageViewer';
import {AttachmentCrop} from './AttachmentCrop';
import {createRosterGate} from './call-roster';
import {OfficialBroadcasts} from './OfficialBroadcasts';
import {ChatCodeBlock} from './ChatCodeBlock';
import {tokenizeMessage} from '../message-tokenizer.mjs';
import {AppRuntime,ReleasePage} from './AppRuntime';
import {initMonitoring,captureReactError,setMonitoringUser} from './monitoring';
import {sendClientSignals} from './client-signals';
import {CustomStatus,CustomStatusEditor} from './CustomStatus';
import {VoiceRosterMedia} from './VoiceRosterMedia';
import {WebUpdateNotice} from './WebUpdateNotice';
import {ChannelBadges} from './ChannelBadges';
import {ModerationSupport} from './ModerationSupport';
import {RailTooltip} from './RailTooltip';
import {t as __t} from './i18n';
import {spotifyConnectResult} from './SpotifyConnect';
import {connectionResult} from './Connections';
import {SuspendedServers,ServerRestrictionInfo} from './ServerRestriction';
import {CategorySection} from './CategorySection';
import {ParticipantVolumeMenu} from './ParticipantVolumeMenu';
import {ProfileRoleEditor} from './ProfileRoleEditor';
import {findCallParticipant} from './call-people';
import {Discovery} from './Discovery';
import {MessageSearch} from './MessageSearch';
import {EmoteGlyph,customEmoteId,useCustomEmotes,emojiOnlyMessage} from './CustomEmotes';
import {VirtualMessages,JumpToLatest,VirtualMessageHandle} from './VirtualMessages';
import {ComposerScope,ComposerSuggestions,ComposerHandle} from './ComposerScope';
import {useTypingUsers} from './useTypingUsers';
import {emojiQuery,searchEmoji,animatedEmote} from './emoji-catalog';
import {AnimatedEmote,EmojiSuggestions} from './EmojiSuggestions';
import {useDmUnread} from './useDmUnread';
import {RoleName,roleBackground} from './RoleName';
import {MemberControls} from './MemberControls';
import {PollComposer,PollMessage} from './Polls';
import {useChatCooldown,ChatCooldown} from './ChatCooldown';
import './server-controls.css';
import {useRoomState,readRoomDraft,setRoomDraft} from './useRoomDraft';
import {parseBotInvite,botInviteAppLink,inDesktopApp,offerDesktopApp} from './bot-invite';
import {applyParticipantAudio,clampAudioVolume,openStreamMenu} from './stream-audio';
import {OfficialAccountTag,OfficialSafetyNotice} from './OfficialSystemProfile';
import {isSystemAccount,OFFICIAL_CHAT_ID} from './systemAccount';
import {useAppViewport} from './useAppViewport';
import './viewport-layout.css';
import {EMAIL_SOURCE, MENTION_SOURCE, isEmailAddress, isMentionToken} from '../mentions.mjs';
import {ChannelMoveHandle} from './ChannelMoveHandle';
import {ProfileStatusMenu} from './ProfileStatusMenu';
import {useChatScroll} from './useChatScroll';
import {streamAudioConstraints,watchingScreen} from './stream-audio';
import {streamPermissions,createStreamWatchReporter} from './stream-access';
import {StreamAccess} from './StreamAccess';
import {microphoneOptions,createSpeakingIndicator} from './microphone-processing';
import {setCallMicrophone,microphoneFailure,microphoneToggleMuted} from './call-microphone';
import {MutedSpeechHint} from './MutedSpeechHint';
import {replyPreview} from './reply-preview';
import {CallElapsed,CallHistoryMessage,type CallEvent} from './CallHistoryMessage';
import {IncomingCallNotice} from './IncomingCallNotice';
import {createCallDismissals} from './incoming-call-dismissal';
import {CreateChannel} from './CreateChannel';
import {SupportAdmin} from './SupportAdmin';
import {toggleStreamFullscreen} from './stream-fullscreen';
import {MessageNotices,pushMessageNotice} from './MessageNotices';
import {requestStreamWatch,takeStreamWatch} from './stream-watch-intent';
import {RestrictedAccount,ModerationWarning} from './ModerationNotice';
import {AudioQuickMenu} from './UserDock';
import './image-file';
import {AnimatedSticker} from './Stickers';
import {stickerFromMessage} from './sticker-catalog';
import {FloatingWindow,useFloatingPosition} from './FloatingWindow';
import {ClipStatus} from './Clips';
import {ServerRail} from './ServerRail';
import {DownloadsPanel} from './MacDownloads';
import {LinkMirror,LINK_REGEX,hasLink,linkHref} from './LinkMirror';
import {LINK_SOURCE} from './linkTokens';
import {MASKED_LINK_SOURCE,outsideMaskedLinks,parseMaskedLink,stripMaskedLinks} from './maskedLink';
import {avatarSrc,bannerFallback} from './avatar';
import {useAnimatedToggle,useAnimatedValue} from './useAnimatedToggle';
import {BadgeToken} from './BadgeToken';
import {ReportDialog} from './ReportDialog';
import {publicationKeys,sourceKeys} from './media-lifecycle';
import {ProfileView} from './ProfileView';
import {useAvatarTint} from './avatar-tint';
import {StaffMark} from './StaffMark';
import {copyImageToClipboard} from './copy-image';
import {useKeybinds} from './keybinds';
import {useSoundboardActivity} from './useSoundboardActivity';
import {SoundboardButton,playSound,soundboardAllowed,soundboardMutedUsers,toggleSoundboardUser} from './Soundboard';
import {ActivityLine,ActivityCard,setActivities,shareActivity} from './activity';
import {startSettingsSync} from './settings-sync';
import {DmProfilePanel} from './DmProfilePanel';
import {BadgeIcon} from './BadgeIcon';
import {IdentityBadges} from './IdentityBadges';
import {profileTheme,shownName} from './profileTheme';
import { VideoPlayer } from './VideoPlayer';
import { AudioPlayer } from './AudioPlayer';
import './media-playback.css';
import { InviteEmbed, VerifiedBadgeSvg, UserStatSvg, extractInviteCode } from './InviteEmbed';
import { ContextMenu, MenuAction } from './ContextMenu';
import { EmojiPicker } from './EmojiPicker';
import { CallGames } from './CallGames';
import React, { useLayoutEffect,useEffect, useMemo, useRef, useState } from 'react';
import * as e2ee from './e2ee';
import './long-press';
import { useMobileGestures, isPhone, usePhoneLayout } from './mobile-gestures';
import {MessageSquare} from 'lucide-react';
import {Pin as GroupPin,PinOff as GroupUnpin} from 'lucide-react';
import { QrApprove, captureQrParam, pendingQr } from './QrLogin';
captureQrParam();
import { useWebUpdate, checkForUpdate, rememberCall, takeResume, installUpdate, type Resume } from './web-update';
import { E2eeDialog, useE2eeVersion } from './E2eeDialog';
import { createRoot } from 'react-dom/client';
import { flushSync,createPortal } from 'react-dom';
import { io, Socket } from 'socket.io-client';
import type { Room } from 'livekit-client';
// The call engine (~560 KB) loads when a call starts (and quietly in the background later), not at page start.
let LK: typeof import('livekit-client') | null = null;
let lkLoading: Promise<typeof import('livekit-client')> | null = null;
const loadLK = () => { if (LK) return Promise.resolve(LK); lkLoading ||= import('livekit-client').then(m => (LK = m)); lkLoading.catch(() => { lkLoading = null; }); return lkLoading; };
if (typeof window !== 'undefined') window.setTimeout(() => { const idle = (window as any).requestIdleCallback || ((f: () => void) => setTimeout(f, 1)); idle(() => { void loadLK().catch(() => {}); void import('./emoji-catalog').then(m => m.loadEmoji()).catch(() => {}); }); }, 6000);
import {
  Sparkles,
  Plus,
  Hash,
  Volume2,
  VolumeX,
  Users,
  Search,
  Settings,
  Mic,
  MicOff,
  Headphones,
  Phone,
  PhoneOff,
  Video,
  VideoOff,
  MonitorUp,
  MonitorOff,
  MessageCircle,
  Bell,
  Check,
  X,
  Send,
  Paperclip,
  Smile,
  Shield,
  Heart,
  Copy,
  MoreHorizontal,
  Trash2,
  Pencil,
  Download,
  Menu,
  ChevronDown,
  AtSign,
  Mail,
  Lock,
  LockOpen,
  Globe,
  ChevronRight,
  UserPlus,
  UserMinus,
  Flag,
  CheckCheck,
  LoaderCircle,
  Bookmark,
  Gamepad2,
  CornerDownRight,
  Bold,
  Italic,
  Strikethrough,
  KeyRound,
  Hand,
  Megaphone,
  HelpCircle,
  Lightbulb,
  FileUp,
  Image,
  Link2,
  Underline,
  RefreshCw,
  Ban,
  UserX,
  User,
  Maximize2,
  Minimize2, PictureInPicture2, PanelTopOpen, PanelRightOpen, PanelRightClose, GripHorizontal, Sticker, SmilePlus, LifeBuoy
} from 'lucide-react';
import './style.css';
import { Auth } from './Auth';
import {AccountSwitcher, SavedAccount} from './AccountSwitcher';
import {FriendNotice, FriendshipNotice} from './FriendNotice';
import {t as translate} from './i18n';
import { VerifyEmail } from './VerifyEmail';
import { Subscription } from './Subscription';
import { SavedMessages } from './SavedMessages';
import { SettingsPanel } from './SettingsPanel';
import { CommunityDialog } from './CommunityDialog';
import { FriendsView } from './FriendsView';
import { ServerSettings } from './ServerSettings';
import {ServerLeaveDialog} from './ServerLeaveDialog';
import { ScreenPicker, type ScreenSource, type ScreenChoice } from './ScreenPicker';
import { MessageEmbeds, type Embed } from './Embeds';
import { MessageComponents, type MessagePart } from './MessageComponents';
import { BotTag } from './BotTag';
import { ReactionsDialog } from './ReactionsDialog';
import { ExploreBots, InviteBot } from './ExploreBots';
import { ExploreServers } from './ExploreServers';
import { GuildTagPopup } from './GuildTagPicker';
import { trackPing, usePing, pingLevel } from './voice-ping';
import { applyMicGain } from './audio-volume';
import './select-enhance';
import './touch-drag';
import './range-style';
import { humanCheck } from './human-check';
import { BotModal, BotModalData } from './BotModal';
import { GroupCreate, GroupManage, GroupAvatar, GroupMembersPanel } from './GroupDialogs';
import { Bot as BotIcon, Bell as BellIcon, BellOff, Compass, Signal, Rss, AudioWaveform, Music4, Clock } from 'lucide-react';
import { DeveloperPortal } from './DeveloperPortal';
import { parseSlash, type SlashCommand } from './slash-commands';
import {createSendHistory} from './send-history';
import {recoverCallMicrophones,syncCallAudioMute} from './call-audio-recovery';
import './social-layout.css';
import {
  applyAppearanceSettings,
  copyToClipboard,
  getAccountAgeText,
  getLang,
  getUserBadges,
  useLang
} from './i18n';
import {
  playCallJoinSound,
  playCallLeaveSound,
  playDeafenToggleSound,
  playMessageSound,
  playMentionSound,
  scheduleRingPhrase,
  chooseCallTone,
  type CallTone,
  playMuteToggleSound,
  playOutgoingRingPulse,
  stopOutgoingRingtone,
  playScreenShareStartSound,
  playScreenShareStopSound
} from './sounds';
import { CustomSelect, HeadphonesOffIcon } from './CustomSelect';

type CustomRole = { colorSecondary?:string|null;autoAssign?:string;autoBefore?:number|null; id: string; name: string; color: string; position: number; permissions?: string[]; hoist?: number };
type Person = {
  accountVerified?:number;callStartedAt?:number|null;
  webhook?:boolean;
  id: string;
  appVerified?: boolean;
  username: string;
  displayName: string;
  bio: string;
  color: string;
  color2: string;
  avatar: string | null;
  banner?: string | null;
  status: string;
  customStatus?:string;customStatusUntil?:number|null;
  email?: string;
  verified?: number;
  bot?: number;
  isOwnerAdmin?: boolean;
  teamAccess?: boolean;
  canManageOfficial?:boolean;
  teamRole?: string;
  teamCapabilities?: string[];
  official?: boolean;
  guildTags?: {id:string;tag:string;icon:string;color:string}[];
  role?: string;
  supporter?: boolean;
  customRoles?: CustomRole[];
  roleColor?: string | null;
  roleColorSecondary?:string|null;voiceRoomId?:string|null;serverMuted?:boolean;serverDeafened?:boolean;timeoutUntil?:number;
  created?: number;
  customBadges?: string[];
  profileGradient?: boolean;
};
type Channel = {
  userLimit?:number;slowmodeSeconds?:number;slowmodeUntil?:number;permissionsSynced?:number;
  id: string;
  name: string;
  icon?:string;
  kind: 'text' | 'voice';
  topic: string;
  category?: string;
  readOnly?: number;
  permissions?: Record<string, any>;
  capabilities?: Record<string, boolean>;
};
type Community = {
  systemTeam?:boolean;
  suspended?:boolean;restriction?:{expires?:number|null;reason?:string;created?:number}|null;
  timeoutUntil?:number;
  id: string;
  name: string;
  invite: string;
  vanityInvite?: string | null;
  inviteExpires?: string;
  inviteMaxUses?: number;
  role: string;
  channels: Channel[];
  categoryPermissions?:Record<string,unknown>;
  categoryIds?:Record<string,string>;
  verified?: number;
  official?: boolean;
  guildTags?: {id:string;tag:string;icon:string;color:string}[];
  banner?: string;
  description?: string;
  icon?: string;
  memberCount?: number;
  onlineCount?: number;
  roles?: CustomRole[];
  capabilities?: {manageChannels?:boolean;[key:string]:boolean|undefined};
  canManage?: boolean;
  canPostReadOnly?: boolean;
};
type Friend = { id: string; senderId: string; recipientId: string; state: string; person: Person };
type DM = { contactBlocked?:boolean;id: string; person: Person; e2ee?: number | boolean; lastActivity?: number; official?: boolean; readOnly?: boolean; unread?: boolean; group?: { name: string; ownerId: string; members: Person[];avatarId?:string|null;canManage?:boolean } };
type FileInfo = { id: string; name: string; mime: string; size: number; url?: string; e2ee?: e2ee.FileMeta };
type Message = {
  callEvent?:CallEvent|null;
  clientMessageId?:string|null;
  e2ee?: boolean;
  officialPrivate?:boolean;
  official?:boolean;
  pinned?:boolean;
  suggestedReactions?:string[];
  mentionUsers?: Array<{id:string;displayName:string;username:string}>;
  files?:FileInfo[];
  poll?:boolean;
  id: string;
  body: string;
  author: Person;
  authorId: string;
  created: number;
  edited: number | null;
  channelId: string | null;
  conversationId: string | null;
  file: FileInfo | null;
  reactions: { emoji: string; userId: string }[];
  replyPing?:number|boolean;replyTo?: { id: string; body: string; author: Person } | null;
  embeds?: Embed[] | null;
  components?: MessagePart[] | null;
  interaction?: { command: string; user: Person } | null;
  ephemeral?: boolean;
  pending?: boolean;
};
type Bootstrap = {
  viewerId?:string;contactPreferences?:Record<string,ContactPreference>;
  communities: Community[];
  friends: Friend[];
  conversations: DM[];
  online: string[];
  blocks: { targetId: string; person?: Person }[];
};
type Features = { mail: boolean; voice: boolean; storage: string; profilePlus: boolean; billing?: boolean; captcha?: string };

const empty: Bootstrap = { communities: [], friends: [], conversations: [], online: [], blocks: [] };
const FALLBACK_PERSON: Person = {
  id: 'malvo-system',
  username: 'malvo',
  displayName: 'MALVO',
  bio: 'Official MALVO Server',
  color: '#ef5252',
  color2: '#a82020',
  avatar: 'icon.png',
  status: 'online',
  verified: 1,
  supporter: true
};

let socket: Socket | undefined;
// Live (chat) connection outages: the server ends a voice session after about 30 s without it, so the call can explain why it was removed.
let liveDownSince=0,lastLiveOutage={from:0,to:0};
const longLiveOutage=()=>{const t=Date.now();return liveDownSince?t-liveDownSince>=25000:lastLiveOutage.to-lastLiveOutage.from>=25000&&t-lastLiveOutage.to<90000;};
let ringAudio: AudioContext | null = null;
let stopIncomingEcho: (() => void) | undefined;
let activeRingNodes: { o: OscillatorNode; g: GainNode }[] = [];

function stopRingtone() {
  stopOutgoingRingtone();
  stopIncomingEcho?.();
  stopIncomingEcho = undefined;
  for (const n of activeRingNodes) {
    try {
      n.o.stop();
    } catch {}
    try {
      n.g.disconnect();
    } catch {}
  }
  activeRingNodes = [];
}

const armSound = () => {
  try {
    ringAudio ??= new AudioContext();
    void ringAudio.resume();
  } catch {}
};
window.addEventListener('pointerdown', armSound);
window.addEventListener('keydown', armSound);

// Desktop app: native notification. Browser: Notification API once allowed. Only while MALVO is not focused.
function showNotification(title: string, body: string, tag: string, _communityId: string | null) {
  pushMessageNotice({title,body,roomId:tag,communityId:_communityId});
  if (!document.hidden && document.hasFocus()) return;
  try { if (localStorage.getItem('malvo-notif-desktop') === '0') return; } catch {}
  const desktop = (window as any).malvoDesktop;
  if (desktop?.isDesktop) { desktop.notify(title, body); return; }
  if (!('Notification' in window) || Notification.permission !== 'granted') return;
  try { const n = new Notification(title, { body: body.slice(0, 180), icon: '/icon.png', tag }); n.onclick = () => { window.focus(); n.close(); }; } catch {}
}
// Ask once, on the first click, so the browser accepts the permission prompt.
if ('Notification' in window && Notification.permission === 'default' && !(window as any).malvoDesktop) {
  window.addEventListener('pointerdown', () => { try { if (localStorage.getItem('malvo-notif-asked')) return; localStorage.setItem('malvo-notif-asked', '1'); } catch {} void Notification.requestPermission().catch(() => {}); }, { once: true });
}

// Readable message when the server (or the proxy in front of it) answers without JSON.
function apiStatusError(status: number) {
  const de = getLang() === 'de';
  if (status === 429) return de ? 'Zu viele Anfragen. Bitte warte kurz und versuche es erneut.' : 'Too many requests. Please wait a moment and try again.';
  if (status === 502 || status === 503 || status === 504) return de ? 'Der Server startet gerade neu. Bitte versuche es in ein paar Sekunden erneut.' : 'The server is restarting. Please try again in a few seconds.';
  return de ? 'Unerwartete Antwort vom Server (' + status + '). Bitte versuche es erneut.' : 'Unexpected server response (' + status + '). Please try again.';
}
let currentAccount:string|null=null;
let captchaSiteKey='',captchaToken='';
async function api(url: string, method = 'GET', body?: unknown, attempt = 0, signal?:AbortSignal): Promise<any> {
  const expected=currentAccount;
  const captcha=captchaToken;captchaToken='';
  const retry = method === 'GET' && attempt < 3;
  signal?.throwIfAborted();
  let networkFailure:unknown;
  const timeout=/^\/rooms\/[^/]+\/call$/.test(url)?12000:url==='/settings'?8000:30000;
  const r = await fetch('/api' + url, {
    method,
    signal: signal?AbortSignal.any([signal,AbortSignal.timeout(timeout)]):AbortSignal.timeout(timeout),
    headers: { 'x-malvo': '1', ...(captcha?{'x-captcha':captcha}:{}), ...(expected?{'x-malvo-account':expected}:{}), 'Accept-Language':getLang(), ...(body instanceof FormData ? {} : { 'Content-Type': 'application/json' }) },
    ...(body === undefined ? {} : { body: body instanceof FormData ? body : JSON.stringify(body) })
  }).catch(error => {if(signal?.aborted)throw error;networkFailure=error;return null});
  const pause = () => new Promise(res => setTimeout(res, 700 * 2 ** attempt));
  if (!r) {
    if (retry) { await pause(); return api(url, method, body, attempt + 1,signal); }
    if((networkFailure as Error)?.name==='TimeoutError')throw Error(getLang()==='de'?'Der Server hat nicht rechtzeitig geantwortet. Bitte versuche es erneut.':'The server took too long to respond. Please try again.');
    throw Error(getLang() === 'de' ? 'Keine Verbindung zum Server. Bitte prüfe deine Internetverbindung.' : 'Could not reach the server. Please check your connection.');
  }
  if (retry && [502, 503, 504].includes(r.status)) { await pause(); return api(url, method, body, attempt + 1,signal); }
  if(expected&&currentAccount!==expected)throw new DOMException('Account changed','AbortError');
  // A proxy or restart page can answer 200 with HTML; never hand that to callers as data.
  const d = r.status===204?null:await r.json().catch(() => { if (r.ok) throw Object.assign(Error(apiStatusError(r.status)), { status: r.status }); return { error: apiStatusError(r.status) }; });
  if (r.status===428 && d?.code==='CAPTCHA_REQUIRED' && captchaSiteKey && !captcha) { captchaToken = await humanCheck(captchaSiteKey, getLang()==='de'); return api(url, method, body, attempt, signal); }
  if (!r.ok && d?.code==='ACCOUNT_SUSPENDED' && d?.restriction) window.dispatchEvent(new CustomEvent('malvo:restricted',{detail:d.restriction}));
  if (!r.ok) throw Object.assign(Error(d?.error || apiStatusError(r.status)), { status: r.status, retryAfter: d?.retryAfter,code:d?.code });
  return d;
}

// Back from "Connect Spotify": drop the result parameter from the address bar.
if (new URLSearchParams(location.search).has('spotify')) history.replaceState({}, '', location.pathname);

const MAX_FILES_PER_SEND=5;
const initial = (p?: Person | null) => (shownName(p) || 'MA').slice(0, 2).toUpperCase();

function TintedTile({ src, className, style, children, ...rest }: React.HTMLAttributes<HTMLDivElement> & { src: string | null | undefined }) {
  const tint = useAvatarTint(src);
  return <div className={className} style={{ ...style, background: tint, ['--tile-tint' as any]: tint }} {...rest}>{children}</div>;
}

function currentNotificationPreferences(){const result:Record<string,string>={};for(const key of ['malvo-muted-servers','malvo-muted-channels','malvo-muted-folders','malvo-server-layout:'+(document.documentElement.dataset.contactOwner||'')]){result[key]=localStorage.getItem(key)||''}return result;}
function Avatar({
  person,
  size = 40,
  online = false,
  showOfflineDot = false,
  onClick
}: {
  person?: Person | null;
  size?: number;
  online?: boolean;
  showOfflineDot?: boolean;
  onClick?: () => void;
}) {
  const p = person || FALLBACK_PERSON;
  const imgSrc = avatarSrc(p);
  const dotStatus = online && p.status !== 'invisible' ? p.status || 'online' : showOfflineDot ? 'offline' : null;
  return (
    <span
      onClick={onClick}
      className={'avatar ' + (onClick ? 'clickable' : '')}
      style={{ '--presence-size':Math.max(10,Math.round(size*.25))+'px', width: size, height: size, background: imgSrc ? 'transparent' : p.color || '#2b2b36' } as React.CSSProperties}
    >
      {imgSrc ? <img src={imgSrc} alt="" loading="lazy" decoding="async" /> : initial(p)}
      {dotStatus && <i className={'status-dot status-' + dotStatus} />}
    </span>
  );
}

// Channel is limited for normal members (only certain roles may see, join or write) → lock on its icon.
function channelRestricted(c: any) {
  let p: any = {};
  try { p = typeof c.permissions === 'string' ? JSON.parse(c.permissions || '{}') : c.permissions || {}; } catch {}
  const every = p.roleOverrides?.['@everyone'] || {};
  if (p.viewChannel === 'roles' || every.view_channel === false) return true;
  if (c.kind === 'voice') return p.connectVoice === false || every.connect_voice === false || every.voice_speak === false || c.capabilities?.connect_voice === false;
  return !!c.readOnly || p.sendMessages === false || every.send_messages === false;
}
function channelIcon(c: Channel, official = false) {
  const icon = channelIconBase(c, official);
  if (!channelRestricted(c)) return icon;
  return <span className="ch-icon-locked">{icon}<Lock size={9} strokeWidth={3} className="ch-icon-lock" /></span>;
}
function channelIconBase(c: Channel, official = false) {
  if(c.icon)return <ChannelIcon value={c.icon}/>;
  const tone=(color='')=>'ch-icon '+(official?color:'ch-neutral');
  if (c.kind === 'voice') return <Volume2 size={17} className={tone('ch-voice')} />;
  const n = c.name.toLowerCase();
  if (n.includes('regel') || n.includes('rule')) return <KeyRound size={16} className={tone('ch-red')} />;
  if (n.includes('willkommen') || n.includes('welcome')) return <Hand size={16} className={tone('ch-red')} />;
  if (n.includes('ankündigung') || n.includes('announce') || n.includes('news')) return <Megaphone size={16} className={tone('ch-red')} />;
  if (n.includes('allgemein') || n.includes('general') || n.includes('chat')) return <MessageCircle size={16} className={tone('ch-blue')} />;
  if (n.includes('frage') || n.includes('question') || n.includes('hilfe') || n.includes('help')) return <HelpCircle size={16} className={tone('ch-blue')} />;
  if (n.includes('idee') || n.includes('feedback') || n.includes('showcase') || n.includes('bug')) return <Lightbulb size={16} className={tone('ch-green')} />;
  return <Hash size={17} className={tone()} />;
}

const GIF_OR_MEDIA_URL_REGEX =
  /(https?:\/\/[^\s]+?\.(?:gif|png|jpe?g|webp|mp4|webm|mov)(?:\?[^\s]*)?|https?:\/\/(?:media\.)?(?:giphy\.com|tenor\.com|klipy\.co|klipy\.com)\/[^\s]+)/gi;

function stripMediaUrlsFromText(text: string): string {
  if (!text) return '';
  return outsideMaskedLinks(text, part => part.replace(GIF_OR_MEDIA_URL_REGEX, '')).trim();
}

// Puts a confirmed message in place of its grey pending copy (by temp id, else the oldest pending one with the same text).
function Spoiler({ children }: { children: React.ReactNode }) {
  const [shown, setShown] = React.useState(false);
  return <span className={'chat-spoiler' + (shown ? ' is-shown' : '')} role="button" tabIndex={0} title={shown ? undefined : 'Spoiler'}
    onClick={e => { if (!shown) { e.stopPropagation(); setShown(true); } }}
    onKeyDown={e => { if (!shown && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); setShown(true); } }}>{children}</span>;
}

// Discord-style markdown: headings (#, ##, ###), -# subtext, > / >>> quotes, - / * / 1. lists, ```code blocks```,
// plus inline **bold**, *italic*, _italic_, __underline__, ~~strike~~, ||spoiler||, `code`, links and mentions.
// Set by the app on every render: turns a channel id into its name and an "open" action (null if not visible to the reader).
let resolveUserName:(id:string)=>string=()=>"Nutzer",resolveRoleName:(id:string)=>string=()=>"Rolle";
let resolveChannelLink: (id: string) => { name: string; kind: string; open: () => void } | null = () => null;
const CHANNEL_LINK = /^(?:https?:\/\/)?(?:www\.)?(?:malvo\.eu|localhost(?::\d+)?)\/\?channel=([A-Za-z0-9_-]{3,64})$/i;
function renderFormattedMessageBody(text: string, onJoinInvite?: (code: string) => void, onMention?: (username: string) => void, onBotInvite?: (invite: {id:string;permissions:string[]}) => void): React.ReactNode {
  const sticker=stickerFromMessage(text);if(sticker)return <AnimatedSticker id={sticker.id} label={sticker.label}/>;
  if (text === '[Nachricht eines gelöschten Kontos]') text = translate('[Message from a deleted account]', text);
  const cleaned = stripMediaUrlsFromText(text);
  if (!cleaned) return null;

  const tokenRegex = new RegExp('(<a?:[a-z0-9_]{2,32}:[0-9a-f-]{36}>|<#[A-Za-z0-9_-]{3,64}>|<@&?[0-9a-f-]{36}>|' + EMAIL_SOURCE + '|' + MASKED_LINK_SOURCE + '|:a_[a-z]+:|' + LINK_SOURCE + '|' +
    /PLACEHOLDER_MENTION|\|\|[^|\n]+?\|\||\*\*\*[^*\n]+\*\*\*|\*\*[^*\n]+?\*\*|__[^_]+__|~~[^~]+~~|\*[^*\n]+\*|\b_[^_\n]+_\b|`[^`\n]+`/.source.replace('PLACEHOLDER_MENTION', MENTION_SOURCE) + ')', 'giu');


  const inline = (src: string, k: string): React.ReactNode[] => {
    tokenRegex.lastIndex = 0;
    const parts = tokenizeMessage(src,tokenRegex);
    return parts.map((part, idx) => {
        if (!part) return null;
        if(customEmoteId(part))return <EmoteGlyph key={k+idx} value={part}/>;
        const userToken=/^<@([0-9a-f-]{36})>$/.exec(part);if(userToken)return <button type="button" className="chat-mention" key={k+idx} onClick={()=>onMention?.(userToken[1])}>@{resolveUserName(userToken[1])}</button>;
        const roleToken=/^<@&([0-9a-f-]{36})>$/.exec(part);if(roleToken)return <span className="chat-mention" key={k+idx}>@{resolveRoleName(roleToken[1])}</span>;
        if(animatedEmote(part))return <AnimatedEmote key={k+idx} token={part}/>;
        if (isEmailAddress(part)) return <React.Fragment key={k + idx}>{part}</React.Fragment>;
        const masked = parseMaskedLink(part);
        if (masked) {
          const code = extractInviteCode(masked.href), bot=parseBotInvite(masked.href);
          return (
            <a key={k + idx} href={masked.href} title={masked.href} target="_blank" rel="noopener noreferrer ugc" className="chat-external-link"
              onClick={e => { if(bot&&onBotInvite&&!e.ctrlKey&&!e.metaKey&&!e.shiftKey){e.preventDefault();onBotInvite(bot);}else if (code && onJoinInvite) { e.preventDefault(); onJoinInvite(code); } }}>
              {masked.label}
            </a>
          );
        }
        const channelId = /^<#([A-Za-z0-9_-]{3,64})>$/.exec(part)?.[1]||CHANNEL_LINK.exec(part)?.[1];
        if (channelId) {
          const info = resolveChannelLink(channelId);
          return info
            ? <button key={k + idx} type="button" className="chat-channel-pill" title={part} onClick={e => { e.stopPropagation(); info.open(); }}>{info.kind === 'voice' ? '🔊' : '#'} {info.name}</button>
            : <span key={k + idx} className="chat-channel-pill is-unknown" title={part}># {getLang() === 'de' ? 'Kanal nicht verfügbar' : 'channel unavailable'}</span>;
        }
        const botInvite=parseBotInvite(part);
        if(botInvite)return <a key={k + idx} href={part} className="chat-external-link" onClick={e=>{if(onBotInvite&&!e.ctrlKey&&!e.metaKey&&!e.shiftKey){e.preventDefault();onBotInvite(botInvite);}}}>{part}</a>;
        const invCode = extractInviteCode(part);
        if (isMentionToken(part)) {
          return (
            part === '@everyone' || part === '@here' || !onMention
              ? <span key={k + idx} className="chat-mention-pill">{part}</span>
              : <span key={k + idx} className="chat-mention-pill is-clickable" role="button" tabIndex={0}
                  onClick={e => { e.stopPropagation(); onMention(part.slice(1)); }}
                  onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onMention(part.slice(1)); } }}>{part}</span>
          );
        }
        if (invCode) {
          const href = part.startsWith('http') ? part : 'https://' + part.replace(/^\/+/, '');
          return (
            <a
              key={k + idx}
              href={href}
              className="chat-invite-link"
              onClick={e => {
                if (onJoinInvite) {
                  e.preventDefault();
                  onJoinInvite(invCode);
                }
              }}
            >
              {part}
            </a>
          );
        }
        if (new RegExp('^(?:' + LINK_REGEX.source + ')$', 'i').test(part)) {
          return (
            <a key={k + idx} href={linkHref(part)} target="_blank" rel="noreferrer" className="chat-external-link">
              {part}
            </a>
          );
        }
        if (part.startsWith('||') && part.endsWith('||') && part.length > 4) {
          return <Spoiler key={k + idx}>{inline(part.slice(2, -2), k + idx + 's')}</Spoiler>;
        }
        if (part.startsWith('***') && part.endsWith('***') && part.length > 6) {
          return <strong key={k + idx}><em>{inline(part.slice(3, -3), k + idx + 'bi')}</em></strong>;
        }
        if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
          return <strong key={k + idx}>{inline(part.slice(2, -2), k + idx + 'b')}</strong>;
        }
        if (part.startsWith('__') && part.endsWith('__') && part.length > 4) {
          return <u key={k + idx}>{inline(part.slice(2, -2), k + idx + 'u')}</u>;
        }
        if (part.startsWith('~~') && part.endsWith('~~') && part.length > 4) {
          return <s key={k + idx}>{inline(part.slice(2, -2), k + idx + 'x')}</s>;
        }
        if (((part.startsWith('*') && part.endsWith('*')) || (part.startsWith('_') && part.endsWith('_'))) && part.length > 2) {
          return <em key={k + idx}>{inline(part.slice(1, -1), k + idx + 'i')}</em>;
        }
        if (part.startsWith('`') && part.endsWith('`') && part.length > 2) {
          return <code key={k + idx} className="chat-inline-code">{part.slice(1, -1)}</code>;
        }
        return <React.Fragment key={k + idx}>{part}</React.Fragment>;
    });
  };

  // Block level
  const blocks: React.ReactNode[] = [];
  const segments = cleaned.split(/(```[\s\S]*?```)/g);
  let n = 0;
  for (const seg of segments) {
    if (!seg) continue;
    if (seg.startsWith('```') && seg.endsWith('```') && seg.length >= 6) {
      let body = seg.slice(3, -3), lang = '';
      const nl = body.indexOf('\n');
      if (nl >= 0 && /^[a-zA-Z0-9+#-]{1,20}$/.test(body.slice(0, nl).trim())) { lang = body.slice(0, nl).trim(); body = body.slice(nl + 1); }
      else if (body.startsWith('\n')) body = body.slice(1);
      blocks.push(<ChatCodeBlock key={'cb' + n++} language={lang} body={body.replace(/\n$/, '')}/>);
      continue;
    }
    const lines = seg.replace(/^\n|\n$/g, '').split('\n');
    let para: string[] = [];
    const flush = () => { if (para.length) { const t = para.join('\n'); blocks.push(<span key={'p' + n} className="md-para">{inline(t, 'p' + n++ + '-')}</span>); para = []; } };
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      let m: RegExpMatchArray | null;
      if (line.startsWith('>>> ')) { flush(); const rest = [line.slice(4), ...lines.slice(i + 1)].join('\n'); blocks.push(<blockquote key={'q' + n} className="chat-quote">{inline(rest, 'q' + n++ + '-')}</blockquote>); break; }
      if (line.startsWith('> ') || line === '>') {
        flush(); const q: string[] = [];
        while (i < lines.length && (lines[i].startsWith('> ') || lines[i] === '>')) { q.push(lines[i].slice(2)); i++; }
        i--; blocks.push(<blockquote key={'q' + n} className="chat-quote">{inline(q.join('\n'), 'q' + n++ + '-')}</blockquote>); continue;
      }
      if ((m = line.match(/^(#{1,3}) (.+)$/))) { flush(); const H = ('h' + m[1].length) as 'h1' | 'h2' | 'h3'; blocks.push(<H key={'h' + n} className="chat-heading">{inline(m[2], 'h' + n++ + '-')}</H>); continue; }
      if ((m = line.match(/^-# (.+)$/))) { flush(); blocks.push(<small key={'s' + n} className="chat-subtext">{inline(m[1], 's' + n++ + '-')}</small>); continue; }
      if (/^\s{0,4}[-*] .+/.test(line) || /^\s{0,4}\d{1,3}\. .+/.test(line)) {
        flush(); const ordered = /^\s{0,4}\d/.test(line); const items: { text: string; depth: number; num: number }[] = [];
        while (i < lines.length && (ordered ? /^\s{0,4}\d{1,3}\. .+/ : /^\s{0,4}[-*] .+/).test(lines[i])) {
          const mm = lines[i].match(/^(\s*)(?:[-*]|(\d{1,3})\.) (.+)$/)!; items.push({ text: mm[3], depth: mm[1].length >= 2 ? 1 : 0, num: Number(mm[2] || 0) }); i++;
        }
        i--; const L = ordered ? 'ol' : 'ul';
        blocks.push(<L key={'l' + n} className="chat-list" start={ordered ? items[0].num || 1 : undefined}>{items.map((it, j) => <li key={j} className={it.depth ? 'is-nested' : undefined}>{inline(it.text, 'l' + n + '-' + j + '-')}</li>)}</L>); n++; continue;
      }
      para.push(line);
    }
    flush();
  }
  return <div className={"message-text-body"+(emojiOnlyMessage(text)?" emoji-only-message":"")}>{blocks}</div>;
}

const linkImageCache = new Map<string, Promise<boolean>>();
function LinkImage({ url, onClick, onMenu }: { url: string; onClick?: () => void; onMenu?: (e: React.MouseEvent) => void }) {
  const [ok, setOk] = useState(false);
  useEffect(() => {
    let alive = true;
    if (!linkImageCache.has(url)) linkImageCache.set(url, fetch('/api/link-image?url=' + encodeURIComponent(url), { credentials: 'include' }).then(r => (r.ok ? r.json() : { image: false })).then(d => !!d.image).catch(() => false));
    void linkImageCache.get(url)!.then(v => { if (alive) setOk(v); });
    return () => { alive = false; };
  }, [url]);
  if (!ok) return null;
  return <div className="message-embedded-media"><img className="inline-gif embedded-media-img clickable-image" src={url} alt="" loading="lazy" referrerPolicy="no-referrer" onClick={onClick} onContextMenu={onMenu} onError={e => { (e.currentTarget as HTMLElement).style.display = 'none'; }} /></div>;
}

// Call menu entry: mute the soundboard sounds this person plays (only for you).
function SoundboardUserToggle({ id, tr }: { id: string; tr: (en: string, de: string) => string }) {
  const [on, setOn] = useState(() => soundboardMutedUsers().includes(id));
  return (
    <button type="button" role="menuitemcheckbox" aria-checked={on} className="voice-menu-item voice-menu-check" onClick={() => setOn(toggleSoundboardUser(id))}>
      <Music4 size={15} /> {tr('Mute soundboard', 'Soundboard stummschalten')}
      <span className={'voice-menu-box' + (on ? ' is-on' : '')}>{on && <Check size={12} strokeWidth={3} />}</span>
    </button>
  );
}

function renderMessageMedia(rawText: string, onImageClick?: (url: string) => void, onImageMenu?: (e: React.MouseEvent, url: string) => void) {
  const text = stripMaskedLinks(rawText);
  const vidRegex = /(https?:\/\/[^\s]+?\.(?:mp4|webm|mov)(?:\?[^\s]*)?)/gi;
  const imgRegex =
    /(https?:\/\/[^\s]+?\.(?:gif|png|jpe?g|webp)(?:\?[^\s]*)?|https?:\/\/(?:media\.)?(?:giphy\.com|tenor\.com|klipy\.co|klipy\.com)\/[^\s]+)/gi;
  const vidMatches = text.match(vidRegex);
  const imgMatches = text.match(imgRegex);
  if (!vidMatches && !imgMatches) {
    // Link without a file ending (e.g. image hosts): ask the server whether it is an image.
    const plain = (text.match(/https?:\/\/[^\s<>]+/gi) || []).find(u => !/malvo\.eu\//i.test(u) && !/\.(?:html?|php|pdf|zip|exe|mp3)(?:[?#]|$)/i.test(u));
    return plain ? <LinkImage key={plain} url={plain} onClick={() => onImageClick?.(plain)} onMenu={e => onImageMenu?.(e, plain)} /> : null;
  }
  return (
    <div className="message-embedded-media">
      {vidMatches &&
        Array.from(new Set(vidMatches))
          .slice(0, 2)
          .map((u, i) => <VideoPlayer key={'vid-' + i} src={u} />)}
      {imgMatches &&
        Array.from(new Set(imgMatches))
          .slice(0, 3)
          .map((u, i) => (
            <img
              key={'img-' + i}
              className="inline-gif embedded-media-img clickable-image"
              src={u}
              alt="GIF"
              loading="lazy"
              onClick={() => onImageClick?.(u)}
              onContextMenu={e => onImageMenu?.(e, u)}
              onError={e => {
                (e.currentTarget as HTMLElement).style.display = 'none';
              }}
            />
          ))}
    </div>
  );
}

function App() {
  const viewportRef=useAppViewport();
  const phone=usePhoneLayout();
  const [lang, , tr] = useLang();
  const isDesktopApp = (typeof navigator !== 'undefined' && navigator.userAgent.includes('MalvoDesktop')) || !!(window as any).malvoDesktop?.isDesktop;
  const [lightbox, setLightbox] = useState<{ src: string; name?: string } | null>(null);
  // Height of the call area above the chat; dragged with the handle under the call, remembered per device.
  const [dockHeight, setDockHeight] = useState<number>(() => { try { return Number(localStorage.getItem('malvo-call-dock-height')) || 0; } catch { return 0; } });
  async function copyImage(src: string) {
    try { await copyImageToClipboard(src); setNotice(tr('Image copied.', 'Bild kopiert.')); }
    catch { setError(tr('The image could not be copied.', 'Das Bild konnte nicht kopiert werden.')); }
  }
  function imageMenu(e: React.MouseEvent, src: string, name?: string) {
    e.preventDefault(); e.stopPropagation();
    const abs = new URL(src, location.href).href;
    setContext({ x: e.clientX, y: e.clientY, actions: [
      { label: tr('Copy image', 'Bild kopieren'), icon: <Copy size={15} />, run: () => void copyImage(src) },
      { label: tr('Copy link', 'Link kopieren'), icon: <Link2 size={15} />, run: () => { void copyToClipboard(abs); setNotice(tr('Link copied.', 'Link kopiert.')); } },
      { label: tr('Save image', 'Bild speichern'), icon: <Download size={15} />, run: () => { const a = document.createElement('a'); a.href = src; a.download = name || 'image'; document.body.append(a); a.click(); a.remove(); } },
      { label: tr('Open image', 'Bild öffnen'), icon: <Maximize2 size={15} />, run: () => setLightbox({ src, name }) }
    ] } as any);
  }
  const [hideBanner, setHideBanner] = useState(() => {
    try {
      return isDesktopApp || localStorage.getItem('hide_win_banner') === '1';
    } catch {
      return isDesktopApp;
    }
  });
  const [plusMenu,setPlusMenu,plusClosing]=useAnimatedToggle();
  useEffect(()=>{if(!plusMenu)return;const close=(e:KeyboardEvent)=>{if(e.key==='Escape')setPlusMenu(false);};window.addEventListener('keydown',close);return()=>window.removeEventListener('keydown',close);},[plusMenu]);
  const [settingsTab, setSettingsTab] = useState(spotifyConnectResult||connectionResult?'connections':'account');
  const [showDiscovery,setShowDiscovery]=useState(localStorage.getItem('malvo-show-discovery')!=='0');
  const pendingJump=useRef<{roomId:string;messageId:string}|null>(null);
  const [linkedMessage,setLinkedMessage]=useState<{roomId:string;messageId:string}|null>(null);
  const linkedReveal=useRef<(()=>void)|null>(null);
  const linkedHistory=useRef<{roomId:string;messageId:string}|null>(null);
  const voiceDrag=useRef<{uid:string;from:string}|null>(null);const [voiceDrop,setVoiceDrop]=useState<string|null>(null);
  const canMoveVoice=(c:any)=>!!c&&(c.role==='owner'||!!c.capabilities?.moveMembers);
  const [channelCategoryDrop,setChannelCategoryDrop]=useState<string|null>(null);const channelDrag=useRef<string|null>(null);const [channelDrop,setChannelDrop]=useState<{id:string;after:boolean}|null>(null),[categoryDrop,setCategoryDrop]=useState<{id:string;after:boolean}|null>(null);
  const [voiceRosters, setVoiceRosters] = useState<Record<string, Person[]>>({});
  const voiceRosterGate=useRef<{invalidate:()=>void}|null>(null);
  // Rooms whose first message is already loaded: no "Load older messages" there.
  const [historyStart, setHistoryStart] = useState<Record<string, boolean>>({});
  const [rosterVolume,setRosterVolume]=useState<{x:number;y:number;person:Person}|null>(null);
  const soundboardUsers = useSoundboardActivity();
  const [speakingUsers, setSpeakingUsers] = useState<Set<string>>(new Set());
  const [unreadPeers,setUnreadPeers]=useState<Record<string,Person>>({});
  const [unreadCounts, setUnreadCounts] = useState<Record<string, number>>({});
  // Pings (@mentions) per channel: only these show a red number; plain unread messages just highlight the channel/server.
  const [mentionCounts, setMentionCounts] = useState<Record<string, number>>({});
  useEffect(() => { setMentionCounts(m => { const keys = Object.keys(m).filter(k => !unreadCounts[k]); if (!keys.length) return m; const next = { ...m }; keys.forEach(k => delete next[k]); return next; }); }, [unreadCounts]);
  const serverMentions = (c: any) => folderMuted(currentNotificationPreferences(),me?.id||'',c?.id)?0:(c?.channels || []).reduce((sum: number, ch: any) => sum + (mentionCounts[ch.id] || 0), 0);
  const serverUnread = (c: any) => (c?.channels || []).some((ch: any) => (unreadCounts[ch.id] || 0) > 0);
  function markServersRead(serverIds:string[],folder=false){
    const selected=new Set(serverIds),channels=new Set(dataRef.current.communities.filter(c=>selected.has(c.id)&&!c.suspended).flatMap(c=>c.channels.map(ch=>ch.id)));
    const clear=(previous:Record<string,number>)=>Object.fromEntries(Object.entries(previous).filter(([id])=>!channels.has(id)));
    setUnreadCounts(clear);setMentionCounts(clear);setUnread(previous=>new Set([...previous].filter(id=>!channels.has(id))));
    setNotice(folder?tr('Folder marked as read.','Ordner als gelesen markiert.'):tr('Server marked as read.','Server als gelesen markiert.'));
  }
  const markFolderRead=(serverIds:string[])=>markServersRead(serverIds,true);
  const [botInvite,setBotInvite]=useState<{id:string;permissions:string[]}|null>(null);
  const [botModal,setBotModal]=useState<BotModalData|null>(null);

  const [invitedFriends, setInvitedFriends] = useState<Set<string>>(new Set());
  const [commands, setCommands] = useState<SlashCommand[]>([]);
  // Inline message editing: Enter saves, Shift+Enter adds a line, Escape cancels.
  const [editing, setEditing] = useState<{ id: string; text: string; saving?: boolean } | null>(null);
  const startEdit = (m: Message) => setEditing({ id: m.id, text: m.body });
  async function saveEdit() {
    if (!editing || editing.saving) return;
    const text = editing.text.trim();
    const original = messages.find(x => x.id === editing.id);
    if (!text || text === original?.body) { setEditing(null); return; }
    setEditing({ ...editing, saving: true });
    try {
      const editRoom = original?.conversationId || original?.channelId || '';
      await api('/messages/' + editing.id, 'PATCH', { body: await seal(editRoom, text) });
      setMessages(prev => prev.map(x => x.id === editing.id ? { ...x, edited: Date.now() } : x));
      setEditing(null);
    } catch (e) {
      setError((e as Error).message);
      setEditing(cur => cur && { ...cur, saving: false });
    }
  }
  const [settingsFocus, setSettingsFocus] = useState<{ page?: string; channelId?: string; category?: string;deleteCategory?:boolean } | null>(null);
  const openChannelSettings = (channelId: string) => { setSettingsFocus({ page: 'channels', channelId }); setModal('community-settings'); };
  const openCategorySettings = (category: string,deleteCategory=false) => { setSettingsFocus({ page: 'channels', category,deleteCategory }); setModal('community-settings'); };
  const [commandsVersion, setCommandsVersion] = useState(0);
  const [localMuted, setLocalMuted] = useState(()=>localStorage.getItem('malvo-mic-muted')==='1');
  const [localDeafened, setLocalDeafened] = useState(()=>localStorage.getItem('malvo-deafened')==='1');
  // Keyboard shortcuts from Settings → Keybinds.
  const pttRestore = useRef<boolean | null>(null);
  useKeybinds({
    run: action => {
      if (action === 'toggle_mute') setLocalMuted(v => !v);
      else if (action === 'toggle_deafen') setLocalDeafened(v => !v);
      else { const el = document.querySelector<HTMLButtonElement>('[data-hotkey="' + ({ disconnect: 'disconnect', toggle_camera: 'camera', toggle_screen: 'screen', soundboard: 'soundboard' } as any)[action] + '"]'); el?.click(); }
    },
    pushToTalk: down => {
      if (down) { if (pttRestore.current === null) pttRestore.current = true; setLocalMuted(false); }
      else { setLocalMuted(true); pttRestore.current = null; }
    }
  });
  const [callMinimized,setCallMinimized]=useState(false);
  useEffect(()=>{localStorage.setItem('malvo-mic-muted',localMuted?'1':'0');},[localMuted]);
  useEffect(()=>{localStorage.setItem('malvo-deafened',localDeafened?'1':'0');},[localDeafened]);
  const [reactionAnchor,setReactionAnchor]=useState<{x:number;y:number}>();
  const [emojiTab, setEmojiTab] = useState<'emoji' | 'gif' | 'sticker'>('emoji');
  const [shiftHeld, setShiftHeld] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [accountSwitching,setAccountSwitching]=useState(false);
  const [inviteCopied, setInviteCopied] = useState(false);
  const [editingInvite, setEditingInvite] = useState(false);
  const [inviteExpDraft, setInviteExpDraft] = useState('5d');
  const [inviteMaxDraft, setInviteMaxDraft] = useState('0');
  const [channelCategory,setChannelCategory]=useState('');
  const [collapsedCategories,setCollapsedCategories]=useState<Record<string,boolean>>(()=>{try{return JSON.parse(localStorage.getItem('malvo-collapsed-categories')||'{}')}catch{return {}}});
  const [newChannelKind, setNewChannelKind] = useState<'text' | 'voice'>('text');
  const [profileDmDraft, setProfileDmDraft] = useState('');

  const [me, setMe] = useState<Person | null>(null);
  const [pinnedGroups,setPinnedGroups]=useState<string[]>([]),[groupPinBusy,setGroupPinBusy]=useState(false);
  function readPinnedGroups(){try{const value=JSON.parse(localStorage.getItem('malvo-pinned-groups')||'[]');return Array.isArray(value)?[...new Set<string>(value.filter((id:unknown):id is string=>typeof id==='string'&&id.length>0&&id.length<=80))].slice(0,100):[]}catch{return []}}
  useEffect(()=>{setPinnedGroups(me?.id?readPinnedGroups():[]);setGroupPinBusy(false)},[me?.id]);
  function toggleGroupPin(conversation:any){
    if(!conversation?.group||!me||groupPinBusy)return;const owner=me.id,pinned=pinnedGroups.includes(conversation.id);
    if(!pinned&&pinnedGroups.length>=100){setError(tr('You can pin up to 100 groups. Unpin one first.','Du kannst bis zu 100 Gruppen anpinnen. Löse zuerst eine Gruppe.'));return;}
    const next=pinned?pinnedGroups.filter(id=>id!==conversation.id):[conversation.id,...pinnedGroups];setGroupPinBusy(true);
    void action(async()=>{try{await api('/settings','PUT',{'malvo-pinned-groups':JSON.stringify(next)});if(meRef.current?.id!==owner)return;setPinnedGroups(next);try{localStorage.setItem('malvo-pinned-groups',JSON.stringify(next))}catch{}setNotice(pinned?tr('Group unpinned.','Gruppe gelöst.'):tr('Group pinned.','Gruppe angepinnt.'));}finally{if(meRef.current?.id===owner)setGroupPinBusy(false)}});
  }
  useEffect(()=>{
    if(!me?.verified)return;
    const params=new URLSearchParams(location.search),id=params.get('botInvite');if(!id)return;
    const invite=parseBotInvite('https://malvo.eu/developer/authorize?'+new URLSearchParams({app:id,permissions:params.get('permissions')||''}));
    if(invite){setBotInvite(invite);offerDesktopApp(invite);}
    params.delete('botInvite');params.delete('permissions');history.replaceState({},'',location.pathname+(params.size?'?'+params:'')+location.hash);
  },[me?.id,me?.verified]);
  const [restriction,setRestriction]=useState<any>(null),[warnings,setWarnings]=useState<any[]>([]);
  const [audioMenu,setAudioMenu]=useState<null|'audioinput'|'audiooutput'>(null);
  useEffect(()=>{const changed=(e:Event)=>{setRestriction((e as CustomEvent).detail);setMe(null);setCall(null);setIncoming(null);socket?.disconnect();};window.addEventListener('malvo:restricted',changed);return()=>window.removeEventListener('malvo:restricted',changed);},[]);
  const [replyTo, setReplyTo] = useState<{ id: string; author: Person; body: string } | null>(null);
  const [replyPing,setReplyPing]=useState(true);useEffect(()=>setReplyPing(true),[replyTo?.id]);
  const [loading, setLoading] = useState(true);
  const [features, setFeatures] = useState<Features>({
    mail: false,
    voice: false,
    storage: 'local',
    profilePlus: true
  });
  const [data, setData] = useState<Bootstrap>(empty);
  document.documentElement.dataset.contactOwner=me?.id||'';
  setContactContext(me?.id||null,data.viewerId===me?.id?data.contactPreferences||{}:{},data.viewerId===me?.id?data.blocks.map(b=>b.targetId):[]);
  const [namingPerson,setNamingPerson]=useState<Person|null>(null);
  const [revealedBlocked,setRevealedBlocked]=useState<Set<string>>(new Set());
  const [activeCommunity, setActiveCommunity] = useState<string | null>(null);
  const [roomId, setRoomId] = useState<string | null>(null);
  const [rawMessages, setMessages] = useState<Message[]>([]);
  useEffect(()=>setRevealedBlocked(new Set()),[roomId,me?.id,data.blocks.map(b=>b.targetId).join('|')]);
  const revealKey=(id:string)=>contactScope()+':'+roomId+':'+id;
  const messageRevealed=(id:string)=>revealedBlocked.has(revealKey(id));
  const revealBlocked=(id:string)=>setRevealedBlocked(old=>{const next=new Set(old),key=revealKey(id);if(next.has(key))next.delete(key);else next.add(key);return next});
  const e2eeTick = useE2eeVersion();
  const [e2eeOpen, setE2eeOpen] = useState(false);
  const [pipClosed, setPipClosed] = useState(false);
  // Big servers: only the first offline members are rendered (like Discord's lazy member list); more on demand.
  const [offlineLimit, setOfflineLimit] = useState(150);
  const [qrApprove, setQrApprove] = useState(() => !!pendingQr());
  const updateReady = useWebUpdate();
  const [rejoinOffer, setRejoinOffer] = useState<Resume | null>(null);
  // Encrypted chats: show decrypted text everywhere (render, reply, copy, edit, search) while state keeps the ciphertext.
  const messages = useMemo(() => rawMessages.map(m => {
    const room = m.conversationId || m.channelId || '';
    const enc = e2ee.isEnvelope(m.body), encReply = !!m.replyTo && e2ee.isEnvelope(m.replyTo.body);
    if (!enc && !encReply) return m;
    const label = (v: e2ee.Shown) => v.state === 'ok' || v.state === 'plain' ? v.text : v.state === 'pending' ? '-# 🔒 …' : v.state === 'locked' ? '-# 🔒 ' + translate('Older encrypted message – not available on this device.', 'Ältere verschlüsselte Nachricht – auf diesem Gerät nicht verfügbar.') : '-# 🔒 ' + translate('This message cannot be decrypted on this device.', 'Diese Nachricht kann auf diesem Gerät nicht entschlüsselt werden.');
    const v = enc ? e2ee.view(m.body, room, m.authorId) : null;
    const packed = v && v.state === 'ok' ? e2ee.unpack(v.text) : null;
    const files = packed?.files.map(meta => { const url = e2ee.fileUrl(meta); return { id: meta.id, name: url === null ? '🔒 ' + meta.name : meta.name, mime: url ? meta.mime : 'application/x-malvo-encrypted', size: meta.size, url: url || '#' }; });
    if (enc) return { ...m, body: packed ? packed.text : label(v!), file: null, files: files || [], replyTo: encReply ? { ...m.replyTo!, body: e2ee.unpack(label(e2ee.view(m.replyTo!.body, room, m.replyTo!.author?.id || ''))).text.replace(/^-# /, '') || '📎' } : m.replyTo, e2ee: true };
    return { ...m, body: m.body, replyTo: encReply ? { ...m.replyTo!, body: label(e2ee.view(m.replyTo!.body, room, m.replyTo!.author?.id || '')).replace(/^-# /, '') } : m.replyTo, e2ee: enc };
  }), [rawMessages, e2eeTick]);
  const [loadedMessageRoom,setLoadedMessageRoom]=useState<string|null>(null);
  // Bumps only on a real /bootstrap reload (not on online-status updates), so members are not re-fetched constantly.
  const [dataVersion, setDataVersion] = useState(0);
  // Recently opened chats are kept in memory, so switching back shows them instantly while fresh messages load.
  const messageCache = useRef(new Map<string, Message[]>());const historyControl=useRef<VirtualMessageHandle|null>(null);
  useEffect(() => {
    if (!loadedMessageRoom) return;
    const cache = messageCache.current;
    cache.delete(loadedMessageRoom);
    cache.set(loadedMessageRoom, messages.filter(m => !m.pending).slice(-60));
    while (cache.size > 30) cache.delete(cache.keys().next().value as string);
  }, [messages, loadedMessageRoom]);
  const [members, setMembers] = useState<Person[]>([]);
  const memberCommunityRef=useRef(activeCommunity);memberCommunityRef.current=activeCommunity;const loadedMemberCommunity=useRef<string|null>(null);
  const memberCache=useRef(new Map<string,any[]>());
  async function refreshMembers(cid:string){const rows=await api('/communities/'+cid+'/members');memberCache.current.set(cid,rows);if(memberCommunityRef.current===cid)setMembers(rows);}
  const [tab, setTab] = useState('online');
  const [query, setQuery] = useState('');
  const [searchedDMs,setSearchedDMs]=useState<DM[]>([]);
  useEffect(()=>{if(!me?.verified||activeCommunity||query.trim().length<2){setSearchedDMs([]);return;}let cancelled=false;const timer=setTimeout(()=>{api('/dm/search?q='+encodeURIComponent(query)).then(d=>{if(!cancelled)setSearchedDMs(d)}).catch(()=>{});},180);return()=>{cancelled=true;clearTimeout(timer)};},[query,me?.id,me?.verified,activeCommunity]);
  const draftControl=useRef<ComposerHandle|null>(null);
  const setDraft=(value:string|((old:string)=>string))=>{if(draftControl.current)draftControl.current.setDraft(value);else setRoomDraft(me?.id,roomId,value)};
  const setDraftFor=setRoomDraft;
  const [attachment,setAttachment]=useRoomState<FileInfo|null>(me?.id,roomId,null);
  const [attachmentSource,setAttachmentSource]=useState<{id:string;file:File;room:string|null;account:string}|null>(null),[cropAttachment,setCropAttachment]=useState<File|null>(null);
  // Further files of one send go out as their own messages right after the first one.
  const [extraAttachments,setExtraAttachments]=useState<FileInfo[]>([]),[uploadBatch,setUploadBatch]=useState<{index:number;total:number}|null>(null),uploadAbort=useRef<AbortController|null>(null);
  useEffect(()=>{setAttachmentSource(null);setCropAttachment(null);setExtraAttachments([]);uploadAbort.current?.abort()},[roomId,me?.id]);
  useEffect(()=>{if(!attachment)setAttachmentSource(null)},[attachment?.id]);
  const [fileOver,setFileOver]=useState(false),fileDragDepth=useRef(0),[pollRoom,setPollRoom]=useState<string|null>(null),[managedMember,setManagedMember]=useState<Person|null>(null);
  const [sending, setSending] = useState(false);
  const [uploadProgress, setUploadProgress] = useState<number | null>(null);
  const [notice, setNotice] = useState('');
  const [friendNotice, setFriendNotice] = useState<FriendshipNotice | null>(null);
  const [error, setError] = useState('');
  const [modal, setModalRaw] = useState<string | null>(spotifyConnectResult||connectionResult?'settings':null);
  const [modalServerId,setModalServerId]=useState<string|null>(null),[modalMembers,setModalMembers]=useState<Person[]>([]);
  useEffect(()=>{let live=true;if(modalServerId)api('/communities/'+modalServerId+'/members').then(rows=>{if(live)setModalMembers(rows)}).catch(()=>{if(live)setModalMembers([])});return()=>{live=false}},[modalServerId,dataVersion]);
  function openServerDialog(id:string,kind:string){setModal(kind);setModalMembers([]);setModalServerId(id)}
  function openCommunityMenu(e:React.MouseEvent,c:Community) {
    const markRead={label:tr('Mark server as read','Server als gelesen markieren'),icon:<CheckCheck size={15}/>,run:()=>markServersRead([c.id])};
    if(c.systemTeam){e.preventDefault();e.stopPropagation();setContext({x:e.clientX,y:e.clientY,actions:[markRead,{label:mutedServers.has(c.id)?tr('Unmute Server','Server-Stummschaltung aufheben'):tr('Mute Server','Server stummschalten'),icon:<BellOff size={15}/>,run:()=>toggleServerMute(c.id)},{label:tr('Copy Server ID','Server-ID kopieren'),icon:<Copy size={15}/>,run:()=>void copyToClipboard(c.id)}]});return;}

                  e.preventDefault();
                  e.stopPropagation();
                  setContext({
                    x: e.clientX,
                    y: e.clientY,
                    actions: [
                      markRead,
                      {label:tr('Move up','Nach oben verschieben'),icon:<ChevronDown size={15} style={{transform:'rotate(180deg)'}}/>,run:()=>window.dispatchEvent(new CustomEvent('malvo-server-move',{detail:{id:c.id,delta:-1}}))},
                      {label:tr('Move down','Nach unten verschieben'),icon:<ChevronDown size={15}/>,run:()=>window.dispatchEvent(new CustomEvent('malvo-server-move',{detail:{id:c.id,delta:1}}))},
                      {
                        label: mutedServers.has(c.id) ? tr('Unmute Server', 'Server-Stummschaltung aufheben') : tr('Mute Server', 'Server stummschalten'),
                        icon: mutedServers.has(c.id) ? <BellIcon size={15} /> : <BellOff size={15} />,
                        run: () => toggleServerMute(c.id)
                      },
                      {
                        label: tr('Invite Friends', 'Freunde einladen'),
                        icon: <Users size={15} />,
                        run: () => openServerDialog(c.id,'invite-friends')
                      },
                      {
                        label: tr('Invite People', 'Leute einladen'),
                        icon: <UserPlus size={15} />,
                        run: () => openServerDialog(c.id,'invite')
                      },
                      ...(canManageCommunity(c) ? [{
                        label: tr('Server Settings', 'Servereinstellungen'),
                        icon: <Settings size={15} />,
                        run: () => openServerDialog(c.id,'community-settings')
                      }] : []),
                      {
                        label: tr('Copy Server ID', 'Server-ID kopieren'),
                        divider: true,
                        icon: <Copy size={15} />,
                        run: () =>
                          action(async () => {
                            await copyToClipboard(c.id);
                            setNotice(tr('Server ID copied.', 'Server-ID kopiert.'));
                          })
                      },
                      ...(c.id !== 'malvo-official' || c.role !== 'owner'
                        ? [
                            {
                              label:
                                c.role === 'owner'
                                  ? tr('Delete Server', 'Server löschen')
                                  : tr('Leave Server', 'Server verlassen'),
                              divider: true,
                              danger: true,
                              icon: <Trash2 size={15} />,
                              run: () => openServerDialog(c.id,c.role === 'owner' ? 'community-delete' : 'community-leave')
                            }
                          ]
                        : [])
                    ]
                  });
                }

  const [modalClosing, setModalClosing] = useState(false);
  const [savedAccounts, setSavedAccounts] = useState<SavedAccount[]>([]);
  const [accountsLoading,setAccountsLoading]=useState(false),[accountsError,setAccountsError]=useState(''),accountFetch=useRef(false);
  async function loadSavedAccounts(){if(accountFetch.current)return;accountFetch.current=true;setAccountsLoading(true);setAccountsError('');try{setSavedAccounts(await api('/auth/accounts'))}catch(e){setAccountsError((e as Error).message)}finally{accountFetch.current=false;setAccountsLoading(false)}}
  function openAccountSwitcher(){setModal('account-switch');void loadSavedAccounts();}
  useEffect(()=>{const channel=typeof BroadcastChannel!=='undefined'?new BroadcastChannel('malvo-account-change'):null;const listener=(event:MessageEvent)=>{if(event.data==='begin'){setAccountSwitching(true);socket?.disconnect();for(const task of messageRequests.current.values())task.controller.abort();messageCache.current.clear();setMessages([])}else if(event.data==='done')location.reload();else if(event.data==='cancel'){setAccountSwitching(false);socket?.connect()}};channel?.addEventListener('message',listener);return()=>channel?.close()},[]);
  async function accountRequest(path:string,method:'POST',body:Record<string,string>){const channel=typeof BroadcastChannel!=='undefined'?new BroadcastChannel('malvo-account-change'):null;setAccountSwitching(true);socket?.disconnect();for(const task of messageRequests.current.values())task.controller.abort();messageCache.current.clear();setMessages([]);channel?.postMessage('begin');try{const result=await api(path,method,body);channel?.postMessage('done');return result}catch(error){setAccountSwitching(false);socket?.connect();channel?.postMessage('cancel');setError((error as Error).message);throw error}finally{channel?.close()}}

  const [profileMenu,setProfileMenu,profileClosing]=useAnimatedToggle();
  const profilePopoverRef=useRef<HTMLElement>(null),profileTriggerRef=useRef<HTMLButtonElement>(null);
  // Close the own-profile popover on any click outside it (channel, chat, server rail, ...) without swallowing that click.
  useEffect(()=>{if(!profileMenu||profileClosing)return;const dismiss=(e:PointerEvent)=>{const t=e.target as Element|null;if(!t||profilePopoverRef.current?.contains(t)||profileTriggerRef.current?.contains(t)||t.closest?.('.profile-status-portal'))return;setProfileMenu(false);};const esc=(e:KeyboardEvent)=>{if(e.key==='Escape')setProfileMenu(false);};document.addEventListener('pointerdown',dismiss,true);document.addEventListener('keydown',esc);return()=>{document.removeEventListener('pointerdown',dismiss,true);document.removeEventListener('keydown',esc);};},[profileMenu,profileClosing]);
  const [person, setPerson] = useState<Person | null>(null);
  useEffect(()=>{if(!person||!['profile','member-profile'].includes(modal||'')||isSystemAccount(person))return;let live=true;const id=person.id;void api('/users/id/'+encodeURIComponent(id)).then(fresh=>{if(live)setPerson(previous=>previous?.id===id?{...previous,...fresh}:previous)}).catch(error=>{if(live)setError(error.message)});return()=>{live=false}},[person?.id,modal]);
  const ping = usePing();
  const [call, setCall] = useState<{ id: string; name: string } | null>(null);
  const discoveryReturn=useRef<{room:string|null;community:string|null}|null>(null);
  function openDiscovery(){discoveryReturn.current={room:roomId,community:activeCommunity};if(teamOpen)closeTeam();home();setTab('servers');setModal(null);setSidebar(false)}
  function closeDiscovery(){const previous=discoveryReturn.current;if(previous?.room)selectRoom(previous.room,previous.community);else{home();setTab('online')}}
  const [teamOpen,setTeamOpen]=useState(()=>new URLSearchParams(location.search).get('view')==='team'),[teamTab,setTeamTab]=useState(()=>new URLSearchParams(location.search).get('teamTab')||'overview'),[teamServer,setTeamServer]=useState<string|undefined>();
  const teamWasMinimized=useRef(false),teamFocus=useRef<HTMLElement|null>(null);
  function openTeam(next='overview',serverId?:string){if(!me?.teamAccess)return;if(!teamOpen){teamWasMinimized.current=callMinimized;teamFocus.current=document.activeElement as HTMLElement;const url=new URL(location.href);url.searchParams.set('view','team');url.searchParams.set('teamTab',next);history.pushState({malvoTeam:true,returnUrl:location.href},'',url)}setTeamTab(next);setTeamServer(serverId);setTeamOpen(true);if(call)setCallMinimized(true);setModal(null);setProfileMenu(false)}
  function closeTeam(restoreHistory=true){setTeamOpen(false);setCallMinimized(teamWasMinimized.current);teamFocus.current?.focus();if(restoreHistory&&history.state?.malvoTeam){history.back()}else{const url=new URL(location.href);url.searchParams.delete('view');url.searchParams.delete('teamTab');history.replaceState(null,'',url)}void loadMe()}
  useEffect(()=>{const change=()=>{const show=new URLSearchParams(location.search).get('view')==='team';setTeamOpen(show);if(!show){setCallMinimized(teamWasMinimized.current);teamFocus.current?.focus()}};window.addEventListener('popstate',change);return()=>window.removeEventListener('popstate',change)},[]);
  useEffect(()=>{if(me&&!me.teamAccess&&teamOpen){setTeamOpen(false);const url=new URL(location.href);url.searchParams.delete('view');url.searchParams.delete('teamTab');history.replaceState(null,'',url)}},[me?.teamAccess,teamOpen]);

  // Remember the active call in this tab so a reload (update, crash, F5) can bring you back into it.
  const hadCall = useRef(false);
  useEffect(() => {
    if (call) { hadCall.current = true; rememberCall(call); const t = window.setInterval(() => rememberCall(call), 15000); const save = () => rememberCall(call); window.addEventListener('pagehide', save); return () => { clearInterval(t); window.removeEventListener('pagehide', save); }; }
    if (hadCall.current) rememberCall(null);
  }, [call?.id]);
  // The floating stream preview comes back when you open the call again or join another one.
  useEffect(()=>{if(!call||roomId===call.id)setPipClosed(false);},[roomId,call?.id]);
  const miniFloating=useFloatingPosition('malvo-mini-call-position',360,260,callMinimized||!!call&&roomId!==call.id);
  useEffect(()=>setCallMinimized(false),[call?.id]);
  const [incoming, setIncoming] = useState<{ roomId: string; from: Person; startedAt?:number; group?: { id: string; name: string } } | null>(null);
  const [incomingSoundBlocked,setIncomingSoundBlocked]=useState(false);
  const [callDismissals]=useState(()=>{try{return createCallDismissals(sessionStorage)}catch{return createCallDismissals(undefined)}});
  const [ringState, setRingState] = useState<Record<string, string[]>>({});
  const {typing,receiveTyping}=useTypingUsers(roomId,me?.id);
  const [showMembers, setShowMembers] = useState(true);
  // Muted servers (per device): no unread counter, sound or notification for plain messages; @mentions still come through.
  const [mutedServers, setMutedServers] = useState<Set<string>>(() => { try { return new Set(JSON.parse(localStorage.getItem('malvo-muted-servers') || '[]')); } catch { return new Set(); } });
  const mutedServersRef = useRef(mutedServers);
  mutedServersRef.current = mutedServers;
  // Settings changed on another device while this one is open: take them over without a reload.
  function applyLiveSettings() {
    setPinnedGroups(readPinnedGroups());
    applyAppearanceSettings();setShowDiscovery(localStorage.getItem('malvo-show-discovery')!=='0');
    try { setMutedServers(new Set(JSON.parse(localStorage.getItem('malvo-muted-servers') || '[]'))); } catch {}
    try{setMutedChannels(new Set(JSON.parse(localStorage.getItem('malvo-muted-channels')||'[]')))}catch{}
  }
  useEffect(()=>{window.addEventListener('malvo-settings-updated',applyLiveSettings);return()=>window.removeEventListener('malvo-settings-updated',applyLiveSettings)},[]);
  function toggleServerMute(id: string) {
    setMutedServers(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else {
        next.add(id);
        const ids = new Set((dataRef.current.communities.find(x => x.id === id)?.channels || []).map((ch: any) => ch.id));
        setUnreadCounts(counts => Object.fromEntries(Object.entries(counts).filter(([k]) => !ids.has(k))));
      }
      try { localStorage.setItem('malvo-muted-servers', JSON.stringify([...next])); } catch {}
      return next;
    });
  }
  // Like server mute, channel mute silences plain messages; mentions remain visible.
  const [mutedChannels, setMutedChannels] = useState<Set<string>>(() => {
    try { const saved = JSON.parse(localStorage.getItem('malvo-muted-channels') || '[]');
      return new Set(Array.isArray(saved) ? saved.filter((id: unknown): id is string => typeof id === 'string') : []);
    } catch { return new Set(); }
  });
  const mutedChannelsRef = useRef(mutedChannels);
  mutedChannelsRef.current = mutedChannels;
  function toggleChannelMute(id: string) {
    const next = new Set(mutedChannelsRef.current);
    if (next.has(id)) next.delete(id);
    else {
      next.add(id);
      setUnreadCounts(counts => { const remaining = {...counts}; delete remaining[id]; return remaining; });
    }
    mutedChannelsRef.current = next;
    setMutedChannels(next);
    try { localStorage.setItem('malvo-muted-channels', JSON.stringify([...next])); }
    catch { setNotice(tr('Channel mute could only be saved for this session.', 'Die Kanal-Stummschaltung konnte nur für diese Sitzung gespeichert werden.')); }
  }
  const [showDmProfile, setShowDmProfileRaw] = useState(() => { try { return localStorage.getItem('malvo-dm-profile')===null?window.matchMedia('(min-width: 1101px)').matches:localStorage.getItem('malvo-dm-profile')!=='0'; } catch { return true; } });
  const setShowDmProfile = (v: boolean) => { setShowDmProfileRaw(v); try { localStorage.setItem('malvo-dm-profile', v ? '1' : '0'); } catch {} };
  const [sidebar, setSidebar] = useState(false);
  // Phones start in the navigation (MALVO Chat, servers on the side, profile at the bottom) like Discord,
  // unless a link opened a specific channel.
  const phoneStartShown = useRef(false);
  useEffect(() => { if (!phone || phoneStartShown.current) return; phoneStartShown.current = true; if (!new URLSearchParams(location.search).get('channel')) setSidebar(true); }, [phone]);
  const [unread, setUnread] = useState<Set<string>>(new Set());
  const [busy, setBusy] = useState(false);
  const [managedFriend, setManagedFriend] = useState<Friend | null>(null);
  const [channelToDelete, setChannelToDelete] = useState<Channel | null>(null);
  const [context, setContext] = useState<{
    x: number;
    y: number;
    actions: MenuAction[];
    quickReactions?: { emoji: string; run: () => void }[];
  } | null>(null);
  const [emoji,setEmoji,emojiClosing]=useAnimatedValue<string>();
  

  // Track Shift key for instant quick-delete on hover
  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === 'Shift') setShiftHeld(true);
    };
    const up = (e: KeyboardEvent) => {
      if (e.key === 'Shift') setShiftHeld(false);
    };
    const blur = () => setShiftHeld(false);
    window.addEventListener('keydown', down);
    window.addEventListener('keyup', up);
    window.addEventListener('blur', blur);
    return () => {
      window.removeEventListener('keydown', down);
      window.removeEventListener('keyup', up);
      window.removeEventListener('blur', blur);
    };
  }, []);

  const incomingTone=useRef<{id:string;tone:CallTone}|null>(null);
  useEffect(()=>{
    if(!incoming)return;
    const previous=document.title;document.title=shownName(incoming.from)+tr(' is calling · MALVO',' ruft an · MALVO');
    const timeout=setTimeout(()=>setIncoming(current=>current?.roomId===incoming.roomId?null:current),Math.max(0,35000-(Date.now()-(incoming.startedAt||Date.now()))));
    let notification:Notification|undefined;
    if(me?.status!=='dnd'&&(document.hidden||!document.hasFocus())&&localStorage.getItem('malvo-notif-desktop')!=='0'){
      const title=tr('Incoming call','Eingehender Anruf'),body=incoming.group?shownName(incoming.from)+' · '+incoming.group.name:shownName(incoming.from);
      if((window as any).malvoDesktop?.isDesktop)(window as any).malvoDesktop.notify(title,body);
      else if('Notification' in window&&Notification.permission==='granted')try{notification=new Notification(title,{body,icon:'/icon.png',tag:'call-'+incoming.roomId,requireInteraction:true,silent:true});notification.onclick=()=>{window.focus();selectRoom(incoming.roomId,null);notification?.close()}}catch{}
    }
    return()=>{document.title=previous;clearTimeout(timeout);notification?.close()};
  },[incoming?.roomId,me?.status]);
  // Incoming call ringtone (respects DND status)
  useEffect(() => {
    stopRingtone();
    setIncomingSoundBlocked(false);
    if(!incoming)incomingTone.current=null;
    if(incoming&&incomingTone.current?.id!==incoming.roomId)incomingTone.current={id:incoming.roomId,tone:chooseCallTone()};
    if (!incoming || call || me?.status === 'dnd' || localStorage.getItem('malvo-notif-sound') === '0') return;
    let cancelled = false;
    try {
      ringAudio ??= new AudioContext();
    } catch {}
    const ctx: AudioContext | null = ringAudio;
    if (!ctx) return;
    const sync=()=>setIncomingSoundBlocked(ctx.state!=='running');sync();ctx.addEventListener('statechange',sync);
    const ring = () => {
      if (cancelled || !ctx || ctx.state !== 'running') return;
      stopRingtone();
      stopIncomingEcho = scheduleRingPhrase(ctx, activeRingNodes,incomingTone.current?.tone||'standard');
    };
    ctx
      .resume()
      .then(() => {
        if (!cancelled) ring();
      })
      .catch(() => {});
    const unlock=()=>{void ctx.resume().then(()=>{if(!cancelled)ring()}).catch(()=>{})};
    window.addEventListener('pointerdown',unlock);window.addEventListener('keydown',unlock);
    const t = setInterval(ring, 3200);
    return () => {
      cancelled = true;
      clearInterval(t);
      ctx.removeEventListener('statechange',sync);window.removeEventListener('pointerdown',unlock);window.removeEventListener('keydown',unlock);
      stopRingtone();
    };
  }, [incoming?.roomId, call?.id, me?.status]);

  useEffect(()=>{const open=()=>{if(me?.teamAccess)openTeam()};window.addEventListener('malvo-open-admin',open);return()=>window.removeEventListener('malvo-open-admin',open)},[me?.teamAccess,teamOpen]);
  const modalTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  function setModal(next: string | null) {
    if(next&&!['channel','kick'].includes(next))setModalServerId(null);
    if (next === 'community-settings' && !(canManageServer||community?.capabilities?.manageRoles||community?.capabilities?.manageChannels||community?.capabilities?.manageEmotes)) return;
    if (modalTimer.current) clearTimeout(modalTimer.current);
    setProfileMenu(false);
    setPlusMenu(false);
    setInviteCopied(false);
    setEditingInvite(false);
    setProfileDmDraft('');
    // A new dialog never shows an error left over from an earlier, unrelated action.
    if (next !== modal) setError('');
    if (next === null && modal) {
      setModalClosing(true);
      modalTimer.current = setTimeout(() => {
        setModalRaw(null);
        setModalClosing(false);
      }, 180);
    } else {
      setModalClosing(false);
      setModalRaw(next);
    }
  }
  useEffect(
    () => () => {
      if (modalTimer.current) clearTimeout(modalTimer.current);
    },
    []
  );

  useEffect(() => {
    if (!modal) return;
    const before = document.activeElement as HTMLElement;
    const frame = requestAnimationFrame(() =>
      document.querySelector<HTMLElement>('[role="dialog"] button')?.focus()
    );
    const key = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        setModal(null);
      }
    };
    document.addEventListener('keydown', key);
    return () => {
      cancelAnimationFrame(frame);
      document.removeEventListener('keydown', key);
      if (before?.isConnected) before.focus();
    };
  }, [modal]);

  const messageList = useChatScroll(roomId,loadedMessageRoom,messages,me?.id,api);
  const fileInput = useRef<HTMLInputElement>(null);
  const mediaInput = useRef<HTMLInputElement>(null);
  const activeRef = useRef(roomId);
  activeRef.current = roomId;
  const callRef = useRef(call);
  callRef.current = call;
  const incomingRef = useRef(incoming);
  incomingRef.current = incoming;
  const meRef = useRef(me);
  meRef.current = me;
  const dataRef = useRef(data);
  dataRef.current = data;
  // Back in the window: the open channel counts as read again.
  useEffect(() => {
    const read = () => { const rid = activeRef.current; if (rid && !document.hidden) setUnreadCounts(prev => { if (!prev[rid]) return prev; const next = { ...prev }; delete next[rid]; return next; }); };
    window.addEventListener('focus', read); document.addEventListener('visibilitychange', read);
    return () => { window.removeEventListener('focus', read); document.removeEventListener('visibilitychange', read); };
  }, []);

  const community = data.communities.find(c => c.id === activeCommunity);
  resolveChannelLink = id => {
    const owner = data.communities.find(c => c.channels.some(ch => ch.id === id));
    const ch = owner?.channels.find(x => x.id === id);
    return ch && owner ? { name: ch.name, kind: ch.kind, open: () => (ch.kind === 'voice' ? void startCall(ch.id, ch.name) : selectRoom(ch.id, owner.id)) } : null;
  };
  useEffect(() => {
    const id = new URLSearchParams(location.search).get('channel');
    if (!id || !data.communities.length) return;
    const owner = data.communities.find(c => c.channels.some(ch => ch.id === id));
    const ch = owner?.channels.find(x => x.id === id);
    if (ch && owner && ch.kind !== 'voice') selectRoom(ch.id, owner.id);
    history.replaceState({}, '', '/');
  }, [data.communities.length]);
  // Bot slash commands available in the open server; reloaded when a bot updates them.
  useEffect(() => {
    if (!activeCommunity) { setCommands([]); return; }
    api('/communities/' + activeCommunity + '/commands').then(setCommands).catch(() => setCommands([]));
  }, [activeCommunity, commandsVersion]);
  const channel = community?.channels.find(c => c.id === roomId);
  const cooldown=useChatCooldown(roomId,channel?.slowmodeUntil||0);
  const dm = data.conversations.find(c => c.id === roomId);
  useEffect(() => { setOfflineLimit(150); }, [activeCommunity]);
  // Phones: member list / profile are drawers (closed by default); swipes open and close them like Discord.
  const phonePanelOpen = community ? showMembers : !!dm && showDmProfile;
  useEffect(()=>{if(modal!=='community-settings')setSettingsFocus(null)},[modal]);
  useEffect(()=>{
    const back=(event:Event)=>{const more=document.querySelector<HTMLDetailsElement>('.mobile-chat-more[open]');if(context){event.preventDefault();setContext(null)}else if(emoji){event.preventDefault();setEmoji(null)}else if(plusMenu){event.preventDefault();setPlusMenu(false)}else if(more){event.preventDefault();more.open=false}else if(modal){event.preventDefault();setModal(null)}else if(sidebar){event.preventDefault();setSidebar(false)}else if(phonePanelOpen){event.preventDefault();setShowMembers(false);setShowDmProfileRaw(false)}else if(teamOpen){event.preventDefault();closeTeam()}};
    window.addEventListener('malvo-android-back',back);return()=>window.removeEventListener('malvo-android-back',back);
  },[modal,sidebar,phonePanelOpen,teamOpen,context,emoji,plusMenu]);
  useEffect(()=>{
    if(!phone||!sidebar)return;const previous=document.activeElement as HTMLElement|null;
    const frame=requestAnimationFrame(()=>document.querySelector<HTMLButtonElement>('.mobile-navigation-close')?.focus({preventScroll:true}));
    return()=>{cancelAnimationFrame(frame);if(previous?.isConnected)previous.focus({preventScroll:true})};
  },[phone,sidebar]);
  useEffect(() => { if (phone) { setSidebar(false); setShowMembers(false); setShowDmProfileRaw(false); } }, [phone]);
  useEffect(() => { if (isPhone()) { setShowMembers(false); setShowDmProfileRaw(false); } }, [roomId]);
  useMobileGestures({ enabled: !!me && !modal && !teamOpen, sidebar, setSidebar, panel: phonePanelOpen, canOpenPanel: !!roomId && (!!community || !!dm && !dm.official),
    openPanel: () => { setSidebar(false); if (community) setShowMembers(true); else setShowDmProfileRaw(true); },
    closePanel: () => { setShowMembers(false); setShowDmProfileRaw(false); } });
  // Every DM and group gets end-to-end encryption by itself as soon as all members have a key.
  const dmUnread=useDmUnread(me?.id,dm?.official?undefined:dm?.id,loadedMessageRoom,messages,api);
  const requests = data.friends.filter(f => f.state === 'pending' && f.recipientId === me?.id);
  const isServerOwner = !!(
    community &&
    (community.role === 'owner')
  );
  const canManageServer = !!(community && !community.systemTeam && (isServerOwner || community.role === 'moderator' || community.canManage));
  // Server settings are only for people who may change something; plain members do not see them at all.
  const canManageCommunity = (c: Community | null | undefined) => !!c && !c.systemTeam && (c.role === 'owner' || c.role === 'moderator' || !!c.canManage || !!c.capabilities?.manageEmotes || c.channels.some((ch:any)=>ch.capabilities?.manage_webhooks));
  const isChannelReadOnly = !!(
    community &&
    channel &&
    (channel.permissions?.sendMessages === false ||
      channel.readOnly === 1 ||
      ['regeln', 'rules', 'ankündigungen', 'announcements', 'willkommen', 'welcome'].includes(
        channel.name.toLowerCase()
      ))
  );
  const customEmotes=useCustomEmotes(api,community?.id||null,me?.id);
  const canWriteInChannel =
    !dm?.contactBlocked && !dm?.official && (channel?.capabilities ? !!channel.capabilities.send_messages : (!isChannelReadOnly || isServerOwner || community?.role === 'moderator' || !!community?.canPostReadOnly));

  resolveUserName=id=>[me,...members,...(dm?.group?.members||[]),...data.friends.map(f=>f.person),...data.conversations.map(c=>c.person),...rawMessages.flatMap(m=>m.mentionUsers||[])].map(p=>p?.id===id?shownName(p):'').find(Boolean)||tr('Unavailable account','Nicht verfügbares Konto');
  resolveRoleName=id=>data.communities.flatMap(c=>c.roles||[]).find((r:any)=>r.id===id)?.name||'Rolle';
  async function loadMe() {
    let d = await api('/me');
    // A password or 2FA change swaps this tab's session cookie; a request that left with the old cookie
    // comes back signed out. Ask once more before treating that as a sign-out.
    if (!d.user && meRef.current) { await new Promise(r => setTimeout(r, 1200)); d = await api('/me'); }
    currentAccount=d.user?.id||null;e2ee.setAccount(d.user?.id||null);if(d.user)e2ee.configure(api,d.user.id);
    if(d.user?.verified)await startSettingsSync(api,d.user.id).then(()=>{applyAppearanceSettings();window.dispatchEvent(new CustomEvent('malvo-lang-change',{detail:localStorage.getItem('malvo-lang')||'en'}))}).catch(()=>{});
    setRestriction(d.restriction||null);
    setWarnings(d.warnings||[]);
    setMe(d.restriction?null:d.user);setMonitoringUser(d.restriction?null:d.user||null);if(d.user&&!d.restriction)sendClientSignals(d.user.id,body=>api('/client-signals','POST',body));
    setFeatures(d.features);captchaSiteKey=d.features?.captcha||"";
    return d.user;
  }
  // An already expired session (401) counts as logged out.
  async function logout() {
    try { await api('/auth/logout', 'POST'); } catch (e) { if ((e as any)?.status !== 401) throw e; }
    setMe(null);
    setData(empty);
  }
  async function refresh() {
    const next = await api('/bootstrap'); setActivities(next.activities,next.musicActivities);
    bootLoaded.current = true;
    const accessible=new Set<string>([...next.communities.flatMap((c:Community)=>c.channels.map(ch=>ch.id)),...next.conversations.map((c:DM)=>c.id)]);for(const id of messageCache.current.keys())if(!accessible.has(id))messageCache.current.delete(id);for(const id of memberCache.current.keys())if(!next.communities.some((c:Community)=>c.id===id))memberCache.current.delete(id);
    setData({...empty,...next,online:next.online||[]});dmUnread.hydrate(next.conversations);
    setUnread(previous=>{const unread=new Set(previous);for(const conversation of next.conversations)if(conversation.official){if(conversation.unread&&conversation.id!==activeRef.current)unread.add(conversation.id);else unread.delete(conversation.id);}return unread;});
    setDataVersion(v => v + 1);
    return next;
  }
  const messageRequests=useRef(new Map<string,{controller:AbortController;promise:Promise<void>}>()),roomGeneration=useRef(0);
  // Fast channel switching: remember the last messages of every opened chat and preload a chat as soon as the
  // pointer is over it (or the finger touches it), so a click shows messages instantly while fresh ones load.
  useEffect(()=>{if(!roomId||loadedMessageRoom!==roomId)return;const rows=rawMessages.filter(m=>!m.pending&&!m.ephemeral&&!String(m.id).startsWith('ephemeral-'));const cache=messageCache.current;cache.delete(roomId);cache.set(roomId,rows.slice(-120));while(cache.size>40)cache.delete(cache.keys().next().value!);},[rawMessages,roomId,loadedMessageRoom]);
  const prefetchAt=useRef(new Map<string,number>());
  function prefetchRoom(rid:string){
    if(!rid||rid===activeRef.current||messageCache.current.has(rid)&&Date.now()-(prefetchAt.current.get(rid)||0)<30000)return;
    if(Date.now()-(prefetchAt.current.get(rid)||0)<8000)return;prefetchAt.current.set(rid,Date.now());
    const account=meRef.current?.id;
    api('/rooms/'+rid+'/messages').then((r:any)=>{const rows=Array.isArray(r)?r:r?.messages;if(!Array.isArray(rows)||meRef.current?.id!==account||activeRef.current===rid)return;const cache=messageCache.current;cache.delete(rid);cache.set(rid,rows);while(cache.size>40)cache.delete(cache.keys().next().value!);}).catch(()=>{});
  }
  async function loadMessages(rid:string,around?:string):Promise<void>{
    if(around)linkedHistory.current={roomId:rid,messageId:around};
    else if(linkedHistory.current?.roomId===rid)around=linkedHistory.current.messageId;
    const key=rid+(around||''),running=messageRequests.current.get(key);if(running)return running.promise;
    const controller=new AbortController(),generation=roomGeneration.current,account=meRef.current?.id;
    const promise=(async()=>{try{const result=await api('/rooms/'+rid+'/messages'+(around?'?around='+encodeURIComponent(around):localStorage.getItem('malvo-chat-open-mode')==='last-position'&&loadedMessageRoom!==rid?'?resume=1':''),'GET',undefined,0,controller.signal);if(controller.signal.aborted||generation!==roomGeneration.current||activeRef.current!==rid||meRef.current?.id!==account)return;
      const rows=Array.isArray(result)?result:result?.messages;if(!Array.isArray(rows))throw Error(apiStatusError(200));
      if(result.position){try{const key='malvo-chat-positions:'+account,positions=JSON.parse(localStorage.getItem(key)||'{}');positions[rid]={id:'message-'+result.position.messageId,offset:result.position.offset,updated:Date.now()};localStorage.setItem(key,JSON.stringify(positions))}catch{}}
      setMessages(previous=>{const kept=previous.filter(m=>(m.pending||m.ephemeral)&&(m.channelId||m.conversationId)===rid);return rows.reduce((current:Message[],row:Message)=>mergeSentMessage(current,row),kept).sort((a:Message,b:Message)=>a.created-b.created)});setLoadedMessageRoom(rid);
    }catch(error){if(controller.signal.aborted||generation!==roomGeneration.current||activeRef.current!==rid)return;if([403,404].includes((error as any).status)){messageCache.current.delete(rid);setMessages([]);setLoadedMessageRoom(null)}throw error}finally{if(messageRequests.current.get(key)?.controller===controller)messageRequests.current.delete(key)}})();messageRequests.current.set(key,{controller,promise});return promise;
  }
  useEffect(()=>()=>{for(const task of messageRequests.current.values())task.controller.abort();messageRequests.current.clear();messageCache.current.clear();memberCache.current.clear()},[me?.id]);

  useEffect(() => {
    applyAppearanceSettings();
    loadMe()
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  // Settings from the database: if this device was missing some, apply them with one reload.
  useEffect(() => {
    if (!me?.verified) return;
    // On load: if the account has settings this browser did not have yet, reload once so every screen uses them
    // (at most once per 20 s, so a broken value can never cause a reload loop).
    startSettingsSync(api).then(changed => {
      if (!changed) return;
      let last = 0;
      try { last = Number(sessionStorage.getItem('malvo-settings-reload') || 0); } catch {}
      if (Date.now() - last < 20000) { applyLiveSettings(); return; }
      try { sessionStorage.setItem('malvo-settings-reload', String(Date.now())); } catch {}
      location.reload();
    }).catch(() => {});
  }, [me?.id, me?.verified]);

  useEffect(() => {
    if (!me?.verified) return;
    refresh().catch(e => setError(e.message));
    const nativeMobile=/MALVOAndroidNotifications\/1/.test(navigator.userAgent);
    const shouldConnect=()=>!nativeMobile||!document.hidden||!!callRef.current;
    socket = io({ auth: { device: deviceId() }, transports: ['polling','websocket'],tryAllTransports:true,reconnection:true,reconnectionDelay:1000,reconnectionDelayMax:10000,autoConnect:shouldConnect() });
    // Background Android delivery has its own read-only connection, without online presence.
    const syncVisibility=()=>{if(shouldConnect())socket?.connect();else socket?.disconnect();};
    if(nativeMobile)document.addEventListener('visibilitychange',syncVisibility);
    const rosterGate=createRosterGate<Record<string,Person[]>>(setVoiceRosters);voiceRosterGate.current=rosterGate;
    socket.on('voice:roster',rosterGate.publish);
    const recoverRoster=()=>{void rosterGate.recover(()=>api('/voice/rosters')).catch(()=>{});};recoverRoster();
    // Many events in a row (e.g. someone creating lots of channels) cause one reload, not hundreds.
    let refreshTimer: ReturnType<typeof setTimeout> | null = null, refreshMe = false, lastRefresh = 0;
    const scheduleRefresh = (withMe: boolean) => {
      refreshMe = refreshMe || withMe;
      if (refreshTimer) return;
      const wait = Math.max(300, 2000 - (Date.now() - lastRefresh));
      refreshTimer = setTimeout(() => {
        refreshTimer = null; lastRefresh = Date.now();
        const me = refreshMe; refreshMe = false;
        refresh().catch(() => {});
        if (me) loadMe().catch(() => {});
      }, wait);
    };
    socket.on('refresh', () => scheduleRefresh(true));
    socket.on('service:state', () => window.dispatchEvent(new Event('malvo-service-state')));
    socket.on('emotes:changed',payload=>window.dispatchEvent(new CustomEvent('malvo-emotes-changed',{detail:payload})));
    socket.on('channel-access-revoked', ({roomId: revoked}: {roomId: string}) => {messageCache.current.delete(revoked);setCall(current=>current?.id===revoked?null:current);for(const [key,task] of messageRequests.current)if(key.startsWith(revoked)){task.controller.abort();messageRequests.current.delete(key)}if(activeRef.current===revoked){activeRef.current=null;roomGeneration.current++;setMessages([]);setLoadedMessageRoom(null);setRoomId(null);setNotice(translate('Your channel access has changed.','Dein Zugriff auf diesen Kanal hat sich geändert.'));}});
    socket.on('official:read', ({roomId: read}: {roomId:string})=>setUnread(previous=>{const next=new Set(previous);next.delete(read);return next;}));
    socket.on('official:broadcast', ({conversation,message}: {conversation: DM;message: Message}) => {
      setData(previous=>({...previous,conversations:[conversation,...previous.conversations.filter(c=>c.id!==conversation.id)].sort((a,b)=>(b.lastActivity||0)-(a.lastActivity||0))}));
      messageCache.current.delete(conversation.id);
      if(activeRef.current===conversation.id){setMessages(previous=>mergeSentMessage(previous,message));void loadMessages(conversation.id).catch(error=>setError(error.message));}
      else setUnread(previous=>new Set([...previous,conversation.id]));
      if(meRef.current?.status!=='dnd'){playMessageSound(meRef.current?.status);showNotification(translate('Official MALVO announcement','Offizielle MALVO-Ankündigung'),message.body,conversation.id,null);}
    });
    // A single server changed (channels, roles, name...): replace just that server, no full reload.
    socket.on('community:updated', (c: Community) => {
      setData(old => {
        const i = old.communities.findIndex(x => x.id === c.id);
        const communities = old.communities.slice();
        if (i >= 0) communities[i] = { ...communities[i], ...c }; else communities.push(c);
        return { ...old, communities };
      });
      if (c.id === loadedMemberCommunity.current) setDataVersion(v => v + 1);
    });
    socket.on('community:removed', (d: { id: string }) => setData(old => ({ ...old, communities: old.communities.filter(x => x.id !== d.id) })));
    socket.on('presence',()=>window.dispatchEvent(new Event('malvo-team-refresh')));
    socket.on('discovery:changed',()=>window.dispatchEvent(new Event('malvo-discovery-refresh')));
    socket.on('settings:changed', () => { startSettingsSync(api).then(changed => { if (changed) applyLiveSettings(); }).catch(() => {}); });
    socket.on('dm:activity', (conversation: DM) => {
      setData(previous => {
        const existing = previous.conversations.find(c => c.id === conversation.id);
        const updated = {...conversation, lastActivity: Math.max(existing?.lastActivity || 0, conversation.lastActivity || 0)};
        return {...previous, conversations: [updated, ...previous.conversations.filter(c => c.id !== conversation.id)]
          .sort((a, b) => (b.lastActivity || 0) - (a.lastActivity || 0))};
      });
    });
    socket.on('friendship', (notice: FriendshipNotice) => {
      setFriendNotice(notice);
      if (meRef.current?.status === 'dnd') return;
      const title = notice.kind === 'request' ? translate('New friend request', 'Neue Freundschaftsanfrage') : translate('Friend request accepted', 'Freundschaftsanfrage angenommen');
      const body = shownName(notice.person) + (notice.kind === 'request'
        ? translate(' would like to add you as a friend.', ' möchte dich als Freund hinzufügen.')
        : translate(' accepted your friend request. You can chat now!', ' hat deine Freundschaftsanfrage angenommen. Ihr könnt jetzt chatten!'));
      playMessageSound(meRef.current?.status);
      showNotification(title, body, 'friendship:' + notice.person.id, null);
    });
    socket.on('moderation:changed',d=>{if(d.restriction)window.dispatchEvent(new CustomEvent('malvo:restricted',{detail:d.restriction}));else loadMe().catch(()=>{});});
    // Someone came online/offline: only fetch the small online list. Full reload only if a profile changed.
    let presenceTimer: ReturnType<typeof setTimeout> | null = null;
    // Desktop app reports the running game / current song; only sent while sharing is enabled.
    let lastActivity: any = null;
    const sendActivity = () => { socket?.emit('activity:share', shareActivity()); if (lastActivity || !shareActivity()) socket?.emit('activity:set', shareActivity() ? lastActivity : null); };
    const offActivity = (window as any).malvoDesktop?.onActivity?.((a: any) => { lastActivity = a; sendActivity(); });
    socket.on('connect', sendActivity);
    window.addEventListener('malvo-activity-share', sendActivity);
    // The server closes our sockets after security changes (password, 2FA) and hands this tab a fresh
    // session cookie; socket.io never reconnects on its own after a server-side close, so do it here.
    // Bounded, so an account that is really signed out does not loop.
    socket.on('disconnect', () => { if (!liveDownSince) liveDownSince = Date.now(); });
    socket.on('connect', () => { if (liveDownSince) { lastLiveOutage = { from: liveDownSince, to: Date.now() }; liveDownSince = 0; } });
    let serverCloses: number[] = [];
    socket.on('disconnect', (reason: string) => {
      if (reason !== 'io server disconnect') return;
      const t = Date.now(); serverCloses = serverCloses.filter(x => t - x < 60000).concat(t);
      if (serverCloses.length > 3) { setError(tr('Live connection closed. Reload the page to reconnect.', 'Live-Verbindung getrennt. Lade die Seite neu, um sie wiederherzustellen.')); return; }
      setTimeout(() => { if (socket && !socket.connected) socket.connect(); }, 600 * serverCloses.length);
    });
    void offActivity;
    // Soundboard: play sounds others trigger in the same call; send our own picks.
    socket.on('soundboard:play', (d: { soundId: string; volume?: number; userId?: string }) => { if (d.userId) { const playbackId = 'event-' + Math.random().toString(36).slice(2); const send = (active: boolean) => window.dispatchEvent(new CustomEvent('malvo-soundboard-activity', { detail: { userId: d.userId, playbackId, active } })); send(true); setTimeout(() => send(false), 2500); } /* ring shows for everyone in the call, even when this device plays nothing (deafened, muted, autoplay) */ if (localStorage.getItem('malvo-deafened') === '1' || !soundboardAllowed(d.userId)) return; void playSound(d.soundId, d.volume ?? 1, d.userId); });
    const sendSound = (e: Event) => socket?.emit('soundboard:play', { soundId: (e as CustomEvent).detail });
    window.addEventListener('malvo-soundboard-play', sendSound);
    // Everyone gets presence events at the same moment. Hidden tabs catch up when they are looked at again, and visible
    // tabs spread their reloads over a few seconds, so one profile change does not make every client hit the server at once.
    let hiddenProfile = false, hiddenPresence = false;
    const loadPresence = () => {
      if (presenceTimer) return;
      presenceTimer = setTimeout(() => {
        presenceTimer = null;
        api('/presence').then((r: { online: string[]; activities?: any;musicActivities?:any }) => { if (!Array.isArray(r?.online)) return; setActivities(r.activities,r.musicActivities); setData(old => ({ ...old, online: r.online })); }).catch(() => {});
      }, 1500 + Math.random() * 1500);
    };
    const profileJitter = () => setTimeout(() => scheduleRefresh(false), Math.random() * 4000);
    socket.on('presence', (d?: { profile?: boolean }) => {
      if (document.hidden) { if (d?.profile) hiddenProfile = true; else hiddenPresence = true; return; }
      if (d?.profile) { profileJitter(); return; }
      loadPresence();
    });
    const catchUpPresence = () => {
      if (document.hidden) return;
      if (hiddenProfile) { hiddenProfile = false; hiddenPresence = false; scheduleRefresh(false); }
      else if (hiddenPresence) { hiddenPresence = false; loadPresence(); }
    };
    document.addEventListener('visibilitychange', catchUpPresence);
    socket.on('message', (m: Message) => {
      const mentionsMe = new RegExp('(^|\\s)@(' + (meRef.current?.username || '\\u0000') + '|everyone|here)\\b', 'i').test(m.body || '');
      if (m.authorId !== meRef.current?.id && !m.conversationId && !mentionsMe && !mutedChannelsRef.current.has(m.channelId || '')) {
        playMessageSound(meRef.current?.status);

      }
      if ((m.channelId || m.conversationId) === activeRef.current) {
        setMessages(prev => mergeSentMessage(prev, m));
      }
    });
    socket.on('commands-changed', () => setCommandsVersion(v => v + 1));
    socket.on('bot-modal', (d: BotModalData) => setBotModal(d));
    // Bot replies only the caller can see; they live until the chat is reloaded.
    socket.on('ephemeral-update', (d: { roomId: string; id: string; body: string; embeds: Embed[]; components: MessagePart[] }) => {
      setMessages(prev => prev.map(x => x.id === 'ephemeral-' + d.id ? { ...x, body: d.body, embeds: d.embeds, components: d.components } : x));
    });
    socket.on('ephemeral', (d: { roomId: string; id: string; author: Person; body: string; embeds: Embed[]; components?: MessagePart[]; interaction: Message['interaction']; created: number }) => {
      if (d.roomId !== activeRef.current) return;
      setMessages(prev => [...prev, { id: 'ephemeral-' + d.id, body: d.body, author: d.author, authorId: d.author.id, created: d.created, edited: null, channelId: d.roomId, conversationId: null, file: null, reactions: [], embeds: d.embeds, components: d.components, interaction: d.interaction, ephemeral: true }]);
    });
    socket.on('messages-changed', () => {
      if (activeRef.current) loadMessages(activeRef.current).catch(() => {});
    });
    socket.on('typing',(d:any)=>{if(!contactBlocked(d.user?.id||d.userId))receiveTyping(d)});
    socket.on('contacts:changed',()=>{void refresh().catch(e=>setError(e.message));});
    socket.on('dm:read',(d:{roomId:string;unreadCount:number})=>{dmUnread.update(d.roomId,d.unreadCount);if(!d.unreadCount)setUnread(previous=>{const next=new Set(previous);next.delete(d.roomId);return next;})});
    socket.on('e2ee:key-changed', () => e2ee.forgetChat());
    socket.on('unread', (d: { roomId: string; unreadCount?:number;notify?:boolean;author?: Person; body?: string }) => {
      if(d.author?.id===meRef.current?.id||contactBlocked(d.author?.id))return;
      dmUnread.update(d.roomId,d.roomId===activeRef.current&&!document.hidden&&document.hasFocus()?0:d.unreadCount);
      if (d.notify!==false&&!contactMuted(d.author?.id)&&meRef.current?.status !== 'dnd') void e2ee.textFor(api, d.body || '', d.roomId, d.author?.id || '', meRef.current?.id || '').then(body => showNotification(shownName(d.author) || 'MALVO Chat', body || tr('Attachment','Anhang'), d.roomId, null));
      if(d.notify!==false&&!contactMuted(d.author?.id))playMessageSound(meRef.current?.status);
      if (d.roomId !== activeRef.current||document.hidden||!document.hasFocus()){setUnread(old => new Set([...old, d.roomId]));if(d.author)setUnreadPeers(old=>({...old,[d.roomId]:d.author!}));}
    });
    socket.on('mention', (d: { roomId: string; communityId: string; author?: Person; body?: string }) => {
      if(d.author?.id===meRef.current?.id||contactBlocked(d.author?.id)||contactMuted(d.author?.id))return;
      if(!messageNotificationAllowed(currentNotificationPreferences(),meRef.current?.id||'',{...d,mentioned:true}))return;
      playMentionSound(meRef.current?.status);
      if (meRef.current?.status !== 'dnd') showNotification(shownName(d.author) || 'MALVO Chat', d.body || '', d.roomId, d.communityId);
    });
    // Every new message in a server channel: red counter on channel/server/folder, plus sound and notification when not reading it.
    socket.on('channel-message', (d: { roomId: string; communityId: string; author?: Person; body?: string; attachment?: boolean; mentioned?: boolean }) => {
      if(d.author?.id===meRef.current?.id||contactBlocked(d.author?.id)||contactMuted(d.author?.id))return;
      const reading = d.roomId === activeRef.current && !document.hidden && document.hasFocus();
      if (reading) return;
      if(folderMuted(currentNotificationPreferences(),meRef.current?.id||'',d.communityId))return;
      if ((mutedServersRef.current.has(d.communityId) || mutedChannelsRef.current.has(d.roomId)) && !d.mentioned) return;
      setUnreadCounts(prev => ({ ...prev, [d.roomId]: (prev[d.roomId] || 0) + 1 }));
      if (d.mentioned) setMentionCounts(prev => ({ ...prev, [d.roomId]: (prev[d.roomId] || 0) + 1 }));
      // Like Discord: plain server messages only raise the unread counter; DMs and @mentions notify.
      if (d.mentioned || meRef.current?.status === 'dnd') return;
      let allServerMessages = false;
      try { allServerMessages = localStorage.getItem('malvo-notif-all-server') === '1'; } catch {}
      if (!allServerMessages) {const channelName=dataRef.current.communities.find(c=>c.id===d.communityId)?.channels.find(c=>c.id===d.roomId)?.name;pushMessageNotice({title:(shownName(d.author)||'MALVO')+(channelName?' · #'+channelName:''),body:d.body||(d.attachment?tr('Attachment','Anhang'):''),roomId:d.roomId,communityId:d.communityId});return;}
      playMessageSound(meRef.current?.status);
      const channelName = dataRef.current.communities.find(c => c.id === d.communityId)?.channels.find(c => c.id === d.roomId)?.name;
      showNotification((shownName(d.author) || 'MALVO') + (channelName ? ' · #' + channelName : ''), d.body || (d.attachment ? tr('Attachment', 'Anhang') : ''), d.roomId, d.communityId);
    });
    socket.on('raid:shield', (d: { name: string; count: number }) => setNotice(tr(`Raid shield active for ${d.name}: ${d.count} new accounts joined within 10 minutes. New accounts are paused for 30 minutes.`, `Raid-Schutz für ${d.name} aktiv: ${d.count} neue Konten in 10 Minuten. Neue Konten können 30 Minuten lang nicht beitreten.`)));
    socket.on('call:ring-state', (d: { roomId: string; ringing: string[] }) => setRingState(prev => ({ ...prev, [d.roomId]: d.ringing })));
    let callSignalRevision=0;
    const receiveCall=(d:{roomId:string;from:Person;startedAt?:number;group?:{id:string;name:string}})=>{callSignalRevision++;if(contactBlocked(d.from.id))return;if(!callDismissals.has(d.roomId)&&callRef.current?.id!==d.roomId)setIncoming(current=>current?.roomId===d.roomId?current:d)};
    socket.on('call',receiveCall);
    const recoverIncoming=()=>{const revision=callSignalRevision;void api('/calls/incoming').then(calls=>{if(revision!==callSignalRevision||!socket?.connected)return;const d=calls.find((c:any)=>c.roomId!==callRef.current?.id&&!callDismissals.has(c.roomId));if(d)receiveCall(d);else setIncoming(null)}).catch(()=>{})};

    socket.on('call:answered', (d: { roomId: string; by: Person }) => {
      callSignalRevision++;
      stopRingtone();
      if (incomingRef.current?.roomId === d.roomId) setIncoming(null);
      if (callRef.current?.id === d.roomId) {
        window.dispatchEvent(new CustomEvent('malvo:call-answered', {detail: d.roomId}));
        setNotice((shownName(d.by) || 'User') + tr(' joined the call.', ' ist dem Anruf beigetreten.'));
      }
    });
    socket.on('call:rejected', (d: { roomId: string; by: Person }) => {
      callSignalRevision++;
      stopRingtone();
      if (incomingRef.current?.roomId === d.roomId) setIncoming(null);
      if (callRef.current?.id === d.roomId) {
        playCallLeaveSound(meRef.current?.status);
        setCall(null);
        setModal(null);
        setNotice((shownName(d.by) || 'User') + tr(' declined the call.', ' hat den Anruf abgelehnt.'));
      }
    });
    socket.on('call:cancelled', (d: { roomId: string; by?: Person }) => {
      callSignalRevision++;
      stopRingtone();
      if (incomingRef.current?.roomId === d.roomId) {
        setIncoming(null);
        setNotice(tr('Missed call from ', 'Verpasster Anruf von ') + (shownName(d.by) || 'User') + '.');
      }
    });
    socket.on('poll:update',(detail:any)=>window.dispatchEvent(new CustomEvent('malvo:poll-update',{detail})));
    socket.on('voice:disconnect',()=>{document.querySelector<HTMLButtonElement>('[data-hotkey="disconnect"]')?.click();});
    socket.on('voice:move',(detail:any)=>{stopRingtone();setCall(current=>current?{id:detail.roomId,name:detail.name}:current);setActiveCommunity(detail.communityId);setRoomId(detail.roomId);setNotice(tr('A moderator moved you to ','Ein Moderator hat dich verschoben nach ')+detail.name);});
    socket.on('call:timeout', (d: { roomId: string; caller?: Person; target?: Person }) => {
      callSignalRevision++;
      stopRingtone();
      if (incomingRef.current?.roomId === d.roomId) {
        setIncoming(null);
        setNotice(tr('Missed call from ', 'Verpasster Anruf von ') + (shownName(d.caller) || 'User') + '.');
      }
      if (callRef.current?.id === d.roomId) {
        playCallLeaveSound(meRef.current?.status);
        setCall(null);
        setModal(null);
        setNotice((shownName(d.target) || 'User') + tr(' did not answer.', ' hat nicht abgenommen.'));
      }
    });
    socket.on('call:ended', (d: { roomId: string }) => {
      callSignalRevision++;
      stopRingtone();
      if (incomingRef.current?.roomId === d.roomId) setIncoming(null);
      if (callRef.current?.id === d.roomId) {
        playCallLeaveSound(meRef.current?.status);
        setCall(null);
        setModal(null);
        setNotice(tr('Call ended.', 'Anruf beendet.'));
      }
    });
    let retryTimer:ReturnType<typeof setTimeout>|undefined;
    socket.on('connect_error', (err:Error) => {
      if(/Bitte anmelden|E-Mail bestätigen/.test(err.message)){setError(tr('Please sign in again to restore the live connection.','Bitte melde dich erneut an, um die Live-Verbindung wiederherzustellen.'));return;}
      setError(tr('Live connection interrupted. Reconnecting…', 'Live-Verbindung unterbrochen. Verbindung wird wiederhergestellt…'));
      if(retryTimer)clearTimeout(retryTimer);
      retryTimer=setTimeout(()=>{if(socket&&!socket.connected&&shouldConnect())socket.connect();},4000);
    });
    socket.on('connect', () => {
      setError('');void checkForUpdate();
      // Catch updates that arrived between the initial HTTP load and the socket handshake/reconnect.
      scheduleRefresh(false);
      recoverRoster();recoverIncoming();
      if (activeRef.current) {
        socket?.emit('join', activeRef.current);
        loadMessages(activeRef.current).catch(() => {});
      }
    });
    return () => {
      stopRingtone();
      if(retryTimer)clearTimeout(retryTimer);
      if(refreshTimer)clearTimeout(refreshTimer);
      if(nativeMobile)document.removeEventListener('visibilitychange',syncVisibility);
      document.removeEventListener('visibilitychange',catchUpPresence);
      rosterGate.close();if(voiceRosterGate.current===rosterGate)voiceRosterGate.current=null;
      socket?.disconnect();
      socket = undefined;
    };
  }, [me?.id, me?.verified]);

  useEffect(()=>{if(!call&&document.hidden&&/MALVOAndroidNotifications\/1/.test(navigator.userAgent))socket?.disconnect();},[call]);

  useEffect(()=>{const markVisible=()=>{if(document.hidden||!document.hasFocus()||!activeRef.current)return;const rid=activeRef.current;setUnread(prev=>{if(!prev.has(rid))return prev;const next=new Set(prev);next.delete(rid);return next;});};window.addEventListener('focus',markVisible);document.addEventListener('visibilitychange',markVisible);return()=>{window.removeEventListener('focus',markVisible);document.removeEventListener('visibilitychange',markVisible);};},[]);
  useEffect(() => {
    setLoadedMessageRoom(null);
    setError('');
    if (!roomId) {
      setMessages([]);
      return;
    }
    setMessages(messageCache.current.get(roomId) || []);
    setQuery('');
    setReplyTo(null);setPollRoom(null);setFileOver(false);fileDragDepth.current=0;
    setPlusMenu(false);
    loadMessages(roomId,pendingJump.current?.roomId===roomId?pendingJump.current.messageId:undefined).catch(e => {if(activeRef.current===roomId)setError(e.message)});
    socket?.emit('join', roomId);
    setUnread(old => {
      const n = new Set(old);
      n.delete(roomId);
      return n;
    });
  }, [roomId]);

  useEffect(() => {
    let current=true;
    if(loadedMemberCommunity.current!==activeCommunity){setMembers(activeCommunity?memberCache.current.get(activeCommunity)||[]:[]);loadedMemberCommunity.current=activeCommunity;}
    if(activeCommunity){const cid=activeCommunity;void api('/communities/'+cid+'/members').then(rows=>{memberCache.current.set(cid,rows);if(current)setMembers(rows);}).catch(e=>{if(current)setError(e.message);});}
    else setMembers([]);
    return()=>{current=false;};
  }, [activeCommunity, dataVersion]);

  useEffect(() => {
    if (activeCommunity && data.communities.length >= 0) {
      const current = data.communities.find(c => c.id === activeCommunity);
      if (!current) {
        home();
        if (call && !data.communities.some(c => c.channels.some(ch => ch.id === call.id)) && !data.conversations.some(c => c.id === call.id)) setCall(null);
        setModal(null);
      } else if (roomId && !current.channels.some(c => c.id === roomId)) {
        setRoomId(current.channels.find(c => c.kind === 'text')?.id || null);
        if (call?.id === roomId) setCall(null);
      }
    }
  }, [data.communities]);


  useEffect(()=>{if(friendNotice?.kind==='request'&&data.friends.some(friend=>friend.person.id===friendNotice.person.id&&friend.state==='accepted'))setFriendNotice(null)},[data.friends,friendNotice]);

  useEffect(() => {
    if (!notice) return;
    const t = setTimeout(() => setNotice(''), 4500);
    return () => clearTimeout(t);
  }, [notice]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('verify');
    const inv = params.get('invite');
    if (token && me)
      api('/auth/verify', 'POST', { token })
        .then(() => {
          setNotice(tr('Email verified.', 'E-Mail bestätigt.'));
          history.replaceState({}, '', '/');
          loadMe();
        })
        .catch(e => setError(e.message));
    if (me && inv) {
      if (inv.toLowerCase() === 'malvo') {
        history.replaceState({}, '', '/');
        joinByCode('malvo');
      } else {
        setModal('community');
      }
    }
  }, [me?.id]);

  async function action(fn: () => Promise<void>) {
    setError('');
    setBusy(true);
    try {
      await fn();
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  function triggerSpinningReload() {
    setReloading(true);
    setTimeout(() => {
      location.reload();
    }, 3000);
  }

  // Last opened channel per server (per device), so coming back from DMs lands where you were.
  function lastChannelOf(c: Community): string {
    let saved = '';
    try { saved = JSON.parse(localStorage.getItem('malvo-last-channel') || '{}')[c.id] || ''; } catch {}
    const ch = c.channels?.find((x: any) => x.id === saved && x.kind === 'text');
    return ch ? ch.id : c.channels?.find((x: any) => x.kind === 'text')?.id || '';
  }
  function selectRoom(rid: string, cid: string | null) {
    if(linkedHistory.current?.roomId!==rid){linkedHistory.current=null;setLinkedMessage(null);}
    if(activeRef.current!==rid){roomGeneration.current++;for(const task of messageRequests.current.values())task.controller.abort();messageRequests.current.clear();activeRef.current=rid;const cached=messageCache.current.get(rid);setMessages(cached||[]);setLoadedMessageRoom(cached?rid:null);}

    if (cid && rid && dataRef.current.communities.find(x => x.id === cid)?.channels?.some((x: any) => x.id === rid && x.kind === 'text')) {
      try { const map = JSON.parse(localStorage.getItem('malvo-last-channel') || '{}'); map[cid] = rid; localStorage.setItem('malvo-last-channel', JSON.stringify(map)); } catch {}
    }
    setUnreadCounts(prev => {
      if (!prev[rid]) return prev;
      const next = { ...prev };
      delete next[rid];
      return next;
    });
    setActiveCommunity(cid);
    setRoomId(rid);
    setSidebar(false);
    setPerson(null);
    setPlusMenu(false);
  }

  // Address bar shows where you are (/channels/<server>/<channel> or /channels/@me/<dm>), so reload and back/forward return there.
  const bootLoaded = useRef(false);
  const urlRestored = useRef(false);
  function pathFor(cid: string | null, rid: string | null) {
    return cid ? '/channels/' + cid + (rid ? '/' + rid : '') : rid ? '/channels/@me/' + rid : '/channels/@me';
  }
  function applyPath(path: string): boolean {
    const target=parseChatLocation(path,location.search,location.hash);
    if(!target)return false;
    const c=target.legacy?dataRef.current.communities.find(c=>c.channels.some(ch=>ch.id===target.roomId)):dataRef.current.communities.find(c=>c.id===target.communityId);
    const cid=c?.id||null,rid=c?(target.roomId&&c.channels.some(ch=>ch.id===target.roomId&&ch.kind==='text')?target.roomId:target.messageId?null:lastChannelOf(c)):!target.communityId&&dataRef.current.conversations.some(d=>d.id===target.roomId)?target.roomId:null;
    if(!rid){home();if(target.messageId)setError(tr('This message link is unavailable or you do not have access to this chat.','Dieser Nachrichtenlink ist nicht verfügbar oder du hast keinen Zugriff auf diesen Chat.'));return true;}
    const sameRoom=activeRef.current===rid;
    if(target.messageId){pendingJump.current={roomId:rid,messageId:target.messageId};linkedHistory.current=pendingJump.current;setLinkedMessage(pendingJump.current);}
    selectRoom(rid,cid);
    if(target.legacy)history.replaceState({},'',chatMessagePath(cid,rid,target.messageId||undefined));
    if(target.messageId&&sameRoom)void loadMessages(rid,target.messageId).catch(e=>setError(e.message));
    return true;
  }
  useEffect(() => {
    if (urlRestored.current || !bootLoaded.current) return;
    urlRestored.current = true;
    applyPath(location.pathname);
  }, [data]);
  useEffect(() => {
    if (!urlRestored.current || location.search || location.pathname.startsWith('/developer')) return;
    const linked=parseChatLocation(location.pathname);if(linked?.messageId&&linked.roomId===roomId&&linked.communityId===activeCommunity)return;
    const next = pathFor(activeCommunity, roomId);
    if (location.pathname !== next) history.pushState({}, '', next);
  }, [activeCommunity, roomId]);
  useEffect(() => {
    const onPop = () => { if (!applyPath(location.pathname)) home(); };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  useEffect(()=>()=>{linkedReveal.current?.();linkedReveal.current=null;},[roomId,me?.id]);
  useEffect(()=>{
    if(!linkedMessage||linkedMessage.roomId!==roomId||loadedMessageRoom!==roomId||!rawMessages.some(m=>m.id===linkedMessage.messageId))return;
    const {messageId}=linkedMessage,list=messageList.current;
    const scale=list?list.getBoundingClientRect().height/(list.offsetHeight||1):1;
    historyControl.current?.restore(messageId,Math.max(12,((list?.getBoundingClientRect().height||300)/scale-80)/2));
    pendingJump.current=null;setLinkedMessage(null);
    let frame=0,attempts=0;let timer:ReturnType<typeof setTimeout>|undefined;
    const highlight=()=>{const el=document.getElementById('message-'+messageId);if(el){el.classList.add('search-highlight');timer=setTimeout(()=>el.classList.remove('search-highlight'),3000)}else if(++attempts<30)frame=requestAnimationFrame(highlight)};
    linkedReveal.current?.();frame=requestAnimationFrame(highlight);linkedReveal.current=()=>{cancelAnimationFrame(frame);if(timer)clearTimeout(timer);document.getElementById('message-'+messageId)?.classList.remove('search-highlight')};
  },[linkedMessage,roomId,loadedMessageRoom,rawMessages]);

  function home() {
    linkedHistory.current=null;setLinkedMessage(null);
    setActiveCommunity(null);
    setRoomId(null);
    setQuery('');
    setSidebar(false);
    setPlusMenu(false);
  }

  async function openDM(p: Person, initialText?: string) {
    await action(async () => {
      const d = !initialText&&data.conversations.find(c=>!c.group&&c.person.id===p.id)||await api('/dm', 'POST', { userId: p.id });
      if (initialText && initialText.trim()) {
        await api('/rooms/' + d.id + '/messages', 'POST', { body: await seal(d.id, initialText.trim()) });
      }
      await refresh();
      selectRoom(d.id, null);
      setModal(null);
    });
  }

  // Clicking an @mention opens that user's profile (looked up among members, friends, DMs and message authors).
  async function openMentionProfile(username: string) {
    const name = username.toLowerCase();
    const candidates: (Person | undefined)[] = [me, ...members, ...data.friends.map(f => f.person), ...data.conversations.map(c => c.person), ...messages.map(m => (m as any).author)];
    let found = candidates.find(p => p?.id===username||p?.username?.toLowerCase() === name);
    if(!found&&/^[0-9a-f-]{36}$/i.test(username)){try{found=await api('/users/id/'+username)}catch{setError(tr('This account is no longer available.','Dieses Konto ist nicht mehr verfügbar.'));return}}
    if (!found) { setError(tr('User @' + username + ' not found.', 'Nutzer @' + username + ' nicht gefunden.')); return; }
    setPerson(found);
    setModal('profile');
  }
  async function openJoined(id: string) {
    const b = await refresh();
    const c = b.communities.find((x: Community) => x.id === id);
    if(!c)throw new Error(tr('This server is no longer available.','Dieser Server ist nicht mehr verfügbar.'));
    if (c) {
      const preferred =
        c.channels.find((ch: Channel) => ch.kind === 'text' && ['allgemein', 'general'].includes(ch.name.toLowerCase())) ||
        c.channels.find((ch: Channel) => ch.kind === 'text');
      selectRoom(preferred?.id || '', c.id);
    }
  }
  async function joinByCode(code: string,serverId?:string) {
    const existing=serverId?dataRef.current.communities.find(c=>c.id===serverId):null;
    if(existing){selectRoom(lastChannelOf(existing),existing.id);return;}
    await action(async () => {
      const d = await api('/communities/join', 'POST', { invite: code });
      await openJoined(d.id);
    });
  }

  // Encrypts the text when the chat has end-to-end encryption turned on.
  async function seal(rid: string, text: string) {
    if (!text) return text;
    const conv = dataRef.current.conversations.find(c => c.id === rid);
    const on = !!conv && !conv.official && !(conv.person as any)?.bot && await e2ee.ensureChat(api, rid).catch(() => !!conv.e2ee);
    if (!on) { if (e2ee.isPacked(text)) throw new Error(tr('This chat is no longer encrypted. Please attach the file again.', 'Dieser Chat ist nicht mehr verschlüsselt. Bitte hänge die Datei erneut an.')); return text; }
    return e2ee.encrypt(api, rid, meRef.current!.id, text);
  }
  // In encrypted chats the file is encrypted on this device before it is uploaded.
  async function uploadAttachment(f: File): Promise<FileInfo> {
    const account=meRef.current?.id,rid = roomId, conv = rid ? dataRef.current.conversations.find(c => c.id === rid) : null;
    if (rid && conv && !conv.official && !(conv.person as any)?.bot && e2ee.ready() && await e2ee.ensureChat(api, rid).catch(() => false)) {
      const { blob, meta } = await e2ee.encryptFile(f);
      const info = await upload(blob);
      if(activeRef.current!==rid||meRef.current?.id!==account)throw Error(tr('The chat changed. Attach the file again in the intended chat.','Der Chat hat sich geändert. Hänge die Datei im gewünschten Chat erneut an.'));
      setAttachmentSource({id:info.id,file:f,room:rid,account:account!});
      return { ...info, name: meta.name, mime: meta.mime, size: meta.size, url: URL.createObjectURL(f), e2ee: { ...meta, id: info.id } };
    }
    const info=await upload(f);if(activeRef.current!==rid||meRef.current?.id!==account)throw Error(tr('The chat changed. Attach the file again in the intended chat.','Der Chat hat sich geändert. Hänge die Datei im gewünschten Chat erneut an.'));setAttachmentSource({id:info.id,file:f,room:rid,account:account!});return info;
  }
  // Posts a message; if the server says we are sending too fast, wait the requested time and send it then (like Discord).
  async function postMessage(rid: string, payload: Record<string, unknown>) {
    for (let attempt = 0; ; attempt++) {
      try {
        const result=await api('/rooms/' + rid + '/messages', 'POST', typeof payload.body==='string'&&payload.body?{...payload,body:await seal(rid,payload.body)}:payload);if(result.nextSendAt)cooldown.mark(rid,result.nextSendAt);return result;
      } catch (e: any) {
        if(e?.code==='SLOW_MODE'){cooldown.mark(rid,Date.now()+e.retryAfter);throw e;}
        if (e?.status !== 429 || !e.retryAfter || attempt >= 8) throw e;
        await new Promise(r => setTimeout(r, e.retryAfter + 50));
      }
    }
  }
  // Outgoing queue: messages appear grey right away and are sent one after another as fast as the server allows.
  const outbox = useRef<{ tempId: string; rid: string; payload: Record<string, unknown>; text: string; accountId:string }[]>([]);
  const outboxBusy = useRef(false);
  const unconfirmedSend = useRef<{ key: string; id: string } | null>(null);
  const plusClickAt = useRef(0);
  const [sendWarning, setSendWarning] = useState('');
  useEffect(() => { if (!sendWarning) return; const t = setTimeout(() => setSendWarning(''), 4000); return () => clearTimeout(t); }, [sendWarning]);
  async function drainOutbox() {
    if (outboxBusy.current) return;
    outboxBusy.current = true;
    try {
      while (outbox.current.length) {
        const item = outbox.current[0];
        try {
          // A send that timed out may still have been stored; retrying with the same clientMessageId lets
          // the server hand back that message instead of creating a second one.
          let m: Message;
          for (let attempt = 0; ; attempt++) {
            try { m = await postMessage(item.rid, item.payload); break; }
            catch (e: any) { if (attempt >= 2 || e?.status && e.status < 500 || meRef.current?.id !== item.accountId) throw e; await new Promise(r => setTimeout(r, 1500 * (attempt + 1))); }
          }
          sendHistory.current.record(item.accountId,item.rid,item.text);
          if (activeRef.current === item.rid) setMessages(prev => mergeSentMessage(prev, m, item.tempId));
        } catch (e) {
          setMessages(prev => prev.filter(x => x.id !== item.tempId));
          setDraftFor(item.accountId,item.rid,d => d || item.text);
          if (!(e as any)?.status) unconfirmedSend.current = { key: item.accountId + '|' + item.rid + '|' + item.text, id: String(item.payload.clientMessageId) };
          setSendWarning((e as Error).message);
        }
        outbox.current.shift();
      }
    } finally {
      outboxBusy.current = false;
    }
  }
  // Scope confirmed sends to their account/chat. Failed requests never become duplicates.
  const sendHistory=useRef(createSendHistory());
  const spamConfirmed = useRef<string|null>(null);
  const [spamConfirm, setSpamConfirm] = useState<'duplicate' | 'fast' | null>(null);
  async function send(e: React.FormEvent) {
    const draft=readRoomDraft(me?.id,roomId),sendAccount=me?.id,sendRoom=roomId,sendGeneration=roomGeneration.current;
    e.preventDefault();
    if (!canWriteInChannel || sending || cooldown.active || uploadBatch || draft.length>4000 || (!draft.trim() && !attachment) || !roomId) return;
    const slash = channel && !attachment ? parseSlash(draft, commands) : null;
    const confirmationKey=JSON.stringify([sendAccount,sendRoom,draft.trim()]);
    const warning=sendHistory.current.check(sendAccount||'',sendRoom!,draft.trim(),outbox.current,!!slash);
    if(warning&&spamConfirmed.current!==confirmationKey){setSpamConfirm(warning);return;}
    spamConfirmed.current=null;
    socket?.emit('typing',{roomId,typing:false});
    if(/^\/clear(?:\s+\d+)?\s*$/.test(draft.trim())){
      const count=Number(draft.trim().split(/\s+/)[1]||100);
      setSending(true);try{const result=await api('/rooms/'+roomId+'/clear','POST',{count});setRoomDraft(sendAccount,sendRoom,previous=>previous===draft?'':previous);if(activeRef.current!==sendRoom||sendGeneration!==roomGeneration.current)return;setNotice(tr(`${result.count} messages cleared.`,`${result.count} Nachrichten entfernt.`));await loadMessages(roomId);}catch(e){setError((e as Error).message);}finally{setSending(false);}return;
    }
    if (slash) {
      setSending(true);
      try {
        await api('/rooms/' + roomId + '/commands', 'POST', { appId: slash.command.application_id, name: slash.command.name, options: slash.options });
        sendHistory.current.record(sendAccount||'',sendRoom!,draft);
        setRoomDraft(sendAccount,sendRoom,previous=>previous===draft?'':previous);
      } catch (e) {
        if(activeRef.current===sendRoom&&sendGeneration===roomGeneration.current)setError((e as Error).message);
      } finally {
        setSending(false);
      }
      return;
    }
    if (outbox.current.filter(x => x.rid === roomId).length >= 4 || outbox.current.length >= 6) {
      setSendWarning(tr('You are sending messages too fast!', 'Du sendest Nachrichten zu schnell!'));
      return;
    }
    // Resending the same text after a send whose outcome is unknown reuses its id, so it cannot double up.
    const retryKey = me!.id + '|' + roomId + '|' + draft, reuse = unconfirmedSend.current?.key === retryKey ? unconfirmedSend.current.id : null;
    unconfirmedSend.current = null;
    const clientMessageId=reuse||crypto.randomUUID();
    const tempId = 'pending-' + Date.now() + '-' + Math.random().toString(36).slice(2);
    const pendingMessage: Message = {
      replyPing,
      id: tempId,clientMessageId, body: draft, author: me as Person, authorId: me!.id, created: Date.now(), edited: null,
      channelId: dm ? null : roomId, conversationId: dm ? roomId : null, file: attachment || null, reactions: [],
      replyTo: replyTo ? { id: replyTo.id, body: replyTo.body, author: replyTo.author } : null, pending: true
    };
    outbox.current.push({ tempId, rid: roomId, accountId:me!.id,text: draft, payload: { clientMessageId,body: attachment?.e2ee ? e2ee.pack(draft.trim(), [attachment.e2ee]) : draft, attachment: attachment?.id, replyToId: replyTo?.id,replyPing } });
    setMessages(old => [...old, pendingMessage]);
    for(const extra of extraAttachments){
      const extraId='pending-'+Date.now()+'-'+Math.random().toString(36).slice(2),extraClientId=crypto.randomUUID();
      outbox.current.push({tempId:extraId,rid:roomId,accountId:me!.id,text:'',payload:{clientMessageId:extraClientId,body:extra.e2ee?e2ee.pack('',[extra.e2ee]):'',attachment:extra.id}});
      setMessages(old=>[...old,{...pendingMessage,id:extraId,clientMessageId:extraClientId,body:'',file:extra,replyTo:null}]);
    }
    setExtraAttachments([]);
    setDraft('');
    setAttachment(null);
    setReplyTo(null);
    void drainOutbox();
  }

  async function sendDirectBody(bodyText: string) {
    if (!canWriteInChannel || sending || cooldown.active || !bodyText.trim() || !roomId) return;
    const targetRoom=roomId,targetAccount=me?.id,generation=roomGeneration.current;setSending(true);
    try {
      const m = await postMessage(roomId, {
        body: bodyText.trim(),
        replyToId: replyTo?.id,replyPing
      });
      if(activeRef.current!==targetRoom||meRef.current?.id!==targetAccount||generation!==roomGeneration.current)return;
      setMessages(old => (old.some(x => x.id === m.id) ? old : [...old, m]));
      setReplyTo(null);
    } catch (e) {
      if(activeRef.current===targetRoom&&generation===roomGeneration.current)setError((e as Error).message);
    } finally {
      setSending(false);
    }
  }

  // Uploads one to five files in order. Cancelling stops the running file and skips the rest.
  async function attachFiles(files: File[]) {
    if(uploadBatch||uploadProgress!==null){setError(tr('An upload is already running.','Ein Upload läuft bereits.'));return;}
    const present=(attachment?1:0)+extraAttachments.length;
    if(files.length+present>MAX_FILES_PER_SEND){setError(tr(`You can send up to ${MAX_FILES_PER_SEND} files at once.`,`Du kannst bis zu ${MAX_FILES_PER_SEND} Dateien auf einmal senden.`));return;}
    const controller=new AbortController();uploadAbort.current=controller;let hasMain=!!attachment;
    setError('');
    try{
      for(const [index,file] of files.entries()){
        if(controller.signal.aborted)break;
        setUploadBatch({index:index+1,total:files.length});
        const info=await uploadAttachment(file);
        if(hasMain)setExtraAttachments(old=>[...old,info]);else{setAttachment(info);hasMain=true;}
      }
    }catch(e){if((e as Error).name!=='AbortError')setError((e as Error).message);}
    finally{if(uploadAbort.current===controller)uploadAbort.current=null;setUploadBatch(null);setUploadProgress(null);}
  }
  async function upload(file: File): Promise<FileInfo> {
    const signal=uploadAbort.current?.signal,aborted=()=>new DOMException('Upload cancelled','AbortError');
    if (file.size > 5 * 1024 * 1024 * 1024) throw Error(tr('Max 5 GB per file.', 'Maximal 5 GB pro Datei.'));
    // Larger files go up in raw 6 MB pieces (below the proxy limit); each piece is retried, then the server stores the file.
    if (file.size > 384 * 1024) {
      setUploadProgress(1);
      try {
        const init = await api('/uploads/init', 'POST', { name: file.name || 'file', mime: file.type || 'application/octet-stream', size: file.size },0,signal);
        signal?.addEventListener('abort',()=>{void api('/uploads/'+init.id,'DELETE').catch(()=>{})},{once:true});
        const chunkSize: number = init.chunkSize || 6 * 1024 * 1024;
        let offset = 0;
        while (offset < file.size) {
          const piece = file.slice(offset, offset + chunkSize);
          let attempt = 0;
          for (;;) {
            try {
              const r = await fetch('/api/uploads/' + init.id + '/chunk?offset=' + offset, { method: 'POST', signal: signal?AbortSignal.any([signal,AbortSignal.timeout(120000)]):AbortSignal.timeout(120000), headers: { 'x-malvo': '1', 'Content-Type': 'application/octet-stream' }, body: piece });
              const d = await r.json().catch(() => ({}));
              if (!r.ok) throw Object.assign(Error(d.error || 'Upload failed'), { fatal: r.status >= 400 && r.status < 500 && r.status !== 429 });
              offset = d.received;
              break;
            } catch (err) {
              if(signal?.aborted)throw aborted();
              if ((err as any).fatal || ++attempt >= 5) throw err;
              await new Promise(res => setTimeout(res, 800 * attempt));
            }
          }
          setUploadProgress(Math.min(97, Math.max(1, Math.round((offset / file.size) * 97))));
        }
        await api('/uploads/complete', 'POST', { id: init.id },0,signal);
        const deadline=Date.now()+Math.min(30*60000,Math.max(3*60000,file.size/(512*1024)*1000));
        for (;;) {
          if(Date.now()>deadline)throw Error(tr('Storage processing timed out. Please retry the upload.','Das Speichern dauert zu lange. Bitte lade die Datei erneut hoch.'));
          const s = await api('/uploads/' + init.id + '/status','GET',undefined,0,signal);
          if (s.state === 'done') { setUploadProgress(null); return s.file; }
          setUploadProgress(99);
          await new Promise(res => setTimeout(res, 1200));
        }
      } catch (err) {
        setUploadProgress(null);
        throw err;
      }
    }

    return new Promise<FileInfo>((resolve, reject) => {
      if(signal?.aborted){reject(aborted());return;}
      const xhr = new XMLHttpRequest();
      signal?.addEventListener('abort',()=>xhr.abort(),{once:true});
      xhr.onabort=()=>{setUploadProgress(null);reject(aborted());};
      const form = new FormData();
      form.append('file', file);
      xhr.open('POST', '/api/uploads');
      xhr.timeout=120000;
      xhr.ontimeout=()=>{setUploadProgress(null);reject(Error(tr('Upload timed out. Please try again.','Zeitüberschreitung beim Upload. Bitte erneut versuchen.')));};
      xhr.setRequestHeader('x-malvo', '1');
      xhr.upload.onprogress = e => setUploadProgress(Math.round((e.loaded / e.total) * 100));
      xhr.onload = () => {
        setUploadProgress(null);
        try {
          const d = JSON.parse(xhr.responseText);
          xhr.status < 300 ? resolve(d) : reject(Error(d.error || 'Upload failed'));
        } catch {
          reject(Error(tr('Upload failed.', 'Upload fehlgeschlagen.')));
        }
      };
      xhr.onerror = () => {
        setUploadProgress(null);
        reject(Error(tr('Upload interrupted. Please try again.', 'Upload unterbrochen.')));
      };
      xhr.send(form);
    });
  }

  // Switching from one call to another needs a confirmation, so a misclick does not drop the current call.
  const [pendingCall, setPendingCall] = useState<{ rid: string; name: string } | null>(null);
  // After a reload: rejoin the call automatically when the reload was an update, otherwise offer it.
  const resumeChecked = useRef(false);
  useEffect(() => {
    if (resumeChecked.current || !me || data === empty) return;
    resumeChecked.current = true;
    const r = takeResume();
    if (!r || !data.conversations.some(c => c.id === r.id) && !data.communities.some(c => c.channels.some(ch => ch.id === r.id))) return;
    if (r.auto && Date.now() - r.at < 120000 && features.voice) { void startCall(r.id, r.name, true); setNotice(tr('MALVO was updated. You are back in ', 'MALVO wurde aktualisiert. Du bist wieder in ') + r.name + '.'); }
    else setRejoinOffer(r);
  }, [me?.id, data, features.voice]);
  // Like Discord: install a waiting update on its own when the tab is in the background and you are not in a call.
  useEffect(() => {
    if (!updateReady || call || sending || uploadProgress !== null || attachment || modal) return;
    let t = 0;
    const vis = () => { clearTimeout(t); if (document.hidden) t = window.setTimeout(() => { if (document.hidden) installUpdate(null); }, 60000); };
    vis(); document.addEventListener('visibilitychange', vis);
    return () => { clearTimeout(t); document.removeEventListener('visibilitychange', vis); };
  }, [updateReady, !!call, sending, uploadProgress !== null, !!attachment, !!modal]);
  async function startCall(rid: string, name: string, confirmed = false) {
    if(data.conversations.some(c=>c.id===rid&&c.contactBlocked)){setError(tr('You cannot call this contact right now.','Du kannst diesen Kontakt derzeit nicht anrufen.'));return;}
    if (call?.id === rid) {
      const group = data.communities.find(c => c.channels.some(ch => ch.id === rid));
      selectRoom(rid, group?.id || null);
      return;
    }
    if (call && !confirmed) { setPendingCall({ rid, name }); return; }
    const target = data.communities.flatMap(c => c.channels).find(ch => ch.id === rid) as any;
    if (target?.capabilities?.connect_voice === false) {
      setError(tr('Only selected roles can join this voice channel.', 'Diesem Sprachkanal können nur ausgewählte Rollen beitreten.'));
      return;
    }
    if (!features.voice) {
      setError(tr('Voice server is not connected yet.', 'Der Sprachserver ist noch nicht verbunden.'));
      return;
    }
    stopRingtone();
    setIncoming(null);
    setCall({ id: rid, name });
    const group=data.communities.find(c=>c.channels.some(ch=>ch.id===rid));
    selectRoom(rid,group?.id||null);
    setModal(null);
  }

  // Back to the voice channel / DM of the running call.
  function goToCall() {
    if (!call) return;
    setCallMinimized(false);
    const group = data.communities.find(c => c.channels.some(ch => ch.id === call.id));
    selectRoom(call.id, group?.id || null);
    if(isPhone()){setSidebar(false);setShowMembers(false);setShowDmProfileRaw(false);}
  }

  function openMemberContextMenu(e: React.MouseEvent, p: Person, anchor?: {x:number;y:number}) {
    e.preventDefault();
    e.stopPropagation();
    const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
    const x = anchor?.x ?? (e.type === 'contextmenu' ? e.clientX : Math.max(12, rect.left - 210));
    const y = anchor?.y ?? (e.type === 'contextmenu' ? e.clientY : rect.bottom + 4);
    const isTargetOwner =
      p.role === 'owner';
    const actions: MenuAction[] = [
      ...(p.id !== me?.id ? [{ label: tr('Message', 'Nachricht senden'), icon: <Mail size={15} />, run: () => openDM(p) }] : []),
      {
        label: tr('Open Profile', 'Profil öffnen'),
        icon: <User size={15} />,
        run: () => {
          setPerson(p);
          setModal('profile');
        }
      },
      ...(community && (isServerOwner||community.capabilities?.manageRoles)
        ? [
            {
              label: tr('Roles', 'Rollen'),
              divider: true,
              submenu: (community.roles || []).map((r: any) => ({
                label: r.name,
                checked: (p.customRoles || []).some((mr: any) => mr.id === r.id),
                icon: <i className="context-role-dot" style={{ background: roleBackground(r) }} />,
                run: () =>
                  action(async () => {
                    await api('/communities/' + community.id + '/members/' + p.id + '/roles', 'POST', { roleId: r.id, assigned: !(p.customRoles || []).some((mr: any) => mr.id === r.id) });
                    await refresh();
                    if (activeCommunity) await refreshMembers(activeCommunity).catch(() => {});
                    setNotice(tr('Role updated for ', 'Rolle aktualisiert für ') + shownName(p));
                  })
              }))
            },
            {
              label: tr('Manage Roles', 'Rollen verwalten'),
              icon: <Shield size={15} />,
              run: () => setModal('community-settings')
            }
          ]
        : []),
      ...(call && p.id !== me?.id && (voiceRosters[call.id] || []).some((u: any) => u.id === p.id)
        ? [{ label: tr('Mute for me', 'Für mich stummschalten'), icon: <VolumeX size={15} />, run: () => window.dispatchEvent(new CustomEvent('malvo-participant-volume', { detail: { id: p.id, value: 0 } })) }]
        : []),
      // Timeout straight from the menu (moderate_members): fixed durations, plus "remove" while active.
      ...((() => {
        if (!community || isTargetOwner || p.id === me?.id) return [];
        const caps: any = community.capabilities || {};
        if (!(community.role === 'owner' || caps.moderateMembers)) return [];
        const live = (members.find(m => m.id === p.id) as any) || p;
        const route = '/communities/' + community.id + '/members/' + p.id + '/timeout';
        const set = (sec: number) => action(async () => {
          await api(route, 'PATCH', { durationSeconds: sec, reason: '' });
          if (activeCommunity) await refreshMembers(activeCommunity).catch(() => {});
          setNotice(sec ? shownName(p) + tr(' is timed out.', ' ist jetzt im Timeout.') : tr('Timeout removed for ', 'Timeout aufgehoben für ') + shownName(p));
        });
        const active = (live.timeoutUntil || 0) > Date.now();
        const durations: [number, string][] = [[60, tr('60 seconds', '60 Sekunden')], [300, tr('5 minutes', '5 Minuten')], [600, tr('10 minutes', '10 Minuten')], [3600, tr('1 hour', '1 Stunde')], [86400, tr('1 day', '1 Tag')], [604800, tr('1 week', '1 Woche')]];
        return [
          { label: tr('Timeout', 'Timeout') + ' ' + shownName(p), divider: true, icon: <Clock size={15} />, submenu: durations.map(([sec, label]) => ({ label, run: () => set(sec) })) } as any,
          ...(active ? [{ label: tr('Remove timeout', 'Timeout aufheben'), icon: <Clock size={15} />, run: () => set(0) } as any] : [])
        ];
      })()),
      // Voice moderation (like other voice apps): only while the person is in a voice channel of this server.
      ...((() => {
        if (!community || isTargetOwner || p.id === me?.id) return [];
        const caps: any = community.capabilities || {}, owner = community.role === 'owner';
        const inVoice = (community.channels || []).some((ch: any) => ch.kind === 'voice' && (voiceRosters[ch.id] || []).some((u: any) => u.id === p.id));
        if (!inVoice) return [];
        const route = '/communities/' + community.id + '/members/' + p.id + '/voice';
        const live = members.find(m => m.id === p.id) as any || p;
        const items: MenuAction[] = [];
        if (owner || caps.muteMembers) items.push({ label: tr('Server mute', 'Server stummschalten'), divider: true, checked: !!live.serverMuted, icon: <MicOff size={15} />, run: () => action(async () => { await api(route, 'PATCH', { muted: !live.serverMuted }); if (activeCommunity) await refreshMembers(activeCommunity).catch(() => {}); }) } as any);
        if (owner || caps.deafenMembers) items.push({ label: tr('Server deafen', 'Kopfhörer stummschalten'), checked: !!live.serverDeafened, icon: <VolumeX size={15} />, run: () => action(async () => { await api(route, 'PATCH', { deafened: !live.serverDeafened }); if (activeCommunity) await refreshMembers(activeCommunity).catch(() => {}); }) } as any);
        if (owner || caps.moveMembers) {
          const here = (community.channels || []).find((ch: any) => ch.kind === 'voice' && (voiceRosters[ch.id] || []).some((u: any) => u.id === p.id));
          const others = (community.channels || []).filter((ch: any) => ch.kind === 'voice' && ch.id !== here?.id);
          if (others.length) items.push({ label: tr('Move to', 'Verschieben nach'), icon: <Volume2 size={15} />, submenu: others.map((ch: any) => ({ label: ch.name, icon: <Volume2 size={14} />, run: () => action(async () => { await api(route, 'PATCH', { destinationId: ch.id }); }) })) } as any);
          items.push({ label: tr('Disconnect', 'Verbindung trennen'), danger: true, icon: <PhoneOff size={15} />, run: () => action(async () => { await api(route, 'PATCH', { disconnect: true }); setNotice(shownName(p) + tr(' was disconnected.', ' wurde getrennt.')); }) } as any);
        }
        return items;
      })()),
      ...(canManageServer && community && !isTargetOwner && p.id !== me?.id
        ? [
            {
              label: tr('Kick Member', 'Vom Server kicken'),
              danger: true,
              icon: <UserX size={15} />,
              run: () => {
                setPerson(p);
                setModal('kick');
              }
            },
            {
              label: tr('Ban Member', 'Vom Server bannen'),
              danger: true,
              icon: <Ban size={15} />,
              run: () =>
                action(async () => {
                  await api('/communities/' + community.id + '/bans', 'POST', {
                    userId: p.id,
                    reason: 'Banned by server administration'
                  });
                  await refresh();
                  setNotice(shownName(p) + tr(' was banned.', ' wurde gebannt.'));
                })
            }
          ]
        : []),
      ...(p.id !== me?.id && p.id !== 'malvo-system'
        ? [
            {label:tr('Change personal name','Persönlichen Namen ändern'),icon:<Pencil size={15}/>,run:()=>{setNamingPerson(p);setContext(null)}},
            {label:contactMuted(p.id)?tr('Unmute notifications','Benachrichtigungen aktivieren'):tr('Mute notifications','Benachrichtigungen stummschalten'),icon:<BellOff size={15}/>,run:()=>void action(async()=>{await api('/contacts/'+p.id+'/preferences','PATCH',{notificationsMuted:!contactMuted(p.id)});await refresh()})},
            {label:tr('Report User','Person melden'),icon:<Flag size={15}/>,run:()=>setModal('report-user:'+p.id)},
            {
              label: contactBlocked(p.id)?tr('Unblock','Blockierung aufheben'):tr('Block User', 'Blockieren'),
              danger: true,
              divider: true,
              icon: <Ban size={15} />,
              run: () => {
                if(contactBlocked(p.id)){void action(async()=>{await api('/blocks/'+p.id,'DELETE');await refresh()});return;}
                setPerson(p);
                setModal('block-confirm');
              }
            }
          ]
        : []),
      {
        label: tr('Copy ID', 'ID kopieren'),
        divider: true,
        icon: <Copy size={15} />,
        run: () => {
          void copyToClipboard(p.id);
          setNotice(tr('ID copied.', 'ID kopiert.'));
        }
      }
    ];
    if(community&&p.id!==me?.id&&(community.role==='owner'||['moderateMembers','moveMembers','muteMembers','deafenMembers','manageChannels'].some(key=>(community.capabilities as any)?.[key]))){actions.splice(2,0,{label:tr('Moderation & channel access','Moderation & Kanalzugriff'),icon:<Shield size={15}/>,run:()=>{setManagedMember(p);setModal('member-tools');if(activeCommunity)void refreshMembers(activeCommunity)}});}
    setContext({ x, y, actions });
  }

  function openMessageContextMenu(e: React.MouseEvent, m: Message) {
    e.preventDefault();
    e.stopPropagation();
    const author = m.author || FALLBACK_PERSON;
    if(dm?.official){setContext({x:e.clientX,y:e.clientY,actions:[{label:tr('Copy text','Text kopieren'),icon:<Copy size={15}/>,run:()=>void copyToClipboard(m.body)},{label:tr('View reactions','Reaktionen ansehen'),icon:<Users size={15}/>,run:()=>setModal('reactions:'+m.id+':')},...(me?.canManageOfficial&&!m.officialPrivate?[{label:tr('Manage official post','Offiziellen Beitrag verwalten'),icon:<Pencil size={15}/>,run:()=>setModal('official-editor')}]:[])]});return;}
    setContext({
      x: e.clientX,
      y: e.clientY,
      quickReactions: ['👍', '❤️', '😂'].map(em => ({
        emoji: em,
        run: () =>
          action(async () => {
            await api('/messages/' + m.id + '/reactions', 'POST', { emoji: em });
          })
      })),
      actions: [
        {
          label: tr('Reply', 'Antworten'),
          icon: <CornerDownRight size={15} />,
          run: () => {
            setReplyTo({ id: m.id, author, body: m.body });
            (document.querySelector('.composer textarea') as HTMLElement)?.focus();
          }
        },
        {
          label: tr('Copy Text', 'Text kopieren'),
          divider: true,
          icon: <Copy size={15} />,
          run: () =>
            action(async () => {
              await copyToClipboard(m.body);
              setNotice(tr('Text copied.', 'Text kopiert.'));
            })
        },
        {
          label: tr('Bookmark', 'Speichern'),
          icon: <Bookmark size={15} />,
          run: () =>
            action(async () => {
              await api('/messages/' + m.id + '/save', 'POST');
              setNotice(tr('Saved messages updated.', 'Gespeicherte Nachrichten aktualisiert.'));
            })
        },
        {
          label: tr('Copy Message Link', 'Nachrichtenlink kopieren'),
          icon: <Globe size={15} />,
          run: () =>
            action(async () => {
              await copyToClipboard(location.origin + chatMessagePath(community?.id||null,m.channelId||m.conversationId||roomId!,m.id));
              setNotice(tr('Link copied.', 'Link kopiert.'));
            })
        },
        ...(m.reactions?.length ? [{ label: tr('View reactions', 'Reaktionen ansehen'), icon: <Users size={15} />, run: () => setModal('reactions:' + m.id) }] : []),
        ...(m.authorId === me?.id && !m.callEvent
          ? [
              {
                label: tr('Edit Message', 'Nachricht bearbeiten'),
                icon: <Pencil size={15} />,
                run: () => startEdit(m)
              }
            ]
          : []),
        {
          label: tr('Report Message', 'Nachricht melden'),
          divider: true,
          danger: true,
          icon: <Flag size={15} />,
          run: () => setModal('report:' + m.id)
        },
        ...(m.authorId === me?.id || canManageServer
          ? [
              {
                label: tr('Delete Message', 'Nachricht löschen'),
                danger: true,
                icon: <Trash2 size={15} />,
                run: () => setModal('delete:' + m.id)
              }
            ]
          : []),
        {
          label: tr('Copy Message ID', 'Nachrichten-ID kopieren'),
          divider: true,
          icon: <Copy size={15} />,
          run: () =>
            action(async () => {
              await copyToClipboard(m.id);
              setNotice(tr('Message ID copied.', 'Nachrichten-ID kopiert.'));
            })
        }
      ]
    });
  }

  function handleGlobalContextMenu(e: React.MouseEvent) {
    if (e.defaultPrevented) return;
    e.preventDefault();
    const sel = window.getSelection()?.toString() || '';
    const actions: MenuAction[] = [];
    if (sel) {
      actions.push({
        label: tr('Copy Selection', 'Auswahl kopieren'),
        icon: <Copy size={15} />,
        run: () => {
          void copyToClipboard(sel);
          setNotice(tr('Copied.', 'Kopiert.'));
        }
      });
    }
    if (community) {
      if(!community.systemTeam)actions.push({
        label: tr('Invite People', 'Leute einladen'),
        icon: <UserPlus size={15} />,
        run: () => setModal('invite')
      });
      if (canManageServer) actions.push({
        label: tr('Server Settings', 'Servereinstellungen'),
        icon: <Settings size={15} />,
        run: () => setModal('community-settings')
      });
    } else {
      actions.push({
        label: tr('Add Friend', 'Freund hinzufügen'),
        icon: <UserPlus size={15} />,
        run: () => {
          home();
          setTab('add');
        }
      });
      actions.push({
        label: tr('Add a Server', 'Server hinzufügen'),
        icon: <Plus size={15} />,
        run: () => setModal('community')
      });
    }
    actions.push({
      label: tr('Edit Profile', 'Profil bearbeiten'),
      divider: true,
      icon: <Pencil size={15} />,
      run: () => {
        setSettingsTab('profile');
        setModal('settings');
      }
    });
    actions.push({
      label: tr('Settings', 'Einstellungen'),
      icon: <Settings size={15} />,
      run: () => {
        setSettingsTab('account');
        setModal('settings');
      }
    });
    actions.push({
      label: tr('Saved Messages', 'Gespeicherte Nachrichten'),
      icon: <Bookmark size={15} />,
      run: () => setModal('bookmarks')
    });
    actions.push({
      label: tr('Reload App', 'App neu laden'),
      divider: true,
      icon: <RefreshCw size={15} />,
      run: () => triggerSpinningReload()
    });
    setContext({ x: e.clientX, y: e.clientY, actions });
  }

  // Hooks also run during loading, sign-in and restricted-account renders.
  const displayMessages = messages.filter(m => !query || m.body.toLowerCase().includes(query.toLowerCase()));
  if (loading)
    return (
      <div className="loading">
        <img src="/icon.png" alt="MALVO" />
        <LoaderCircle className="spin" />
        {tr('Loading MALVO Chat…', 'MALVO Chat wird geladen')}
      </div>
    );
  if (restriction) return <RestrictedAccount restriction={restriction} onBack={async()=>{await api('/auth/logout','POST');setRestriction(null);setMe(null);}}/>;
  if (me && warnings.length) return <ModerationWarning warning={warnings[0]} onAcknowledge={async()=>{await api('/moderation/warnings/'+warnings[0].id+'/ack','POST');await loadMe();}}/>;
  if (!me)
    return (
      <Auth
        request={api}
        onDone={async () => {
          await loadMe();
        }}
        error={error}
        setError={setError}
        mailEnabled={features.mail}
        captchaSiteKey={features.captcha}
      />
    );
  if (me && !me.verified)
    return (
      <VerifyEmail
        email={me.email || ''}
        request={api}
        mailEnabled={features.mail}
        onVerified={async () => {
          await loadMe();
          setError('');
        }}
        onLogout={logout}
      />
    );

  const groupPinOrder=new Map(pinnedGroups.map((id,index)=>[id,index]));
  const categories = community
    ? Array.from(
        new Set([...community.channels.map(c => c.category || ''),...(community.capabilities?.manageChannels?Object.keys(community.categoryPermissions||{}):[])])
      ).sort((a,b)=>{if(!a)return -1;if(!b)return 1;const order=(community as any).categoryOrder||[];const ai=order.indexOf(a),bi=order.indexOf(b);return (ai<0?100000:ai)-(bi<0?100000:bi)})
    : [];
  const memberRows = members || [], onlineIds = data.online || [];
  const onlineMembers = memberRows.filter(p => (p.id===me.id?me.status:p.status)!=='invisible'&&(p.id===me.id||onlineIds.includes(p.id)));
  const offlineMembers = memberRows.filter(p => !onlineMembers.some(o => o.id === p.id));
  // Discord-style member list: online people grouped under their highest hoisted role,
  // then everyone else online, then all offline members.
  const isCommunityOwner = (p: Person) =>
    p.role === 'owner';
  const memberGroups = (() => {
    const byName = (a: Person, b: Person) => shownName(a).localeCompare(shownName(b));
    const groups = new Map<string, { id: string; label: string; position: number; people: Person[] }>();
    const rest: Person[] = [];
    for (const p of onlineMembers) {
      const role = (p.customRoles || []).find(r => !!r.hoist); // only roles with "display separately" get their own group
      const key = role
        ? { id: role.id, label: role.name, position: role.position }
        : isCommunityOwner(p)
        ? { id: '__owner', label: tr('Owner', 'Owner'), position: Number.MAX_SAFE_INTEGER }
        : p.role === 'moderator'
        ? { id: '__moderator', label: tr('Moderators', 'Moderatoren'), position: Number.MAX_SAFE_INTEGER - 1 }
        : null;
      if (!key) { rest.push(p); continue; }
      if (!groups.has(key.id)) groups.set(key.id, { ...key, people: [] });
      groups.get(key.id)!.people.push(p);
    }
    const list = [...groups.values()].sort((a, b) => b.position - a.position);
    list.forEach(g => g.people.sort(byName));
    if (rest.length) list.push({ id: '__online', label: tr('Online', 'Online'), position: -1, people: rest.sort(byName) });
    if (offlineMembers.length) list.push({ id: '__offline', label: tr('Offline', 'Offline'), position: -2, people: [...offlineMembers].sort(byName) });
    return list;
  })();
  const callConv = call ? data.conversations.find(c => c.id === call.id) : undefined;
  const callPeer = callConv && !callConv.group ? callConv.person || null : null;
  const callWaiting: Person[] = callConv?.group ? callConv.group.members.filter(m => m.id !== me?.id) : callPeer ? [callPeer] : [];
  const callRinging = call ? ringState[call.id] : undefined;

  if(accountSwitching)return <div className="loading" role="status"><LoaderCircle className="spin"/>Account wird gewechselt …</div>;
  const dialogCommunity=community,dialogMembers=members;
  return (
    <div ref={viewportRef} className={"app-shell"+(teamOpen?" team-open":"")} onContextMenu={handleGlobalContextMenu}>
      {namingPerson&&<NicknameDialog username={namingPerson.username} nickname={data.contactPreferences?.[namingPerson.id]?.nickname||null} onClose={()=>setNamingPerson(null)} onSave={async nickname=>{await api('/contacts/'+namingPerson.id+'/preferences','PATCH',{nickname});await refresh()}}/>}
      <MessageNotices activeRoom={roomId} status={me.status} onOpen={(rid,cid)=>{if(rid.startsWith('friendship:')){home();setTab('pending')}else selectRoom(rid,cid)}}/>
      {botInvite&&<InviteBot bot={{id:botInvite.id}} requested={botInvite.permissions} appLink={inDesktopApp()?undefined:botInviteAppLink(botInvite)} request={api} lang={getLang()} onClose={()=>setBotInvite(null)}/>}
      {botModal&&<BotModal key={botModal.id} modal={botModal} request={api} onClose={()=>setBotModal(null)}/>}
      {reloading && (
        <div className="spinning-reload-overlay" role="status" aria-live="polite">
          <div className="spinning-reload-card">
            <img src="/icon.png" alt="MALVO" className="spinning-reload-logo" />
            <p>{tr('Reloading MALVO Chat…', 'MALVO Chat wird neu geladen …')}</p>
          </div>
        </div>
      )}

      <ClipStatus userId={me.id}/>
      {phone&&<nav className="mobile-app-nav" aria-label={tr('Main navigation','Hauptnavigation')}>
        <button type="button" className={!community?'active':''} onClick={()=>{home();setSidebar(true)}}><MessageSquare size={22}/><span>Chats</span>{unread.size>0&&<i className="mobile-unread-count">{Math.min(unread.size,99)}</i>}</button>
        <button type="button" className={community?'active':''} onClick={()=>{setShowMembers(false);setShowDmProfileRaw(false);setSidebar(true)}}><Hash size={23}/><span>Server</span></button>
        <button type="button" onClick={()=>setModal('message-search')}><Search size={22}/><span>{tr('Search','Suchen')}</span></button>
        <button type="button" onClick={()=>{setSettingsTab('account');setModal('settings')}}><Avatar person={me} size={24}/><span>{tr('You','Du')}</span></button>
      </nav>}
      {sidebar && <div className="mobile-sidebar-backdrop" onClick={() => setSidebar(false)} aria-hidden="true" />}
      {phonePanelOpen && isPhone() && <div className="mobile-panel-backdrop" onClick={() => { setShowMembers(false); setShowDmProfileRaw(false); }} aria-hidden="true" />}
      <aside inert={phone&&!sidebar?true:undefined} aria-hidden={phone&&!sidebar?true:undefined} onClickCapture={()=>{if(teamOpen)closeTeam(false)}} className="server-rail">
        <div className="rail-primary-scroll">
        <button
          title={tr('Direct Messages & Friends', 'MALVO Zuhause')}
          className={'brand-tile ' + (!activeCommunity ? 'selected' : '')}
          onClick={home}
        >
          <img src="/icon.png" alt="MALVO" />
          {/* Unread messages from the official MALVO account show on the home button, not as an extra MALVO logo. */}
          {[...unread].some(rid => { const p = unreadPeers[rid] || data.conversations.find(c => c.id === rid)?.person; return rid === OFFICIAL_CHAT_ID || isSystemAccount(p); }) && <span className="rail-mention-badge rail-home-badge">1</span>}
        </button>
        <button
          title={tr('Notifications', 'Benachrichtigungen')}
          className="rail-notif-btn"
          onClick={() => {
            home();
            setTab('pending');
          }}
        >
          <Bell size={18} />
          {requests.length > 0 && <i className="rail-notif-dot" />}
        </button>
        <div className="rail-unread-dms" aria-label={tr('Private call and unread direct messages','Privatanruf und ungelesene Direktnachrichten')}>
          {[...new Set([...(call && callPeer ? [call.id] : []), ...unread])].map(rid => {
            const inCall = rid === call?.id && !!callPeer;
            const p = inCall ? callPeer : unreadPeers[rid] || data.conversations.find(c => c.id === rid)?.person;
            if (!p || rid === OFFICIAL_CHAT_ID || isSystemAccount(p)) return null;
            const hasUnread = unread.has(rid), n = dmUnread.counts[rid] || 1;
            const label = inCall ? tr('Private call with ', 'Privatanruf mit ') + shownName(p) : tr('New message from ', 'Neue Nachricht von ') + shownName(p);
            return <div key={rid} className={'rail-dm-wrap' + (inCall ? ' rail-dm-in-call' : '')}>
              {hasUnread && <i className="rail-unread-pill" />}
              <button type="button" className="rail-dm-tile" aria-label={label} onClick={() => {
                selectRoom(rid, null);
                setUnread(prev => { const next = new Set(prev); next.delete(rid); return next; });
                if (inCall) { setCallMinimized(false); setModal(null); }
              }}><Avatar person={p} size={48}/>
              {inCall && <span className="rail-dm-call-badge" aria-hidden="true"><Volume2 size={12}/></span>}
              {hasUnread && <span className="rail-mention-badge rail-dm-badge" aria-hidden="true">{n > 99 ? '99+' : n}</span>}</button>
              <RailTooltip compact>{label}</RailTooltip>
            </div>;
          })}
        </div>
        <span className="rail-divider" />
        <ServerRail request={api} onMarkRead={markFolderRead} userId={me.id} communities={data.communities} unread={cid => serverMentions(data.communities.find(x => x.id === cid))} hasUnread={cid => serverUnread(data.communities.find(x => x.id === cid))} render={(c:Community) => {
          const isOff = c.id === 'malvo-official' || !!c.verified;
          return (
            <div key={c.id} className="server-tile-wrap">
              <button
                onMouseEnter={() => { if (!memberCache.current.has(c.id)) void api('/communities/' + c.id + '/members').then(rows => memberCache.current.set(c.id, rows)).catch(() => {}); }}
                onContextMenu={e=>openCommunityMenu(e,c)}
                aria-label={c.name}
                onClick={() => selectRoom(lastChannelOf(c), c.id)}
                className={'server-tile ' + (activeCommunity === c.id ? 'selected ' : '') + (mutedServers.has(c.id) ? 'is-muted ' : '')+(c.suspended?'is-server-suspended':'')}
              >
                {c.id === 'malvo-official' && (!c.icon || c.icon === 'icon.png') ? (
                  <img draggable={false} src="/icon.png" alt={c.name} style={{ width: '30px', height: '30px', objectFit: 'contain' }} />
                ) : c.icon === 'icon.png' ? (
                  <img draggable={false} src="/icon.png" alt={c.name} style={{ width: '30px', height: '30px', objectFit: 'contain' }} />
                ) : c.icon ? (
                  <img draggable={false} className="rail-server-icon" src={'/api/files/' + c.icon + '?size=96'} alt={c.name} decoding="async" />
                ) : (
                  c.name.slice(0, 2).toUpperCase()
                )}
              </button>
              {c.suspended&&<span className="rail-server-suspension" title="Server gesperrt"><Ban size={12}/></span>}
              {(() => {
                const n = serverMentions(c);
                return <>{serverUnread(c) ? <i className="rail-unread-pill" /> : null}{n > 0 ? <span className="rail-mention-badge">{n > 99 ? '99+' : n}</span> : null}</>;
              })()}
              {c.channels?.some((ch: any) => ch.kind==='voice' && (ch.id===call?.id || (voiceRosters[ch.id]?.length||0)>0)) && (
                <span className={'rail-voice-badge'+(c.channels.some((ch:any)=>ch.id===call?.id)?' is-joined':' is-occupied')} title={c.channels.some((ch:any)=>ch.id===call?.id)?tr('You are in a voice call here', 'Du bist hier im Sprachkanal'):tr('Members are in voice channels','Mitglieder sind in Sprachkanälen')}>
                  <Volume2 size={11} />
                </span>
              )}
              <RailTooltip>
                <div className="rail-tooltip-arrow" />
                <div className="tooltip-title">
                  {isOff && <VerifiedBadgeSvg size={18} />}
                  <span>{c.name}</span>
                </div>
                <div className="tooltip-stats">
                  <span className="tooltip-stat-online">
                    <UserStatSvg color="#22c55e" size={14} /> {Math.max(0, c.onlineCount || 0)}
                  </span>
                  <span className="tooltip-stat-total">
                    <UserStatSvg color="#8e8e9a" size={14} />{' '}
                    {Math.max(1, c.memberCount || 1).toLocaleString(lang === 'de' ? 'de-DE' : 'en-US')}
                  </span>
                </div>
              </RailTooltip>
            </div>
          );
        }}/>
        <button
          title={tr('Create or Join a Server', 'Community erstellen oder beitreten')}
          className="server-add"
          onClick={() => setModal('community')}
        >
          <Plus />
        </button>
        {showDiscovery&&<button type="button" className="server-discovery" title="Server finden" aria-label="Server finden" onClick={openDiscovery}><Globe size={22}/></button>}
        </div>
        <SuspendedServers servers={data.communities} onRefresh={()=>void refresh()} onOpen={server=>{setActiveCommunity(server.id);setRoomId(null);setMessages([]);setLoadedMessageRoom(null)}}/>
        {!isDesktopApp&&<button
          title={tr('Download MALVO Desktop App', 'MALVO App herunterladen')}
          className="rail-bottom"
          onClick={() => setModal('about')}
        >
          <Download size={19} />
        </button>}
      </aside>

      <aside inert={phone&&!sidebar?true:undefined} aria-hidden={phone&&!sidebar?true:undefined} className={'channel-sidebar ' + (sidebar ? 'mobile-open' : '')}>
        {phone&&<div className="mobile-navigation-heading"><span>{community?tr('Server channels','Serverkanäle'):tr('Your conversations','Deine Unterhaltungen')}</span><button type="button" className="mobile-navigation-close" aria-label={tr('Close navigation','Navigation schließen')} onClick={()=>setSidebar(false)}><X size={20}/></button></div>}
        {!community && (
          <header className="workspace-header">
            <span>MALVO Chat</span>
          </header>
        )}
        {community && (community.verified || community.id === 'malvo-official' || community.banner) && (
          <div
            className="official-server-banner flackle-banner-card"
            style={
              community.banner
                ? {
                    backgroundImage: `linear-gradient(180deg, rgba(14,14,18,0.52) 0%, rgba(14,14,18,0.88) 100%), url('/api/files/${community.banner}')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }
                : undefined
            }
            onClick={() => { if (canManageServer) setModal('community-settings'); }}
          >
            <div className="official-banner-top">
              {(community.verified || community.id === 'malvo-official') && <VerifiedBadgeSvg size={20} />}
              <b>{community.name}</b>
              <div className="official-banner-btns" onClick={e => e.stopPropagation()}><button type="button" className="server-menu-trigger" title={tr('Server menu','Servermenü')} aria-label={tr('Server menu','Servermenü')} onClick={e=>openCommunityMenu(e,community)}><MoreHorizontal size={17}/></button>
                <button type="button" data-team-hidden={community?.systemTeam||undefined} title={tr('Invite People', 'Leute einladen')} onClick={() => setModal('invite')}>
                  <UserPlus size={15} />
                </button>
                {canManageServer && <button
                  type="button"
                  title={tr('Server Settings & Roles', 'Servereinstellungen & Rollen')}
                  onClick={() => setModal('community-settings')}
                >
                  <Settings size={15} />
                </button>}
              </div>
            </div>
            <p className="official-banner-desc">{community.description || 'Communities deserve better.'}</p>
            <div className="official-banner-handle">
              <span className="banner-vanity-pill">
                {community.id === 'malvo-official' ? 'malvo.eu/malvo' : `malvo.eu/i/${community.vanityInvite || community.invite}`}
              </span>
            </div>
          </div>
        )}
        {community && !(community.verified || community.id === 'malvo-official' || community.banner) && (
          <header className="workspace-header">
            <span>{community.name}</span>
            <div className="workspace-header-actions"><button type="button" className="server-menu-trigger" title={tr('Server menu','Servermenü')} aria-label={tr('Server menu','Servermenü')} onClick={e=>openCommunityMenu(e,community)}><MoreHorizontal size={17}/></button>
              <button data-team-hidden={community?.systemTeam||undefined} title={tr('Invite People', 'Leute einladen')} onClick={() => setModal('invite')}>
                <UserPlus size={16} />
              </button>
              {canManageServer && <button
                title={tr('Server Settings & Roles', 'Servereinstellungen & Rollen')}
                onClick={() => setModal('community-settings')}
              >
                <Settings size={16} />
              </button>}
            </div>
          </header>
        )}
        <div className="side-scroll">
          {!community ? (
            <>
              <div className="quick-search">
                <Search size={16} />
                <input
                  placeholder={tr('Search conversations...', 'Unterhaltungen suchen...')}
                  aria-label="Search conversations"
                  value={query}
                  onChange={e => setQuery(e.target.value)}
                />
              </div>
              <button
                className="side-link"
                onClick={() => {
                  setPerson(me);
                  setModal('profile');
                }}
              >
                <Users size={19} />
                {tr('My Profile', 'Mein Profil')}
              </button>
              <button className={'side-link ' + (!roomId ? 'active' : '')} onClick={home}>
                <Users size={19} />
                {tr('Friends', 'Freunde')}
                {requests.length > 0 && <b className="badge">{requests.length}</b>}
              </button>
              <button className="side-link" onClick={() => setModal('bookmarks')}>
                <Bookmark size={19} />
                {tr('Saved', 'Gespeichert')}
              </button>
              {(features.billing || me.supporter) && (
                <button className="side-link" onClick={() => setModal('subscription')}>
                  <Heart size={19} />
                  MALVO Supporter
                </button>
              )}
              <div className="side-section">
                {tr('DIRECT MESSAGES', 'DIREKTNACHRICHTEN')}
                <button
                  title={tr('Create group', 'Gruppe erstellen')}
                  aria-label={tr('Create group', 'Gruppe erstellen')}
                  onClick={() => setModal('group-create')}
                >
                  <Plus size={16} />
                </button>
              </div>
              {data.conversations
                .filter(c => !query || (c.group?.name||shownName(c.person))?.toLowerCase().includes(query.toLowerCase()))
                .sort((a,b)=>{const left=a.group?groupPinOrder.get(a.id):undefined,right=b.group?groupPinOrder.get(b.id):undefined;return left===undefined?(right===undefined?0:1):right===undefined?-1:left-right})
                .map(c => (
                  <div key={c.id} className={'dm-entry'+(c.group?' group-entry':'')+(c.group&&pinnedGroups.includes(c.id)?' pinned-group':'')}>
                  <button
                    key={c.id}
                    className={'dm-link ' + (roomId === c.id ? 'active' : '')}
                    onContextMenu={e => {
                      e.preventDefault();
                      e.stopPropagation();
                      if(c.official){setContext({x:e.clientX,y:e.clientY,actions:[{label:tr('Close chat','Chat schließen'),icon:<X size={15}/>,run:()=>void action(async()=>{await api('/dm/'+c.id+'/close','POST');setData(previous=>({...previous,conversations:previous.conversations.filter(row=>row.id!==c.id)}));setUnread(previous=>{const next=new Set(previous);next.delete(c.id);return next});if(activeRef.current===c.id)home()})}]});return;}
                      if (c.group) {
                        setContext({ x: e.clientX, y: e.clientY, actions: [
                          {label:pinnedGroups.includes(c.id)?tr('Unpin group','Gruppe lösen'):tr('Pin group','Gruppe anpinnen'),icon:pinnedGroups.includes(c.id)?<GroupUnpin size={16}/>:<GroupPin size={16}/>,run:()=>toggleGroupPin(c)},
                          { label: tr('Group settings', 'Gruppeneinstellungen'), icon: <Users size={15} />, run: () => { selectRoom(c.id, null); setModal('group-manage'); } },
                          { label: tr('Start Voice Call', 'Anrufen'), icon: <Phone size={15} />, run: () => startCall(c.id, shownName(c.person)) },
                          { label: tr('Leave group', 'Gruppe verlassen'), danger: true, divider: true, icon: <X size={15} />, run:()=>{selectRoom(c.id,null);setModal('group-manage')} }
                        ] });
                        return;
                      }
                      setContext({
                        x: e.clientX,
                        y: e.clientY,
                        actions: [
                          {
                            label: tr('Open Profile', 'Profil öffnen'),
                            icon: <User size={15} />,
                            run: () => {
                              setPerson(c.person);
                              setModal('profile');
                            }
                          },
                          {label:tr('Close chat','Chat schließen'),icon:<X size={15}/>,run:()=>void action(async()=>{await api('/dm/'+c.id+'/close','POST');setData(prev=>({...prev,conversations:prev.conversations.filter(x=>x.id!==c.id)}));if(roomId===c.id){setRoomId(null);setActiveCommunity(null);}setUnread(prev=>{const next=new Set(prev);next.delete(c.id);return next;});})},
                          {
                            label: tr('Start Voice Call', 'Anrufen'),
                            icon: <Phone size={15} />,
                            run: () => startCall(c.id, shownName(c.person))
                          },
                          {
                            label: tr('Block User', 'Person blockieren'),
                            danger: true,
                            divider: true,
                            icon: <Ban size={15} />,
                            run: () => {
                              setPerson(c.person);
                              setModal('block-confirm');
                            }
                          },
                          {
                            label: tr('Copy ID', 'ID kopieren'),
                            divider: true,
                            icon: <Copy size={15} />,
                            run: () => {
                              void copyToClipboard(c.person.id);
                              setNotice(tr('ID copied.', 'ID kopiert.'));
                            }
                          }
                        ]
                      });
                    }}
                    onClick={() => selectRoom(c.id, null)}
                    onPointerEnter={() => prefetchRoom(c.id)} onPointerDown={() => prefetchRoom(c.id)}
                  >
                    <span className="dm-avatar-wrap">{c.group ? <GroupAvatar members={c.group.members.filter(m => m.id !== me.id)} size={32} /> : <Avatar
                      person={c.person}
                      size={32}
                      online={(data.online || []).includes(c.person?.id) && c.person?.status !== 'invisible'}
                    />}{(voiceRosters[c.id]?.length||0)>0&&<i className="dm-call-badge" aria-hidden="true"><Volume2 size={11} strokeWidth={2.6}/></i>}</span>
                    <span className="dm-contact-copy">
                      <span className="dm-link-title">{c.group&&pinnedGroups.includes(c.id)&&<GroupPin className="group-pinned-mark" size={12} aria-label={tr('Pinned group','Angepinnte Gruppe')}/>} {shownName(c.person) || 'User'}{!c.group && <OfficialAccountTag person={c.person}/>}</span>
                      {(voiceRosters[c.id]?.length||0)>0
                        ? <small className="dm-in-call" title={(voiceRosters[c.id]||[]).map(u=>shownName(u)).join(', ')}><Volume2 size={12}/><span className="dm-call-summary">{tr('In call','Im Anruf')} · {voiceRosters[c.id].length}</span><CallElapsed startedAt={voiceRosters[c.id]?.find(p=>p.callStartedAt)?.callStartedAt}/></small>
                        : <small>{c.group ? tr(`${c.group.members.length} members`, `${c.group.members.length} Mitglieder`) : '@' + (c.person?.username || 'user')}</small>}
                    </span>
                    {(dmUnread.counts[c.id]||0)>0?<span className="dm-unread-count" aria-label={tr(`${dmUnread.counts[c.id]} unread messages`,`${dmUnread.counts[c.id]} ungelesene Nachrichten`)}>{dmUnread.counts[c.id]>99?'99+':dmUnread.counts[c.id]}</span>:unread.has(c.id)&&<i className="unread"/>}
                  </button>
                  {c.group&&<button type="button" className="group-pin-action" data-group-pin={c.id} disabled={groupPinBusy} aria-label={pinnedGroups.includes(c.id)?tr('Unpin group ','Gruppe lösen: ')+(c.group.name||shownName(c.person)):tr('Pin group ','Gruppe anpinnen: ')+(c.group.name||shownName(c.person))} title={pinnedGroups.includes(c.id)?tr('Unpin group','Gruppe lösen'):tr('Pin group','Gruppe anpinnen')} onClick={()=>toggleGroupPin(c)}>{pinnedGroups.includes(c.id)?<GroupUnpin size={17}/>:<GroupPin size={17}/>}</button>}
                  </div>
                ))}
              {searchedDMs.filter(c=>!data.conversations.some(d=>d.id===c.id)).map(c=><button className="dm-link" key={c.id} onClick={()=>{void openDM(c.person);setQuery('');}}><Avatar person={c.person} size={32}/><span>{shownName(c.person)}<small>@{c.person.username}</small></span></button>)}
              {!data.conversations.length && (
                <p className="side-hint">{tr('No direct messages yet.', 'Noch keine Direktnachrichten.')}</p>
              )}
            </>
          ) : (
            <>
              {categories.map(cat => {
                const catChannels = community.channels.filter(
                  c => (c.category || '') === cat
                );
                if (!catChannels.length&&!community.capabilities?.manageChannels&&community.role!=='owner') return null;
                return (
                  <CategorySection key={cat} name={cat} enabled={community.role==='owner'||!!community.capabilities?.manageChannels} onTarget={setCategoryDrop} onMove={(target,after)=>void action(async()=>{await api('/communities/'+community.id+'/categories/reorder','POST',{name:cat,target,after});await refresh()})}>
                    {!!cat&&<div className={"side-section category-header"+(channelCategoryDrop===cat?" category-channel-drop":"")+(categoryDrop?.id===cat?(categoryDrop.after?" category-drop-after":" category-drop-before"):"")} onContextMenu={e => {
                      e.preventDefault();
                      const key = me.id + ':' + community.id + ':' + cat, collapsed = !!collapsedCategories[key];
                      setContext({ x: e.clientX, y: e.clientY, actions: [
                        { label: collapsed ? tr('Expand Category', 'Kategorie ausklappen') : tr('Collapse Category', 'Kategorie einklappen'), icon: <ChevronDown size={15} />, run: () => { const next = { ...collapsedCategories, [key]: !collapsed }; setCollapsedCategories(next); localStorage.setItem('malvo-collapsed-categories', JSON.stringify(next)); } },
                        ...(community.categoryIds?.[cat] ? [{ label: tr('Copy Category ID', 'Kategorie-ID kopieren'), icon: <Copy size={15} />, run: () => { void copyToClipboard(community.categoryIds![cat]); setNotice(tr('Category ID copied.', 'Kategorie-ID kopiert.')); } }] : []),
                        ...(community.role==='owner'||community.capabilities?.manageChannels ? [
                          { label: tr('Edit Category', 'Kategorie bearbeiten'), divider: true, icon: <Pencil size={15} />, run: () => openCategorySettings(cat) },
                          { label: tr('Delete Category', 'Kategorie löschen'),danger:true,icon:<Trash2 size={15}/>,run:()=>openCategorySettings(cat,true) },
                          { label: tr('Create Channel', 'Kanal erstellen'), icon: <Plus size={15} />, run: () => { setChannelCategory(cat); setModal('channel'); } }
                        ] : [])
                      ] });
                    }}>
                      {(community.role==='owner'||community.capabilities?.manageChannels)&&<ChannelMoveHandle kind="category" id={cat} onTarget={setCategoryDrop} onMove={(target,after)=>void action(async()=>{await api('/communities/'+community.id+'/categories/reorder','POST',{name:cat,target,after});await refresh()})}/>}<button type="button" className="category-toggle" aria-expanded={!collapsedCategories[me.id+':'+community.id+':'+cat]} onClick={()=>{const key=me.id+':'+community.id+':'+cat;const next={...collapsedCategories,[key]:!collapsedCategories[key]};setCollapsedCategories(next);localStorage.setItem('malvo-collapsed-categories',JSON.stringify(next));}}>{cat}<ChevronDown size={12}/></button>
                      {canManageServer && (
                        <button title={tr('Create Channel', 'Kanal erstellen')} onClick={() => {setChannelCategory(cat);setModal('channel');}}>
                          <Plus size={15} />
                        </button>
                      )}
                    </div>}
                    <div inert={!!cat&&!!collapsedCategories[me.id+':'+community.id+':'+cat]} className={'category-channel-group '+(cat&&collapsedCategories[me.id+':'+community.id+':'+cat]?'is-collapsed':'')}><div>
                    {catChannels.map(c => (
                      <React.Fragment key={c.id}>
                        <div
                        data-channel-id={c.id}
                        draggable={community.role==='owner'||!!community.capabilities?.manageChannels}
                        onDragStart={e=>{channelDrag.current=c.id;e.dataTransfer.effectAllowed='move';e.dataTransfer.setData('application/x-malvo-channel',c.id);e.dataTransfer.setData('text/plain',c.id);}}
                        onDragOver={e=>{if(voiceDrag.current){if(c.kind!=='voice'||voiceDrag.current.from===c.id)return;e.preventDefault();e.dataTransfer.dropEffect='move';setVoiceDrop(c.id);return;}if(!channelDrag.current||channelDrag.current===c.id)return;e.preventDefault();e.dataTransfer.dropEffect='move';const rect=e.currentTarget.getBoundingClientRect();setChannelDrop({id:c.id,after:e.clientY>rect.top+rect.height/2});}}
                        onDragEnd={()=>{channelDrag.current=null;setChannelDrop(null);}}
                        onDragLeave={e=>{if(voiceDrop===c.id&&!e.currentTarget.contains(e.relatedTarget as Node))setVoiceDrop(null);}}
                        onDrop={e=>{e.preventDefault();if(voiceDrag.current){const v=voiceDrag.current;voiceDrag.current=null;setVoiceDrop(null);if(c.kind==='voice'&&v.from!==c.id)void action(async()=>{await api('/communities/'+community.id+'/members/'+v.uid+'/voice','PATCH',{destinationId:c.id});});return;}const source=channelDrag.current;const after=channelDrop?.after||false;channelDrag.current=null;setChannelDrop(null);if(source&&source!==c.id)void action(async()=>{await api('/communities/'+community.id+'/channels/reorder','POST',{channelId:source,targetId:c.id,after});await refresh();});}}
                        className={
                          (channelDrop?.id===c.id?(channelDrop.after?'channel-drop-after ':'channel-drop-before '):'')+(voiceDrop===c.id?'voice-drop-target ':'')+'side-link channel-item ' +
                          ((c.kind === 'voice' ? call?.id === c.id : roomId === c.id) ? 'active' : '')
                        }
                        onContextMenu={e => {
                          e.preventDefault();
                          e.stopPropagation();
                          setContext({
                            x: e.clientX,
                            y: e.clientY,
                            actions: [
                              {
                                label: tr('Open Channel', 'Kanal öffnen'),
                                icon: <Hash size={15} />,
                                run: () =>
                                  c.kind === 'voice' ? startCall(c.id, c.name) : selectRoom(c.id, community.id)
                              },
                              ...(!community.systemTeam?[{
                                label: tr('Invite People', 'Leute einladen'),
                                icon: <UserPlus size={15} />,
                                run: () => setModal('invite')
                              }]:[]),
                              {
                                label: tr('Copy Channel Link', 'Kanal-Link kopieren'),
                                icon: <Link2 size={15} />,
                                run: () => { void copyToClipboard(location.origin + '/?channel=' + c.id); setNotice(tr('Channel link copied. Paste it in a chat to share the channel.', 'Kanal-Link kopiert. Füge ihn in einen Chat ein, um den Kanal zu teilen.')); }
                              },
                              {
                                label: mutedChannels.has(c.id) ? tr('Unmute Channel', 'Kanal-Stummschaltung aufheben') : tr('Mute Channel', 'Kanal stummschalten'),
                                icon: mutedChannels.has(c.id) ? <BellIcon size={15}/> : <BellOff size={15}/>,
                                run: () => toggleChannelMute(c.id)
                              },
                              ...(canManageServer
                                ? [
                                    {
                                      label: tr('Channel Settings', 'Kanaleinstellungen'),
                                      divider: true,
                                      icon: <Settings size={15} />,
                                      run: () => openChannelSettings(c.id)
                                    },
                                    {
                                      label: cat?tr('Edit Category', 'Kategorie bearbeiten'):tr('Set category','Kategorie zuweisen'),
                                      icon: <Pencil size={15} />,
                                      run: () => cat?openCategorySettings(cat):openChannelSettings(c.id)
                                    },
                                    {
                                      label: tr('Create Channel', 'Kanal erstellen'),
                                      icon: <Plus size={15} />,
                                      run: () => setModal('channel')
                                    },
                                    {
                                      label: tr('Delete Channel', 'Kanal löschen'),
                                      danger: true,
                                      icon: <Trash2 size={15} />,
                                      run: () => {
                                        setChannelToDelete(c);
                                        setModal('channel-delete');
                                      }
                                    }
                                  ]
                                : []),
                              {
                                label: tr('Copy Channel ID', 'Kanal-ID kopieren'),
                                divider: true,
                                icon: <Copy size={15} />,
                                run: () => {
                                  void copyToClipboard(c.id);
                                  setNotice(tr('Channel ID copied.', 'Kanal-ID kopiert.'));
                                }
                              }
                            ]
                          });
                        }}
                        onClick={() =>
                          c.kind === 'voice' ? startCall(c.id, c.name) : selectRoom(c.id, community.id)
                        }
                        onPointerEnter={() => { if (c.kind !== 'voice') prefetchRoom(c.id); }} onPointerDown={() => { if (c.kind !== 'voice') prefetchRoom(c.id); }}
                      >
                        {(community.role==='owner'||community.capabilities?.manageChannels)&&<ChannelMoveHandle id={c.id} onCategoryTarget={setChannelCategoryDrop} onCategoryMove={category=>void action(async()=>{await api('/communities/'+community.id+'/channels/reorder','POST',{channelId:c.id,targetCategory:category,after:true});await refresh()})} onTarget={setChannelDrop} onMove={(targetId,after)=>void action(async()=>{await api('/communities/'+community.id+'/channels/reorder','POST',{channelId:c.id,targetId,after});await refresh();})}/>}
                        {channelIcon(c,community.id==='malvo-official')}
                        <span className={'channel-item-name' + (unreadCounts[c.id] > 0 ? ' has-unread' : '')}>{c.name}</span>
                        {c.kind==='voice'&&<CallElapsed startedAt={voiceRosters[c.id]?.find(p=>p.callStartedAt)?.callStartedAt}/>}
                        {c.kind==='voice'&&!!c.userLimit&&c.userLimit<12&&<span className="voice-limit-label" title={tr('Participant limit','Teilnehmerlimit')}>{(voiceRosters[c.id]||[]).length} / {c.userLimit}</span>}
                        {mutedChannels.has(c.id) && <span className="channel-muted-indicator" title={tr('Channel muted · mentions still notify', 'Kanal stummgeschaltet · Erwähnungen bleiben aktiv')}><BellOff size={13} aria-label={tr('Channel muted', 'Kanal stummgeschaltet')}/></span>}
                        {mentionCounts[c.id] > 0 && (
                          <span className="channel-unread-badge">{mentionCounts[c.id] > 99 ? '99+' : mentionCounts[c.id]}</span>
                        )}
                        <span className="channel-item-actions" onClick={e => e.stopPropagation()}>
                          <button type="button" data-team-hidden={community?.systemTeam||undefined} title={tr('Invite People', 'Leute einladen')} onClick={() => setModal('invite')}>
                            <UserPlus size={14} />
                          </button>
                          {canManageServer && (
                            <button
                              type="button"
                              title={tr('Channel Settings', 'Kanaleinstellungen')}
                              onClick={e => { e.stopPropagation(); openChannelSettings(c.id); }}
                            >
                              <Settings size={14} />
                            </button>
                          )}
                        </span>
                      </div>
                      {c.kind === 'voice' && voiceRosters[c.id] && voiceRosters[c.id].length > 0 && (
                        <div className="voice-channel-roster">
                          {voiceRosters[c.id].map(u => (
                            <div key={u.id} role="button" tabIndex={0} draggable={canMoveVoice(community)}
                              onDragStart={e=>{e.stopPropagation();voiceDrag.current={uid:u.id,from:c.id};e.dataTransfer.effectAllowed='move';e.dataTransfer.setData('text/plain',shownName(u));}}
                              onDragEnd={()=>{voiceDrag.current=null;setVoiceDrop(null);}}
                              onClick={()=>{setPerson(u);setModal('profile');}} onKeyDown={e=>{if(e.key==='Enter'){setPerson(u);setModal('profile');}}} onContextMenu={e=>{e.preventDefault();setRosterVolume({x:e.clientX,y:e.clientY,person:u})}} className={(canMoveVoice(community)?'voice-roster-draggable ':'')+'voice-roster-member ' + (speakingUsers.has(u.id) ? 'is-speaking' : '')+(soundboardUsers.has(u.id)?' is-soundboard-playing':'')}>
                              <Avatar person={u} size={18} />
                              <span className="voice-roster-name" title={shownName(u)}>{shownName(u)}</span>
                              <ChannelBadges person={u}/>
                              {(u as any).streaming&&u.id!==me.id&&<button type="button" className="voice-roster-join" onClick={e=>{e.stopPropagation();setCallMinimized(false);requestStreamWatch(c.id,u.id);void startCall(c.id,c.name)}}>{tr('Join stream','Stream beitreten')}</button>}<VoiceRosterMedia camera={(u as any).camera} streaming={(u as any).streaming} muted={(u as any).muted} deafened={(u as any).deafened}/>
                            </div>
                          ))}
                        </div>
                      )}
                    </React.Fragment>
                    ))}
                    </div></div>
                  </CategorySection>
                );
              })}
            </>
          )}
        </div>
        {profileMenu && (
          <>
            <section
              ref={profilePopoverRef}
              className={'profile-popover ' + (profileClosing?'is-closing ':'') + profileTheme(me).className}
              aria-label={tr('Your profile','Dein Profil')}
              style={profileTheme(me).style}
            >
              <div
                className="popover-banner clickable"
                title={tr('Click to open full profile', 'Klicken, um Profil zu öffnen')}
                onClick={() => {
                  setPerson(me);
                  setModal('profile');
                }}
                style={{
                  backgroundImage: me.banner ? `url('/api/files/${me.banner}')` : bannerFallback(me),
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}
              />
              <div className="popover-body">
                <div
                  className="popover-identity-click"
                  title={tr('Click to open full profile', 'Klicken, um Profil zu öffnen')}
                  onClick={() => {
                    setPerson(me);
                    setModal('profile');
                  }}
                >
                  <Avatar person={me} size={58} online={me.status !== 'invisible'} />
                  <b>{shownName(me)}<StaffMark person={me} /><IdentityBadges person={{ ...me, guildTags: [] }} /></b>
                  <span>@{me.username}</span>
                  <small className="popover-age-text">{getAccountAgeText(me.created, lang)}</small>
                </div>
                {getUserBadges(me).length > 0 && (
                  <div className="popover-badges-row">
                    {getUserBadges(me)
                      .slice(0, 4)
                      .map(b => (
                        <span
                          key={b.id}
                          className="profile-badge-chip"
                          style={{ color: b.color }}
                        >
                          <BadgeToken badge={b} lang={lang}/>
                        </span>
                      ))}
                  </div>
                )}
                <button
                  onClick={() => {
                    setPerson(me);
                    setModal('profile');
                  }}
                >
                  <Users size={16} />
                  <span className="popover-action-label">{tr('My Profile', 'Mein Profil')}</span>
                  <ChevronRight size={15} />
                </button>
                <button
                  onClick={() => {
                    setSettingsTab('profile');
                    setModal('settings');
                  }}
                >
                  <Pencil size={16} />
                  <span className="popover-action-label">{tr('Edit Profile', 'Profil bearbeiten')}</span>
                  <span className="free-label">FREE</span>
                </button>
                <CustomStatus person={me}/><button type="button" onClick={()=>{setProfileMenu(false);setModal('custom-status')}}><Pencil size={16}/><span className="popover-action-label">{tr('Set a status','Status festlegen')}</span></button>
                <ProfileStatusMenu status={me.status} onChange={async status=>{
                  await api('/profile','PATCH',{displayName:me.displayName,bio:me.bio,color:me.color,color2:me.color2,status});
                  await loadMe();setProfileMenu(false);
                }}/>

                <button
                  onClick={() => {
                    setSettingsTab('account');
                    setModal('settings');
                  }}
                >
                  <Settings size={16} />
                  <span className="popover-action-label">{tr('Settings', 'Einstellungen')}</span>
                  <ChevronRight size={15} />
                </button>
                {me.teamAccess && <button onClick={()=>{openTeam();}}><Shield size={16}/><span className="popover-action-label">{tr('Team Dashboard','Team-Dashboard')}</span></button>}
                <button
                  onClick={() =>
                    action(async () => {
                      await copyToClipboard(me.username);
                      setNotice(tr('Username copied.', 'Nutzername kopiert.'));
                      setProfileMenu(false);
                    })
                  }
                >
                  <Copy size={16} />
                  <span className="popover-action-label">{tr('Copy Username', 'Nutzername kopieren')}</span>
                </button>
                <button type="button" onClick={openAccountSwitcher}><Users size={16}/><span className="popover-action-label">{tr('Switch Account','Account wechseln')}</span></button>
              </div>
            </section>
          </>
        )}
        <div className={'user-dock'+(call?' has-call':'')}>
          {call && (
            <section className="dock-voice" aria-label={tr('Voice connection','Sprachverbindung')}>
              <div className="dock-voice-head">
                <button type="button" className="dock-voice-info" title={tr('Open call','Anruf öffnen')} onClick={goToCall}>
                  <span className={'dock-signal ping-'+pingLevel(ping)} title={ping===null?tr('Measuring ping…','Ping wird gemessen …'):'Ping: '+ping+' ms'}><Rss size={18}/>{ping!==null&&<em>{ping} ms</em>}</span>
                  <span className={'dock-voice-text ping-'+pingLevel(ping)}>
                    <b>{tr('Voice Connected', 'Sprachchat verbunden')}</b>
                    <small><Volume2 size={12}/><span>{call.name}{(()=>{const g=data.communities.find(c=>c.channels.some(ch=>ch.id===call.id));return g?' / '+g.name:'';})()}</span></small>
                  </span>
                </button>
                <button type="button" className="dock-icon dock-hangup" title={tr('Disconnect','Auflegen')} aria-label={tr('Disconnect','Auflegen')} onClick={()=>document.querySelector<HTMLButtonElement>('[data-hotkey="disconnect"]')?.click()}><PhoneOff size={18}/></button>
              </div>
              <div className="dock-voice-actions">
                <button type="button" title={tr('Camera','Kamera')} aria-label={tr('Camera','Kamera')} onClick={()=>document.querySelector<HTMLButtonElement>('[data-hotkey="camera"]')?.click()}><Video size={18}/></button>
                <button type="button" title={tr('Share screen','Bildschirm teilen')} aria-label={tr('Share screen','Bildschirm teilen')} onClick={()=>document.querySelector<HTMLButtonElement>('[data-hotkey="screen"]')?.click()}><MonitorUp size={18}/></button>
                <SoundboardButton request={api} />
                <button type="button" title={modal==='call'?tr('Minimize call','Anruf verkleinern'):tr('Open call','Anruf öffnen')} aria-label={tr('Open call','Anruf öffnen')} onClick={()=>document.querySelector<HTMLButtonElement>('[data-hotkey="expand-call"]')?.click()}>{modal==='call'?<Minimize2 size={18}/>:<Maximize2 size={18}/>}</button>
              </div>
            </section>
          )}
          <div className="dock-self">
            <button
              ref={profileTriggerRef}
              type="button"
              className="dock-profile"
              aria-expanded={profileMenu}
              onClick={() => { if (phone) { setSettingsTab('profile'); setModal('settings'); } else setProfileMenu(!profileMenu); }}
            >
              <Avatar person={me} size={40} online={me.status !== 'invisible'} />
              <span className="dock-identity">
                <b>{shownName(me)}</b>
                <small><CustomStatus person={me} inline fallback={'@'+me.username}/></small>
              </span>
            </button>
            <div className="dock-controls">
              <div className={'dock-split'+(localMuted||localDeafened?' is-muted':'')}>
                <button
                  type="button"
                  aria-pressed={localMuted||localDeafened}
                  title={localMuted||localDeafened ? tr('Unmute Microphone', 'Mikrofon aktivieren') : tr('Mute Microphone', 'Mikrofon stummschalten')}
                  onClick={() => {
                    const next = !(localMuted||localDeafened);
                    setLocalMuted(next);if(!next)setLocalDeafened(false);
                    playMuteToggleSound(next);
                  }}
                >
                  {localMuted||localDeafened ? <MicOff size={18} /> : <Mic size={18} />}
                </button>
                <button type="button" className="dock-chevron" aria-label={tr('Input options','Eingabeoptionen')} aria-expanded={audioMenu==='audioinput'} onClick={()=>setAudioMenu(m=>m==='audioinput'?null:'audioinput')}><ChevronDown size={14}/></button>
              </div>
              <div className={'dock-split'+(localDeafened?' is-muted':'')}>
                <button
                  type="button"
                  aria-pressed={localDeafened}
                  title={localDeafened ? tr('Undeafen', 'Ton aktivieren') : tr('Deafen', 'Ton stummschalten')}
                  onClick={() => {
                    const next = !localDeafened;
                    setLocalDeafened(next);
                    if (next) setLocalMuted(true);
                    playDeafenToggleSound(next);
                  }}
                >
                  {localDeafened ? <HeadphonesOffIcon size={18} /> : <Headphones size={18} />}
                </button>
                <button type="button" className="dock-chevron" aria-label={tr('Output options','Ausgabeoptionen')} aria-expanded={audioMenu==='audiooutput'} onClick={()=>setAudioMenu(m=>m==='audiooutput'?null:'audiooutput')}><ChevronDown size={14}/></button>
              </div>
              <button
                type="button"
                className="dock-icon"
                title={tr('Settings', 'Einstellungen')}
                aria-label={tr('Settings', 'Einstellungen')}
                onClick={() => {
                  setSettingsTab('account');
                  setModal('settings');
                }}
              >
                <Settings size={18} />
              </button>
            </div>
            {audioMenu && <AudioQuickMenu kind={audioMenu} onClose={()=>setAudioMenu(null)} onOpenSettings={()=>{setSettingsTab('voice');setModal('settings');}}/>}
          </div>
        </div>
      </aside>

      <main className={"main-panel " + (call && roomId===call.id && channel?.kind==='voice' ? 'voice-channel-open' : '')}>
        {!hideBanner && (
          <div className="top-announcement-banner">
            <span>{tr('Download our app to stay connected', 'Lade unsere Desktop-App herunter')}</span>
            <a
              href="/downloads/MALVO-Chat-Setup.exe"
              download="MALVO-Chat-Setup.exe"
              className="banner-download-btn"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M0 3.449L9.75 2.1v9.451H0m10.949-9.602L24 0v11.4h-13.051M0 12.6h9.75v9.451L0 20.699M10.949 12.6H24V24l-13.051-1.749" />
              </svg>
              Download
            </a>
            <button
              className="banner-close-btn"
              onClick={() => {
                setHideBanner(true);
                try {
                  localStorage.setItem('hide_win_banner', '1');
                } catch {}
              }}
              title={tr('Close', 'Schließen')}
            >
              <X size={16} />
            </button>
          </div>
        )}
        <header className="main-header">
          <button className="mobile-toggle" aria-label="Navigation" aria-expanded={sidebar} onClick={() => setSidebar(!sidebar)} title="Navigation">
            <Menu />
          </button>
          <div className="page-identity">
            {community?.suspended ? <><Ban size={20}/><b>{community.name}</b></> : roomId ? (
              <>
                {dm?.group ? (
                  <GroupAvatar members={dm.group.members.filter(m => m.id !== me.id)} size={26} />
                ) : dm ? (
                  <Avatar person={dm.person} size={26} />
                ) : channel ? (
                  channelIcon(channel)
                ) : (
                  <Hash size={20} />
                )}
                <b>{channel?.name || shownName(dm?.person) || 'Chat'}</b>{dm&&<OfficialAccountTag person={dm.person}/>}
                {channel?.topic && <span className="topic">{channel.topic}</span>}
              </>
            ) : (
              <>
                <Users size={20} />
                <b>{tr('Friends', 'Freunde')}</b>
                <i className="vertical-divider" />
                <div className="friend-tabs" role="tablist" aria-label="Friends">
                  {[
                    ['online', tr('Online', 'Online')],
                    ['all', tr('All', 'Alle')],
                    ['pending', tr('Pending', 'Ausstehend')],
                    ['blocked', tr('Blocked', 'Blockiert')]
                  ].map(([value, label]) => (
                    <button
                      role="tab"
                      aria-selected={tab === value}
                      className={tab === value ? 'active' : ''}
                      key={value}
                      onClick={() => setTab(value)}
                    >
                      {label}
                      {value === 'pending' && requests.length > 0 && <span className="dot" />}
                    </button>
                  ))}
                  <button
                    role="tab"
                    aria-selected={tab === 'add'}
                    className={'add-friend-btn ' + (tab === 'add' ? 'active' : '')}
                    onClick={() => setTab('add')}
                  >
                    <UserPlus size={15} /> {tr('Add Friend', 'Freund hinzufügen')}
                  </button>
                  <button
                    role="tab"
                    aria-selected={tab === 'bots'}
                    className={'explore-bots-btn ' + (tab === 'bots' ? 'active' : '')}
                    onClick={() => setTab('bots')}
                  >
                    <BotIcon size={15} /> {tr('Explore Bots', 'Bots entdecken')}
                  </button>
                  <button
                    role="tab"
                    aria-selected={tab === 'servers'}
                    className={'explore-bots-btn ' + (tab === 'servers' ? 'active' : '')}
                    onClick={() => setTab('servers')}
                  >
                    <Compass size={15} /> {tr('Explore Servers', 'Server entdecken')}
                  </button>
                </div>
              </>
            )}
          </div>
           <div className="header-actions"><button className="hdr-secondary" title="Support" aria-label="Support" onClick={()=>setModal('moderation-support')}><LifeBuoy size={18}/></button>
            {me.teamAccess&&<button className="team-entry hdr-secondary" title="Team-Verwaltung" onClick={()=>openTeam()}><Shield size={17}/><span>Team</span></button>}
            {dm && !dm.official && (
              <button title={tr('Start Call', 'Anrufen')} onClick={() => startCall(dm.id, shownName(dm.person))}>
                <Phone size={18} />
              </button>
            )}
            {dm?.group && (
              <button className="header-group-settings" title={tr('Group settings', 'Gruppeneinstellungen')} aria-label={tr('Group settings', 'Gruppeneinstellungen')} onClick={() => setModal('group-manage')}>
                <Users size={18} />
              </button>
            )}
            {roomId && (
              <>
                <button className="hdr-secondary" title={tr('Saved Messages', 'Gespeicherte Nachrichten')} onClick={() => setModal('bookmarks')}>
                  <Bookmark size={18} />
                </button>
                <button
                  title={dm?showDmProfile?tr('Hide profile overview','Profilübersicht ausblenden'):tr('Show profile overview','Profilübersicht anzeigen'):tr('Toggle Member List','Mitgliederliste ein-/ausblenden')}
                  aria-pressed={dm?showDmProfile:showMembers}
                  aria-controls={dm?'dm-profile-sidebar':'server-member-sidebar'}
                  className={'member-panel-toggle '+((dm ? showDmProfile : showMembers) ? 'active' : '')}
                  onClick={() => (dm ? setShowDmProfile(!showDmProfile) : setShowMembers(!showMembers))}
                >
                  {dm?(showDmProfile?<PanelRightClose size={19}/>:<PanelRightOpen size={19}/>):<Users size={19}/>} 
                </button>
                <button type="button" className="header-search-pill" title={__t('Search messages','Nachrichten suchen')} onClick={()=>setModal('message-search')}><Search size={15}/><span>{__t('Search messages','Nachrichten suchen')}</span></button>
                <button type="button" className="hdr-secondary" title={__t('Your mentions','Deine Erwähnungen')} onClick={()=>setModal('mentions')}><AtSign size={18}/></button>
              </>
            )}
            {phone&&<details className="mobile-chat-more" onClick={event=>{if((event.target as HTMLElement).closest('button'))event.currentTarget.open=false}}><summary aria-label={tr('More chat actions','Weitere Chataktionen')}><MoreHorizontal size={22}/></summary><div className="mobile-header-menu">{community&&<button type="button" onClick={()=>{setSidebar(false);setShowMembers(true)}}><Users size={18}/>{tr('Members','Mitglieder')}</button>}
              <button type="button" onClick={()=>setModal('message-search')}><Search size={18}/>{tr('Search messages','Nachrichten suchen')}</button>
              <button type="button" onClick={()=>setModal('mentions')}><AtSign size={18}/>{tr('Your mentions','Deine Erwähnungen')}</button>
              <button type="button" onClick={()=>setModal('bookmarks')}><Bookmark size={18}/>{tr('Saved messages','Gespeicherte Nachrichten')}</button>
              {dm?.group&&<button type="button" onClick={()=>setModal('group-manage')}><Users size={18}/>{tr('Group settings','Gruppeneinstellungen')}</button>}
              {dm?.group&&<button type="button" disabled={groupPinBusy} onClick={()=>toggleGroupPin(dm)}><GroupPin size={18}/>{pinnedGroups.includes(dm.id)?tr('Unpin group','Gruppe lösen'):tr('Pin group','Gruppe anpinnen')}</button>}
              <button type="button" onClick={()=>setModal('moderation-support')}><LifeBuoy size={18}/>Support</button>
              {me.teamAccess&&<button type="button" onClick={()=>openTeam()}><Shield size={18}/>Team-Dashboard</button>}
            </div></details>}
          </div>
        </header>

        {error && (
          <div className="alert error" role="alert">
            <Shield size={17} />
            <span>{error}</span>
            <button title={tr('Close', 'Schließen')} onClick={() => setError('')}>
              <X size={16} />
            </button>
          </div>
        )}

        {incoming&&<IncomingCallNotice
          avatar={incoming.group?<GroupAvatar members={(data.conversations.find(c=>c.id===incoming.roomId)?.group?.members||[incoming.from]).filter(m=>m.id!==me.id)} size={36}/>:<Avatar person={incoming.from} size={36}/>}
          name={incoming.group?.name||shownName(incoming.from)}
          description={incoming.group?shownName(incoming.from)+tr(' is calling',' ruft an'):tr('Voice call','Sprachanruf')}
          silent={me.status==='dnd'} soundBlocked={incomingSoundBlocked} onEnableSound={armSound}
          onDismiss={()=>{callDismissals.dismiss(incoming.roomId);stopRingtone();setIncoming(null)}}
          onDecline={()=>{const rid=incoming.roomId;callDismissals.dismiss(rid);stopRingtone();setIncoming(null);void api('/rooms/'+rid+'/call/reject','POST').catch(e=>setError(e.message))}}
          onAnswer={()=>{const d=incoming;setIncoming(null);void startCall(d.roomId,d.group?.name||shownName(d.from))}}
        />}

        {/* Bild 3 & Bild 5: Voice Call Stage (either docked at the top of chat like Bild 3, or full 2-card stage like Bild 5) */}
        {call && (
          <div {...(!callMinimized&&modal!=='call'&&call.id!==roomId?miniFloating.handlers:{})} ref={miniFloating.ref} style={callMinimized||modal!=='call'&&call.id!==roomId?miniFloating.style:({'--call-dock-h':dockHeight?dockHeight+'px':undefined} as React.CSSProperties)} className={callMinimized ? 'call-mini-window' : modal === 'call' ? 'call-full' : roomId===call.id ? (channel?.kind==='voice' ? 'call-channel-stage' : 'call-dock-top') : 'call-pip'+(pipClosed?' pip-closed':'')} onClickCapture={e=>{if(miniFloating.dragged.current){miniFloating.dragged.current=false;e.stopPropagation();e.preventDefault();return}if(!callMinimized&&modal!=='call'&&roomId!==call.id&&!(e.target as HTMLElement).closest('button,input,[role=dialog]')){e.stopPropagation();e.preventDefault();goToCall();}}} title={!callMinimized&&modal!=='call'&&roomId!==call.id?tr('Back to the call','Zurück zum Anruf'):undefined}>
            {!callMinimized&&modal!=='call'&&roomId!==call.id&&<button type="button" className="pip-close" title={tr('Hide preview','Vorschau ausblenden')} aria-label={tr('Hide preview','Vorschau ausblenden')} onClick={e=>{e.stopPropagation();setPipClosed(true);}}><X size={14}/></button>}
            <Voice key={call.id}
              me={me}
              muted={localMuted} deafened={localDeafened}
              onMutedChange={setLocalMuted} onDeafenedChange={setLocalDeafened}
              floating={callMinimized||modal!=='call'&&roomId!==call.id} dragHandlers={miniFloating.handlers} minimized={callMinimized} onMinimize={()=>{setCallMinimized(v=>!v);setModal(null);}}
              peer={callPeer}
              waiting={callWaiting}
              ringing={data.conversations.find(c=>c.id===call.id)?.group?callRinging||[]:callRinging}
              members={members}
              roster={voiceRosters[call.id]||[]}
              roomId={call.id}
              name={call.name}
              isExpanded={modal === 'call'}
              soundboardUsers={soundboardUsers}
              speakingUsers={speakingUsers}
              onSpeakersChange={setSpeakingUsers}
              onParticipantLeft={(id)=>{voiceRosterGate.current?.invalidate();setVoiceRosters(prev=>({...prev,[call.id]:(prev[call.id]||[]).filter(u=>u.id!==id)}))}}
              onParticipantsChange={participants=>{voiceRosterGate.current?.invalidate();setVoiceRosters(prev=>{
                const known=new Map([me,...members,...(prev[call.id]||[])].map(p=>[p.id,p]));
                return {...prev,[call.id]:[known.get(me.id)||me,...participants.map(p=>({...known.get(p.id),id:p.id,username:known.get(p.id)?.username||p.name,displayName:p.name,avatar:p.avatar,color:p.color}))] as Person[]};
              })}}
              onClose={() => {
                voiceRosterGate.current?.invalidate();
                const rid = call.id;
                setVoiceRosters(prev=>({...prev,[rid]:(prev[rid]||[]).filter(u=>u.id!==me.id)}));
                stopRingtone();
                playCallLeaveSound(me.status);
                setIncoming(null);
                setCall(null);
                setModal(null);
                // The voice component releases only its own admission during cleanup.
              }}
              onExpand={() => {setCallMinimized(false);setModal(modal === 'call' ? null : 'call');}}
              onOpenProfile={id => {
                const p = id === me.id ? me : members.find(m => m.id === id) || (callPeer?.id === id ? callPeer : null);
                if (p) { setPerson(p); setModal('profile'); }
              }}
              onMessage={id=>{if(id===me.id)return;const found=findCallParticipant(id,voiceRosters[call.id]||[],members,callPeer,data.conversations,call.id,data.friends,data.conversations);void (async()=>{try{const person=found||await api('/users/id/'+encodeURIComponent(id));setCallMinimized(true);await openDM(person)}catch(error){setError((error as Error).message)}})()}}
              onError={setError}
              onMemberActions={(()=>{const cc=data.communities.find(c=>c.channels.some(ch=>ch.id===call.id)),caps:any=cc?.capabilities||{};return cc&&(cc.role==='owner'||caps.moderateMembers||caps.moveMembers||caps.muteMembers||caps.deafenMembers||caps.kickMembers||caps.banMembers||caps.manageRoles)?(e:React.MouseEvent,id:string,anchor:{x:number;y:number})=>{const p=members.find(m=>m.id===id)||(voiceRosters[call.id]||[]).find(u=>u.id===id);if(p)openMemberContextMenu(e,p as Person,anchor);}:undefined})()}
            />
            {!callMinimized&&modal!=='call'&&roomId===call.id&&channel?.kind!=='voice'&&<div className="call-dock-resizer" role="separator" aria-orientation="horizontal" title={tr('Drag to resize','Ziehen zum Ändern der Größe')} onPointerDown={e=>{e.preventDefault();const box=(e.currentTarget.parentElement as HTMLElement).getBoundingClientRect();const top=box.top;const move=(ev:PointerEvent)=>{const h=Math.round(Math.min(window.innerHeight*0.8,Math.max(180,ev.clientY-top-24)));setDockHeight(h);};const up=()=>{window.removeEventListener('pointermove',move);window.removeEventListener('pointerup',up);setDockHeight(h=>{try{if(h)localStorage.setItem('malvo-call-dock-height',String(h))}catch{}return h;});};window.addEventListener('pointermove',move);window.addEventListener('pointerup',up);}} onDoubleClick={()=>{setDockHeight(0);try{localStorage.removeItem('malvo-call-dock-height')}catch{}}}><span/></div>}
          </div>
        )}

        {callMinimized&&call&&channel?.kind==='voice'&&roomId===call.id&&<div className="voice-minimized-placeholder"><PictureInPicture2 size={30}/><strong>{call.name}</strong><button type="button" onClick={()=>setCallMinimized(false)}>{tr('Open call','Anruf öffnen')}</button></div>}
        {community?.suspended ? <ServerRestrictionInfo server={community} request={api} onManage={me.isOwnerAdmin?()=>openTeam('servers',community.id):undefined}/> : !roomId && tab === 'bots' ? (
          <ExploreBots request={api} />
        ) : !roomId && tab === 'servers' ? (
          <Discovery request={api} onBack={closeDiscovery} onOpen={async id=>{const next=await refresh(),server=next.communities.find((c:Community)=>c.id===id);if(server)selectRoom(lastChannelOf(server),server.id)}}/>
        ) : !roomId ? (
          <FriendsView
            tab={tab}
            data={data}
            me={me}
            request={api}
            refresh={async () => {
              await refresh();
            }}
            onRename={p=>setNamingPerson(p)}
            onMessage={p => openDM(p)}
            onProfile={p => {
              setPerson(p);
              setModal('profile');
            }}
            onRemove={f => {
              setManagedFriend(f);
              setModal('friend-remove');
            }}
            onOpenMenu={(x, y, actions) => setContext({ x, y, actions })}
          />
        ) : (
          <div className="chat-layout">
            <section className={'conversation'+(dm?.official?' announcement-conversation':'')} key={roomId}>
              {dm?.official&&<OfficialSafetyNotice compact/>}
              {e2eeOpen&&dm&&<E2eeDialog api={api} roomId={dm.id} me={me} people={dm.group?.members||[dm.person,me]} onClose={()=>{setE2eeOpen(false);void refresh();}}/>}
              {!community && dm && roomId && call?.id !== roomId && (voiceRosters[roomId] || []).length > 0 && (() => {
                // Someone is in this DM/group call while I'm not: show who and offer to join.
                const inCall = voiceRosters[roomId] || [];
                const names = inCall.slice(0, 3).map(u => shownName(u)).join(', ') + (inCall.length > 3 ? ' +' + (inCall.length - 3) : '');
                return <div className="dm-call-bar" role="status">
                  <span className="dm-call-bar-faces">{inCall.slice(0, 4).map(u => <img key={u.id} src={avatarSrc(u) || '/icon.png'} alt="" />)}</span>
                  <span className="dm-call-bar-text"><b>{names}</b><small>{inCall.length === 1 ? tr('is in the call', 'ist im Anruf') : tr('are in the call', 'sind im Anruf')}</small></span>
                  <button type="button" className="dm-call-bar-join" onClick={() => startCall(roomId, dm.group?.name || shownName(dm.person))}><Phone size={15} />{tr('Join', 'Beitreten')}</button>
                </div>;
              })()}
              <div
                className="message-list"
                data-room-id={roomId}
                ref={messageList}
              >
                {messages.length >= 30 && !historyStart[roomId || ''] && (
                  <button
                    className="older"
                    onClick={() =>
                      action(async () => {
                        const generation=roomGeneration.current;const older = await api('/rooms/' + roomId + '/messages?beforeId=' + messages[0].id);
                        if(activeRef.current!==roomId||generation!==roomGeneration.current)return;
                        const list=messageList.current,bounds=list?.getBoundingClientRect(),scale=bounds&&list?bounds.height/(list.offsetHeight||bounds.height||1):1,anchor=list&&bounds?[...list.querySelectorAll<HTMLElement>('article.message[id]')].find(el=>{const r=el.getBoundingClientRect();return r.bottom>bounds.top+1&&r.top<bounds.bottom}):null,offset=anchor&&bounds?(anchor.getBoundingClientRect().top-bounds.top)/scale:0;
                        flushSync(()=>setMessages(prev=>[...older,...prev.filter(m=>!older.some((old:Message)=>old.id===m.id))]));
                        if(anchor)historyControl.current?.restore(anchor.id.replace(/^message-/,''),offset);
                        if (older.length < 60) setHistoryStart(prev => ({ ...prev, [roomId!]: true }));
                        if (!older.length)
                          setNotice(tr('You reached the start of the conversation.', 'Du bist am Anfang des Verlaufs.'));
                      })
                    }
                  >
                    {tr('Load older messages', 'Ältere Nachrichten laden')}
                  </button>
                )}
                <div className="chat-intro flackle-chat-intro">
                  <h1>{dm ? shownName(dm.person) : '# ' + channel?.name} {dm && <IdentityBadges person={dm.person}/>}</h1>
                  <p>
                    {dm?.group ? (
                      <>
                        {tr('This is the beginning of the group', 'Das ist der Anfang der Gruppe')} <b>{shownName(dm.person)}</b> · {dm.group.members.map(m => shownName(m)).join(', ')}
                      </>
                    ) : dm ? (
                      <>
                        {tr('This is the beginning of your direct message history with', 'Das ist der Anfang deines Gesprächs mit')}{' '}
                        <b>{shownName(dm.person)}</b>.
                      </>
                    ) : (
                      <>
                        {tr('This is the beginning of the', 'Das ist der Anfang des Kanals')}{' '}
                        <b>#{channel?.name}</b> {tr('channel.', '')}
                      </>
                    )}
                  </p>
                </div>
                <VirtualMessages control={historyControl} items={displayMessages}>{(m, idx) => {
                  const author = m.author || FALLBACK_PERSON;
                  const memberObj = members.find(x => x.id === author.id);
                  const authorColor =
                    memberObj?.roleColor ||
                    (author.id === 'malvo-system' || author.username?.toLowerCase() === 'malvo' ? '#ef5252' : undefined);
                  const replyAuthor = m.replyTo?.author || FALLBACK_PERSON;
                  const canDelete = !dm?.official&&(m.authorId === me.id || canManageServer);
                  const prevMsg = idx > 0 ? displayMessages[idx - 1] : null;
                  const isConsecutive =
                    !contactBlocked(author.id) && prevMsg &&
                    prevMsg.authorId === m.authorId &&
                    !m.replyTo &&
                    !m.interaction &&
                    new Date(m.created).toDateString()===new Date(prevMsg.created).toDateString() &&
                    (new Date(m.created).getTime() - new Date(prevMsg.created).getTime() < 60000);
                  const isMentioned =
                    me &&
                    m.body &&
                    (m.body.includes('<@'+me.id+'>') || m.body.includes('@everyone') ||
                      m.body.includes('@here') ||
                      m.body.toLowerCase().includes('@' + me.username.toLowerCase()));
                  if(contactBlocked(author.id)&&!messageRevealed(m.id))return <article id={'message-'+m.id} key={m.id} className="blocked-message-placeholder"><button type="button" className="blocked-message-toggle" aria-expanded={false} onClick={()=>revealBlocked(m.id)}>{tr('Blocked message','Blockierte Nachricht')} · {tr('Show','Anzeigen')}</button></article>;
                  return (
                    <article
                      className={'message ' + (m.replyTo?'message-with-reply ':'') + (isConsecutive ? 'message-compact ' : '') + (isMentioned ? 'is-mentioned ' : '') + (m.ephemeral ? 'is-ephemeral ' : '') + (m.pending ? 'is-pending ' : '')}
                      id={'message-' + m.id}
                      key={m.id}
                      onContextMenu={e => openMessageContextMenu(e, m)}
                    >
                      {isConsecutive ? (
                        <span className="compact-timestamp">
                          {new Date(m.created).toLocaleTimeString(lang === 'de' ? 'de-DE' : 'en-US', {
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </span>
                      ) : (
                        <Avatar
                          person={author}
                          onClick={() => {
                            setPerson(memberObj || author);
                            setModal('profile');
                          }}
                        />
                      )}
                      <div className="message-content">{contactBlocked(author.id)&&<button type="button" className="blocked-message-toggle" aria-expanded={true} onClick={()=>revealBlocked(m.id)}>{tr('Hide blocked message','Blockierte Nachricht verbergen')}</button>}
                        {m.interaction && (
                          <div className="message-interaction">
                            <Avatar person={m.interaction.user} size={16} />
                            <b>{shownName(m.interaction.user)}</b>
                            <span>{tr('used', 'hat')}</span>
                            <code>/{m.interaction.command}</code>
                            <span>{tr('', 'verwendet')}</span>
                          </div>
                        )}
                        {m.replyTo && contactBlocked(replyAuthor.id)&&!messageRevealed(m.replyTo.id)&&<button type="button" className="blocked-message-toggle message-reply-preview blocked-reply-placeholder" onClick={()=>revealBlocked(m.replyTo!.id)}>{tr('Blocked reply · Show','Blockierte Antwort · Anzeigen')}</button>}
                        {m.replyTo && (!contactBlocked(replyAuthor.id)||messageRevealed(m.replyTo.id)) && (
                          <div
                            className="message-reply-preview"
                            title={tr('Click to jump to message', 'Klicken, um zur Nachricht zu springen')}
                            onClick={() => {
                              const el = document.getElementById('message-' + m.replyTo!.id);
                              const list = el?.closest('.message-list') as HTMLElement | null;
                              if (el && list) {
                                list.scrollTo({ top: el.offsetTop - list.clientHeight / 2 + el.offsetHeight / 2, behavior: 'smooth' });
                                el.classList.add('message-highlight');
                                setTimeout(() => el.classList.remove('message-highlight'), 1800);
                              }
                            }}
                          >
                            <svg
                              className="reply-spine"
                              width="28"
                              height="18"
                              viewBox="0 0 28 18"
                              fill="none"
                              style={{ flexShrink: 0, color: 'rgba(255,255,255,0.25)' }}
                            >
                              <path
                                d="M 6 16 L 6 8 Q 6 3 12 3 L 26 3"
                                stroke="currentColor"
                                strokeWidth="1.75"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            <Avatar person={replyAuthor} size={16} />
                            <b className={'reply-author'+(m.replyPing?' is-ping':'')}>@{shownName(replyAuthor)}</b>
                            <span className="reply-snippet">
                              {replyPreview(m.replyTo.body,resolveUserName)}
                            </span>
                          </div>
                        )}
                        {!isConsecutive && (
                        <div className="message-meta">
                          <button
                            style={{ color: authorColor }}
                            onClick={() => {
                              setPerson(memberObj || author);
                              setModal('profile');
                            }}
                          >
                            <RoleName role={{color:authorColor,colorSecondary:memberObj?.roleColorSecondary}}>{shownName(author)}</RoleName>
                          </button>
                          <StaffMark person={author} />
                          {author.bot ? <BotTag verified={author.appVerified} /> : null}
                          {author.webhook&&<span className="webhook-badge">WEBHOOK</span>}<IdentityBadges person={author}/>
                          <time dateTime={new Date(m.created).toISOString()}>
                            {new Date(m.created).toLocaleString(lang === 'de' ? 'de-DE' : 'en-US', {
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                          </time>
                          {m.edited && <small>{tr('edited', 'bearbeitet')}</small>}
                        </div>
                        )}
                        {editing?.id === m.id ? (
                          <div className="inline-edit">
                            <textarea
                              autoFocus
                              value={editing.text}
                              maxLength={4000}
                              rows={Math.min(8, editing.text.split('\n').length)}
                              aria-label={tr('Edit message', 'Nachricht bearbeiten')}
                              onFocus={e => e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)}
                              onChange={e => setEditing({ ...editing, text: e.target.value })}
                              onKeyDown={e => {
                                if (e.key === 'Escape') { e.preventDefault(); setEditing(null); }
                                if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); void saveEdit(); }
                              }}
                            />
                            <small>{tr('Escape to', 'Escape zum')} <button type="button" onClick={() => setEditing(null)}>{tr('cancel', 'Abbrechen')}</button> · {tr('Enter to', 'Enter zum')} <button type="button" disabled={editing.saving} onClick={() => void saveEdit()}>{tr('save', 'Speichern')}</button></small>
                          </div>
                        ) : m.callEvent?<CallHistoryMessage event={m.callEvent} own={m.callEvent.callerId===me.id}/>:m.poll?<PollMessage message={m} request={api} canVote={!!dm&&!dm.official||!!channel?.capabilities?.add_reactions} canClose={m.authorId===me.id||!!channel?.capabilities?.manage_messages||!!(dm?.group as any)?.canManage}/>:renderFormattedMessageBody(m.body, joinByCode, openMentionProfile, setBotInvite)}
                        <MessageEmbeds embeds={m.embeds} renderText={s => renderFormattedMessageBody(s, joinByCode, openMentionProfile, setBotInvite)} />
                        <MessageComponents components={m.components} renderText={s => renderFormattedMessageBody(s, joinByCode, openMentionProfile, setBotInvite)} onAction={async (customId, values) => { try { setError(''); await api((m.ephemeral ? '/ephemeral/' + m.id.replace(/^ephemeral-/, '') : '/messages/' + m.id) + '/components', 'POST', { custom_id: customId, values: values || [] }); } catch (e) { setError((e as Error).message); } }} />
                        {m.ephemeral && <small className="ephemeral-note">{tr('Only you can see this', 'Nur du kannst das sehen')}</small>}
                        <InviteEmbed text={m.body} onJoin={joinByCode} joinedCommunityIds={data.communities.map(c=>c.id)} />
                        {renderMessageMedia(m.body, u => setLightbox({ src: u }), (e,u)=>imageMenu(e,u))}
                        {[...(m.file?[m.file]:[]),...(m.files||[])].map(file=><React.Fragment key={file.id}>{file &&
                          (file.mime.startsWith('image/') ? (
                            <img
                              className="attachment-image clickable-image"
                              src={((file as FileInfo).url||'/api/files/' + file.id)}
                              alt={file.name}
                              onContextMenu={e=>imageMenu(e,((file as FileInfo).url||'/api/files/'+file.id),file.name)}
                              onClick={() => setLightbox({ src: ((file as FileInfo).url||'/api/files/' + file.id), name: file.name })}
                            />
                          ) : file.mime.startsWith('video/') ? (
                            <VideoPlayer src={((file as FileInfo).url||'/api/files/' + file.id)} name={file.name} />
                          ) : file.mime.startsWith('audio/') ? (
                            <AudioPlayer src={((file as FileInfo).url||'/api/files/' + file.id)} name={file.name} />
                          ) : (
                            <a className="attachment-file" href={((file as FileInfo).url||'/api/files/' + file.id)} download={file.name}>
                              <Download size={18} />
                              {file.name}
                              <small>{(file.size / 1024).toFixed(0)} KB</small>
                            </a>
                          ))}</React.Fragment>)}
                        {!!m.pinned&&<small className="official-pinned-label">{tr('Pinned official message','Angepinnte offizielle Nachricht')}</small>}
                        {!!m.reactions.length && (
                          <div className="reactions">
                            {[...new Set(m.reactions.map(r => r.emoji))].map(em => (
                              <button
                                className={m.reactions.some(r => r.emoji === em && r.userId === me.id) ? 'mine' : ''}
                                key={em}
                                title={m.reactions.filter(r => r.emoji === em).map(r => r.userId === me.id ? tr('You', 'Du') : members.find(x => x.id === r.userId)?.displayName || (dm?.person.id === r.userId ? shownName(dm.person) : '…')).slice(0, 12).join(', ')}
                                onContextMenu={e => { e.preventDefault(); e.stopPropagation(); setContext({ x: e.clientX, y: e.clientY, actions: [{ label: tr('View reactions', 'Reaktionen ansehen'), icon: <Users size={15} />, run: () => setModal('reactions:' + m.id + ':' + em) }] }); }}
                                onClick={() =>
                                  action(async () => {
                                    await api('/messages/' + m.id + '/reactions', 'POST', { emoji: em });
                                  })
                                }
                              >
                                <EmoteGlyph value={em}/> {m.reactions.filter(r => r.emoji === em).length}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                      <div
                        className={'message-floating-bar ' + (shiftHeld && canDelete ? 'shift-delete-mode' : '')}
                        role="toolbar"
                        aria-label="Actions"
                      >
                        {shiftHeld && canDelete ? (
                          <button
                            type="button"
                            className="floating-tool-btn shift-quick-delete-btn"
                            title={tr('Instant Delete (Shift)', 'Sofort löschen (Shift)')}
                            onClick={() =>
                              action(async () => {
                                await api('/messages/' + m.id, 'DELETE');
                                await loadMessages(roomId!);
                              })
                            }
                          >
                            <Trash2 size={15} />
                            <span>{tr('Quick Delete', 'Sofort löschen')}</span>
                          </button>
                        ) : (
                          <>
                            {(m.suggestedReactions||['👍', '❤️', '😂']).map(em => (
                              <button
                                key={em}
                                className="floating-tool-btn"
                                title={tr('React with ', 'Reagieren mit ') + em}
                                onClick={() =>
                                  action(async () => {
                                    await api('/messages/' + m.id + '/reactions', 'POST', { emoji: em });
                                  })
                                }
                              >
                                {em}
                              </button>
                            ))}
                            <span className="floating-bar-sep" />
                            <button
                              className="floating-tool-btn"
                              title={tr('Add Reaction', 'Reaktion auswählen')} aria-label={tr('Choose any reaction','Andere Emoji-Reaktion auswählen')}
                              onClick={e => {
                                const r=e.currentTarget.getBoundingClientRect();setReactionAnchor({x:r.left,y:r.top});
                                setEmojiTab('emoji');
                                setEmoji(m.id);
                              }}
                            >
                              <SmilePlus size={15} />
                            </button>
                            <button
                              className="floating-tool-btn"
                              title={tr('Reply', 'Antworten')}
                              onClick={() => {
                                setReplyTo({ id: m.id, author, body: m.body });
                                (document.querySelector('.composer textarea') as HTMLElement)?.focus();
                              }}
                            >
                              <CornerDownRight size={15} />
                            </button>
                            <button
                              className="floating-tool-btn"
                              title={tr('Copy Text', 'Text kopieren')}
                              onClick={() =>
                                action(async () => {
                                  await copyToClipboard(m.body);
                                  setNotice(tr('Text copied.', 'Text kopiert.'));
                                })
                              }
                            >
                              <Copy size={15} />
                            </button>
                            {m.authorId === me.id && !m.callEvent && (
                              <button
                                className="floating-tool-btn"
                                title={tr('Edit', 'Bearbeiten')}
                                onClick={() => startEdit(m)}
                              >
                                <Pencil size={15} />
                              </button>
                            )}
                            {canDelete && (
                              <button
                                className="floating-tool-btn danger-tool-btn"
                                title={tr('Delete Message', 'Nachricht löschen')}
                                onClick={() => setModal('delete:' + m.id)}
                              >
                                <Trash2 size={15} />
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    </article>
                  );
                }}</VirtualMessages>
                <div aria-hidden="true" />
              </div>

              <div className={'composer-wrap composer-drop-area'+(fileOver?' is-file-over':'')} onDragEnter={e=>{if(!e.dataTransfer.types.includes('Files'))return;e.preventDefault();fileDragDepth.current++;if(canWriteInChannel)setFileOver(true)}} onDragOver={e=>{if(e.dataTransfer.types.includes('Files')){e.preventDefault();e.dataTransfer.dropEffect=canWriteInChannel?'copy':'none'}}} onDragLeave={e=>{if(!e.dataTransfer.types.includes('Files'))return;fileDragDepth.current=Math.max(0,fileDragDepth.current-1);if(!fileDragDepth.current)setFileOver(false)}} onDrop={e=>{if(!e.dataTransfer.types.includes('Files'))return;e.preventDefault();fileDragDepth.current=0;setFileOver(false);if(!canWriteInChannel)return;void attachFiles(Array.from(e.dataTransfer.files))}}>
                <JumpToLatest list={messageList} force={linkedHistory.current?.roomId===roomId} onJump={()=>{linkedHistory.current=null;pendingJump.current=null;setLinkedMessage(null);history.replaceState({},'',pathFor(activeCommunity,roomId));void loadMessages(roomId!).then(()=>{const list=messageList.current;if(list)requestAnimationFrame(()=>{list.scrollTop=list.scrollHeight})})}}/>
                {fileOver&&<div className="composer-file-overlay"><span><Paperclip size={22}/>{tr('Drop to upload','Zum Hochladen ablegen')}</span></div>}
                <div className="typing">
                  {typing && (
                    <>
                      <span className="typing-dots">
                        <i />
                        <i />
                        <i />
                      </span>
                      {typing}
                    </>
                  )}
                </div>
                {!canWriteInChannel ? (
                  <div className="flackle-readonly-bar">
                    <Lock size={16} />
                    <span>
                      {dm?.contactBlocked?(contactBlocked(dm.person.id)?tr('You blocked this contact. Unblock them to send messages.','Du hast diesen Kontakt blockiert. Hebe die Blockierung auf, um zu schreiben.'):tr('You cannot send messages to this contact right now.','Du kannst diesem Kontakt derzeit keine Nachrichten senden.')):community?.timeoutUntil&&community.timeoutUntil>Date.now()?tr('You are in timeout until ','Du bist im Timeout bis ')+new Date(community.timeoutUntil).toLocaleString():dm?.official ? tr('Official MALVO announcements · replies are disabled.','Offizielle MALVO-Ankündigungen · Antworten sind deaktiviert.') : tr('You do not have permission to send messages in this channel.','Du hast keine Berechtigung, in diesem Kanal Nachrichten zu senden.')}
                    </span>
                  </div>
                ) : (
                  <>
<ComposerScope emotes={customEmotes} userId={me.id} roomId={roomId!} members={community?[...members,...(community.roles||[]).map(r=>({id:'role:'+r.id,username:r.name,displayName:r.name,roleMention:true}))]:dm?.group?.members||[me,...(dm?[dm.person]:[])]} channels={data.communities.flatMap(c=>c.channels.map(ch=>({...ch,communityName:c.name})))} control={draftControl} onTyping={active=>socket?.emit('typing',{roomId,typing:active})}>{({draft,setDraft,draftSaved,composerRef,insertFormatting,items,index,pick,change,handleSuggestionKey,stopTyping,setCursor})=><>
                    {attachment && (<>
                      <div className={'attachment-preview' + (attachment.mime?.startsWith('image/') ? ' has-image' : '')}>
                        {attachment.mime?.startsWith('image/')
                          ? <img className="attachment-thumb" src={attachment.url||'/api/files/' + attachment.id} alt="" />
                          : <Paperclip size={15} />}
                        <span className="attachment-name">{attachment.name}</span>
                        {attachmentSource?.id===attachment.id&&/^(image\/(png|jpeg|webp))$/.test(attachmentSource.file.type)&&<button type="button" disabled={uploadProgress!==null} onClick={()=>setCropAttachment(attachmentSource.file)}>{tr('Crop image','Bild zuschneiden')}</button>}
                        <button title={tr('Remove attachment', 'Anhang entfernen')} onClick={() => {setAttachment(extraAttachments[0]||null);setExtraAttachments(old=>old.slice(1))}}>
                          <X size={15} />
                        </button>
                      </div>
                      {attachment.mime?.startsWith('audio/') && <AudioPlayer src={'/api/files/' + attachment.id} name={attachment.name} />}
                    </>)}
                    {!!extraAttachments.length&&<div className="attachment-extras">{extraAttachments.map(extra=><div className="attachment-extra" key={extra.id}><Paperclip size={13}/><span>{extra.name}</span><button type="button" title={tr('Remove attachment','Anhang entfernen')} aria-label={tr('Remove attachment','Anhang entfernen')} onClick={()=>setExtraAttachments(old=>old.filter(x=>x.id!==extra.id))}><X size={13}/></button></div>)}</div>}
                    {(uploadProgress !== null||uploadBatch) && (
                      <div className="upload-progress has-cancel">
                        <span style={{ width: (uploadProgress??0) + '%' }} />
                        <em>{uploadBatch&&uploadBatch.total>1?`${uploadBatch.index}/${uploadBatch.total} · `:''}Upload {uploadProgress??0}%</em>
                        {uploadBatch&&<button type="button" className="upload-cancel" onClick={()=>uploadAbort.current?.abort()}>{tr('Cancel','Abbrechen')}</button>}
                      </div>
                    )}
                    {replyTo && (
                      <div className="composer-reply-bar">
                        <div className="reply-bar-content">
                          <CornerDownRight size={14} className="reply-bar-icon" />
                          <span className="reply-bar-text">
                            {tr('Replying to', 'Antwort an')} <b>@{shownName(replyTo.author) || 'MALVO'}</b>:{' '}
                            <small>
                              {replyPreview(replyTo.body,resolveUserName)}
                            </small>
                          </span>
                        </div>
                        <button type="button" className={'reply-ping-toggle'+(replyPing?' is-on':'')} aria-pressed={replyPing} title={replyPing?tr('Notify the author: on','Verfasser benachrichtigen: an'):tr('Notify the author: off','Verfasser benachrichtigen: aus')} aria-label={tr('Notify reply author','Verfasser der Antwort benachrichtigen')} onClick={()=>setReplyPing(v=>!v)}>@</button>
                        <button
                          type="button"
                          className="reply-bar-close"
                          onClick={() => setReplyTo(null)}
                          title={tr('Cancel reply', 'Antwort abbrechen')}
                        >
                          <X size={15} />
                        </button>
                      </div>
                    )}
                    <div className="composer-channel flackle-format-bar">
                      <div className="composer-toolbar">
                        <button
                          type="button"
                          title={tr('Chat Settings', 'Chat-Einstellungen')}
                          onClick={() => {
                            setSettingsTab('chat');
                            setModal('settings');
                          }}
                        >
                          <Settings size={14} />
                        </button>
                        <button type="button" title={tr('Mention (@)', 'Erwähnen (@)')} onClick={() => insertFormatting('@', '')}>
                          <AtSign size={14} />
                        </button>
                        <button type="button" title={tr('Bold (**text**)', 'Fett (**text**)')} onClick={() => insertFormatting('**', '**')}>
                          <Bold size={14} />
                        </button>
                        <button type="button" title={tr('Italic (*text*)', 'Kursiv (*text*)')} onClick={() => insertFormatting('*', '*')}>
                          <Italic size={14} />
                        </button>
                        <button
                          type="button"
                          title={tr('Underline (__text__)', 'Unterstrichen (__text__)')}
                          onClick={() => insertFormatting('__', '__')}
                        >
                          <Underline size={14} />
                        </button>
                        <button
                          type="button"
                          title={tr('Strikethrough (~~text~~)', 'Durchgestrichen (~~text~~)')}
                          onClick={() => insertFormatting('~~', '~~')}
                        >
                          <Strikethrough size={14} />
                        </button>
                        <button type="button" title={tr('Insert Link', 'Link einfügen')} onClick={() => insertFormatting('https://', '')}>
                          <Link2 size={14} />
                        </button>
                      </div>
                    </div>
                    {plusMenu && (
                      <>
                        <button
                          type="button"
                          className="profile-menu-dismiss"
                          onClick={() => {
                            // The quick second click of a double click on "+" can land here: open the file picker then.
                            if (Date.now() - plusClickAt.current < 400) { plusClickAt.current = 0; setPlusMenu(false); fileInput.current?.click(); return; }
                            setPlusMenu(false);
                          }}
                          aria-label="Close menu"
                        />
                        <div className={'composer-plus-popover '+(plusClosing?'is-closing':'')} role="menu">{(channel?.capabilities?.create_polls||!!dm&&!dm.official)&&<button type="button" role="menuitem" onClick={()=>{setPlusMenu(false);setPollRoom(roomId)}}><MessageCircle size={17}/>{tr('Create poll','Umfrage erstellen')}</button>}
                          <button
                            type="button"
                            role="menuitem"
                            onClick={() => {
                              setPlusMenu(false);
                              setSettingsTab('chat');
                              setModal('settings');
                            }}
                          >
                            <Settings size={17} />
                            <span>{tr('Chat Settings', 'Chat-Einstellungen')}</span>
                          </button>
                          <button
                            type="button"
                            role="menuitem"
                            onClick={() => {
                              setPlusMenu(false);
                              fileInput.current?.click();
                            }}
                          >
                            <FileUp size={17} />
                            <span>{tr('Upload a File', 'Datei hochladen')}</span>
                          </button>
                          <button
                            type="button"
                            role="menuitem"
                            onClick={() => {
                              setPlusMenu(false);
                              mediaInput.current?.click();
                            }}
                          >
                            <Image size={17} />
                            <span>{tr('Send Image or Video', 'Bild oder Video senden')}</span>
                          </button>
                        </div>
                      </>
                    )}
                    {sendWarning && <div className="send-rate-warning" role="alert">{sendWarning}</div>}
                    {pollRoom===roomId&&roomId&&(channel?.capabilities?.create_polls||!!dm&&!dm.official)&&<PollComposer request={api} roomId={roomId} onClose={()=>setPollRoom(null)} onCreated={m=>{if(activeRef.current===roomId)setMessages(old=>mergeSentMessage(old,m,''));if(channel?.slowmodeSeconds&&!channel.capabilities?.manage_messages)cooldown.mark(roomId,Date.now()+channel.slowmodeSeconds*1000)}}/>}
                    {!!channel?.slowmodeSeconds&&!channel.capabilities?.manage_messages&&<ChatCooldown until={cooldown.until} duration={channel.slowmodeSeconds}/>}
                    {!draftSaved&&<small role="status">{tr('Draft saved for this session only.','Entwurf nur für diese Sitzung gespeichert.')}</small>}
                    <form className="composer flackle-composer" onSubmit={send}>
                      <input
                        ref={fileInput}
                        type="file"
                        hidden
                        multiple
                        onChange={e => {
                          const files = Array.from(e.target.files || []);
                          if (files.length) void attachFiles(files);
                          e.target.value = '';
                        }}
                      />
                      <input
                        ref={mediaInput}
                        type="file"
                        accept="image/*,video/*"
                        hidden
                        multiple
                        onChange={e => {
                          const files = Array.from(e.target.files || []);
                          if (files.length) void attachFiles(files);
                          e.target.value = '';
                        }}
                      />
                      <button
                        title={tr('Upload files or media', 'Dateien oder Medien senden')}
                        type="button"
                        className={'composer-plus-btn ' + (plusMenu ? 'active' : '')}
                        onClick={() => {
                          // Second click within 400 ms = double click: open the file picker directly.
                          // (A native dblclick never arrives because the opened menu covers the button.)
                          const t = Date.now();
                          if (t - plusClickAt.current < 400) { plusClickAt.current = 0; setPlusMenu(false); fileInput.current?.click(); return; }
                          plusClickAt.current = t;
                          setPlusMenu(!plusMenu);
                        }}
                        disabled={uploadProgress !== null}
                      >
                        <Plus size={20} />
                      </button>
                      <div className="composer-input-area"><ComposerSuggestions items={items} index={index} onPick={pick}/>
                        {!draft && (
                          <div className="composer-fake-placeholder" aria-hidden="true">
                            {tr('Send a message in', 'Nachricht senden in')}{' '}
                            <span className="placeholder-channel-pill">
                              {dm ? '@' + shownName(dm.person) : '# ' + channel?.name}
                            </span>
                          </div>
                        )}
                        {channel && /^\/[a-z0-9_-]*$/i.test(draft) && (() => {
                          const q = draft.slice(1).toLowerCase();
                          const items = [
                            ...commands.filter(c => c.name.startsWith(q)).map(c => ({ key: c.id, name: c.name, sub: c.description, app: c.appName || '' })),
                            ...('clear'.startsWith(q) && channel?.capabilities?.clear_messages ? [{ key: 'clear', name: 'clear', sub: tr('Clear recent messages (owner/admin)', 'Letzte Nachrichten leeren (Owner/Admin)'), app: 'MALVO' }] : [])
                          ].slice(0, 8);
                          return items.length ? (
                            <div className="mention-autocomplete-popup slash-command-popup" role="listbox">
                              <small className="slash-command-head">{tr('Commands', 'Befehle')}</small>
                              {items.map(item => (
                                <button key={item.key} type="button" className="mention-item" onMouseDown={e => { e.preventDefault(); setDraft('/' + item.name + ' '); composerRef.current?.focus(); }}>
                                  <span className="slash-icon">/</span>
                                  <div><b>/{item.name}</b><small>{item.sub}</small></div>
                                  <em>{item.app}</em>
                                </button>
                              ))}
                            </div>
                          ) : null;
                        })()}
                        {channel && (() => {
                          const m = draft.match(/^\/([a-z0-9_-]+)\s/i);
                          const cmd = m && commands.find(c => c.name === m[1].toLowerCase());
                          return cmd && cmd.options.length ? (
                            <div className="slash-command-hint">
                              <b>/{cmd.name}</b>
                              {cmd.options.map(o => <span key={o.name} className={o.required ? 'is-required' : ''} title={o.description}>{o.name}{o.required ? '' : '?'}: <i>{o.type}</i></span>)}
                            </div>
                          ) : null;
                        })()}
                        {hasLink(draft) && <LinkMirror text={draft} target={composerRef} />}
                        <textarea
                          onBlur={stopTyping}
                          onPaste={e=>{const file=Array.from(e.clipboardData.items).find(i=>i.kind==='file'&&i.type.startsWith('image/'))?.getAsFile();if(file){e.preventDefault();void attachFiles([new File([file],`Screenshot-${Date.now()}.png`,{type:file.type})]);}}}
                          ref={composerRef}
                          className={hasLink(draft) ? 'has-link-mirror' : undefined}
                          aria-label="Message"
                          value={draft}
                          aria-invalid={draft.length>4000}
                          rows={1}
                          onChange={change}
                          onSelect={e=>setCursor(e.currentTarget.selectionStart)}
                          onKeyDown={e => {
                            if(e.nativeEvent.isComposing||e.keyCode===229)return;
                            if(handleSuggestionKey(e))return;
                            if(e.key==='ArrowUp'&&!draft&&!e.shiftKey&&!e.ctrlKey&&!e.metaKey&&!e.altKey&&loadedMessageRoom===roomId){const last=[...messages].reverse().find(m=>m.authorId===me?.id&&!m.pending&&!m.ephemeral&&!m.poll);if(last){e.preventDefault();startEdit(last);return;}}
                            if (e.key === 'Enter' && !e.shiftKey) {
                              e.preventDefault();

                              send(e);
                            }
                          }}
                        />
                      </div>
                      <button
                        title={tr('Send Klipy GIFs', 'Klipy GIFs senden')}
                        type="button"
                        className="composer-gif-btn"
                        onClick={() => {
                          setEmojiTab('gif');
                          setEmoji(emoji === 'composer' && emojiTab === 'gif' ? null : 'composer');
                        }}
                      >
                        GIF
                      </button>
                      <button type="button" title={tr('Send sticker','Sticker senden')} aria-label={tr('Open stickers','Sticker auswählen')} onClick={()=>{setEmojiTab('sticker');setEmoji(emoji==='composer'&&emojiTab==='sticker'?null:'composer');}}><Sticker size={19}/></button>
                      <button
                        title={tr('Insert Emoji', 'Emoji einfügen')}
                        type="button"
                        onClick={() => {
                          setEmojiTab('emoji');
                          setEmoji(emoji === 'composer' && emojiTab === 'emoji' ? null : 'composer');
                        }}
                      >
                        <Smile size={20} />
                      </button>
                      <button
                        className="send-button"
                        title={tr('Send', 'Senden')}
                        disabled={sending || draft.length>4000 || (!draft.trim() && !attachment)}
                      >
                        {sending ? <LoaderCircle className="spin" size={18} /> : <Send size={18} />}
                      </button>
                    </form>
                    {draft.length>3600&&<small role="status" className={draft.length>4000?'text-danger':''}>{draft.length}/4000 {tr('characters','Zeichen')}{draft.length>4000?' – '+tr('Shorten the message before sending.','Kürze die Nachricht vor dem Senden.'):''}</small>}
</>}</ComposerScope>
                  </>
                )}
              </div>
            </section>

            {!community && dm?.group && showDmProfile && <GroupMembersPanel group={dm.group} online={data.online} onPerson={p => { setPerson(p); setModal('profile'); }} onManage={() => setModal('group-manage')} />}
            {!community && dm && !dm.group && showDmProfile && (() => {
              const live: Person = { ...dm.person, ...(data.friends.find(f => f.person.id === dm.person.id)?.person || {}) };
              const isOnline = (data.online || []).includes(live.id) && live.status !== 'invisible';
              return <DmProfilePanel person={live} online={isOnline} viewerStatus={me.status} request={api} onClose={()=>setShowDmProfile(false)}
                onOpenProfile={() => { setPerson(dm.person); setModal('profile'); }}
                onMessage={openDM}
                onCommunity={(c: any) => { const own = data.communities.find(g => g.id === c.id); selectRoom(own?.channels?.find((ch: any) => ch.kind === 'text')?.id || '', c.id); }} />;
            })()}
            {community && showMembers && (
              <aside id="server-member-sidebar" className="members-panel flackle-members-panel"><button type="button" className="mobile-members-close" aria-label={tr('Close member list','Mitgliederliste schließen')} onClick={()=>setShowMembers(false)}><X size={20}/></button>
                <div className="members-top-header">
                  <Users size={16} />
                  <span>
                    {tr('Members', 'Mitglieder')} ({members.length})
                  </span>
                  {canManageServer && (
                    <button
                      type="button"
                      className="members-manage-btn"
                      title={tr('Manage Members & Roles', 'Mitglieder & Rollen verwalten')}
                      onClick={() => setModal('community-settings')}
                    >
                      <Settings size={14} />
                    </button>
                  )}
                </div>
                {memberGroups.map(group => (
                  <React.Fragment key={group.id}>
                    <h4 className="member-group-title">
                      {group.label} — {group.people.length}
                    </h4>
                    {(group.id === '__offline' ? group.people.slice(0, offlineLimit) : group.people).map(p => {
                      const online = group.id !== '__offline';
                      const topRole = p.customRoles?.[0];
                      const isOwnerMember = isCommunityOwner(p);
                      return (
                        <div
                          className={'member-row flackle-member-item' + (online ? '' : ' is-offline')}
                          key={p.id}
                          onContextMenu={e => openMemberContextMenu(e, p)}
                          onClick={() => {
                            setPerson(p);
                            setModal('profile');
                          }}
                        >
                          <Avatar person={p} size={34} online={online} />
                          <div className="member-item-meta">
                            <div className="member-item-name-row">
                              <b style={{ color: p.roleColor || (isOwnerMember ? '#ef5252' : '#e8e8f2') }}><RoleName role={{color:p.roleColor||undefined,colorSecondary:p.roleColorSecondary}}>{shownName(p)}</RoleName></b>
                              <span className="member-item-badges"><StaffMark person={p} size={14} /><IdentityBadges person={{ ...p, guildTags: [] }} /></span>
                              {!p.official && topRole && topRole.id !== group.id ? (
                                <span className="member-role-tag" style={{ background: `${topRole.color}22`, color: topRole.color }}>
                                  {topRole.name}
                                </span>
                              ) : null}
                            </div>
                            {online ? <ActivityLine uid={p.id} /> : null}
                            <small>@{p.username}</small>
                          </div>
                          <button
                            type="button"
                            className="member-more-btn"
                            title={tr('Options', 'Optionen')}
                            onClick={e => openMemberContextMenu(e, p)}
                          >
                            <MoreHorizontal size={15} />
                          </button>
                        </div>
                      );
                    })}
                  {group.id === '__offline' && group.people.length > offlineLimit && <button type="button" className="member-show-more" onClick={() => setOfflineLimit(n => n + 300)}>{tr('Show ' + Math.min(300, group.people.length - offlineLimit) + ' more', Math.min(300, group.people.length - offlineLimit) + ' weitere anzeigen')}</button>}
                  </React.Fragment>
                ))}
              </aside>
            )}
          </div>
        )}
      </main>

      {spamConfirm && (
        <div className="call-switch-backdrop" onMouseDown={e => { if (e.target === e.currentTarget) setSpamConfirm(null); }}>
          <div className="call-switch" role="alertdialog" aria-modal="true" aria-label={tr('Send again?', 'Nochmal senden?')}>
            <h3>{spamConfirm === 'duplicate' ? tr('Send the same message again?', 'Dieselbe Nachricht nochmal senden?') : tr('You are sending a lot of messages', 'Du sendest gerade sehr viele Nachrichten')}</h3>
            <p>{spamConfirm === 'duplicate' ? tr('You just sent this text. Please avoid spamming the chat.', 'Diesen Text hast du gerade schon gesendet. Bitte spamme den Chat nicht zu.') : tr('Please slow down a little so the chat stays readable.', 'Bitte etwas langsamer, damit der Chat lesbar bleibt.')}</p>
            <div className="call-switch-actions">
              <button type="button" className="secondary" autoFocus onClick={() => setSpamConfirm(null)}>{tr('Cancel', 'Abbrechen')}</button>
              <button type="button" className="primary" onClick={() => { setSpamConfirm(null); spamConfirmed.current = JSON.stringify([me?.id,roomId,readRoomDraft(me?.id,roomId).trim()]); void send({ preventDefault() {} } as React.FormEvent); }}>{tr('Send anyway', 'Trotzdem senden')}</button>
            </div>
          </div>
        </div>
      )}
      {pendingCall && call && (
        <div className="call-switch-backdrop" onMouseDown={e => { if (e.target === e.currentTarget) setPendingCall(null); }}>
          <div className="call-switch" role="alertdialog" aria-modal="true" aria-label={tr('Switch call', 'Call wechseln')}>
            <h3>{tr('Switch to another call?', 'In einen anderen Call wechseln?')}</h3>
            <p>{tr('You will leave', 'Du verlässt')} <b>{call.name}</b> {tr('and join', 'und trittst')} <b>{pendingCall.name}</b>{tr('.', ' bei.')}</p>
            <div className="call-switch-actions">
              <button type="button" className="secondary" autoFocus onClick={() => setPendingCall(null)}>{tr('Stay', 'Bleiben')}</button>
              <button type="button" className="primary" onClick={() => { const next = pendingCall; setPendingCall(null); void startCall(next.rid, next.name, true); }}>{tr('Switch', 'Wechseln')}</button>
            </div>
          </div>
        </div>
      )}
      {rosterVolume&&<ParticipantVolumeMenu accountId={me.id} person={rosterVolume.person} x={rosterVolume.x} y={rosterVolume.y} onClose={()=>setRosterVolume(null)} onProfile={()=>{setPerson(rosterVolume.person);setModal('profile')}} onMessage={()=>void openDM(rosterVolume.person)} onActions={(e,anchor)=>openMemberContextMenu(e,rosterVolume.person,anchor)}/>}
      {teamOpen&&me.teamAccess&&<section className="team-surface"><SupportAdmin request={api} onClose={closeTeam} initialTab={teamTab} initialServerId={teamServer} canManageOfficial={!!me.canManageOfficial} onTabChange={next=>{const url=new URL(location.href);url.searchParams.set('teamTab',next);history.replaceState(history.state,'',url)}}/></section>}
      {context && <ContextMenu {...context} onClose={() => setContext(null)} />}
      {emoji && (
        <EmojiPicker onConfigureGifs={me.isOwnerAdmin?()=>{setEmoji(null);openTeam('gifs')}:undefined} customEmotes={customEmotes} key={emoji+emojiTab} anchor={emoji==='composer'?undefined:reactionAnchor}
          closing={emojiClosing}
          mode={emoji === 'composer' ? 'all' : 'emoji-only'}
          initialTab={emojiTab}
          onClose={() => setEmoji(null)}
          onPick={(em, isGif) => {
            if (emoji === 'composer') {
              if (isGif) {
                void sendDirectBody(em);
              } else {
                draftControl.current?.insert(em);
              }
            } else
              action(async () => {
                await api('/messages/' + emoji + '/reactions', 'POST', { emoji: em });
              });
            if(emoji==='composer')setEmoji(null);
          }}
        />
      )}
      {friendNotice && <FriendNotice notice={friendNotice} onClose={() => setFriendNotice(null)} onOpen={() => {
        if (friendNotice.kind === 'request') { home(); setTab('pending'); setModal(null); }
        else { const peer = data.friends.find(f => f.person.id === friendNotice.person.id)?.person;
          if (peer) void openDM(peer);
          else void openDM({...FALLBACK_PERSON, ...friendNotice.person, avatar: null}); }
        setFriendNotice(null);
      }}/>}
      {qrApprove && me && me.verified && <QrApprove request={api} onClose={() => setQrApprove(false)} />}
      {me && <GuildTagPopup request={api} onOpenServer={id => openJoined(id)} />}
      <WebUpdateNotice ready={updateReady} call={call} pendingWork={sending || uploadProgress !== null || !!attachment || !!modal}/>
      {rejoinOffer && !call && <div className="rejoin-offer" role="status"><Phone size={16} /><span>{tr('You were in ', 'Du warst in ')}<b>{rejoinOffer.name}</b>. {tr('Rejoin?', 'Wieder beitreten?')}</span><button type="button" onClick={() => { const r = rejoinOffer; setRejoinOffer(null); void startCall(r.id, r.name, true); }}>{tr('Rejoin', 'Beitreten')}</button><button type="button" className="rejoin-dismiss" aria-label={tr('Dismiss', 'Schließen')} onClick={() => setRejoinOffer(null)}><X size={15} /></button></div>}
      {notice && (
        <div className="toast" role="status">
          <CheckCheck size={18} />
          {notice}
        </div>
      )}

      {modal && modal !== 'call' && (()=>{const community=modalServerId?data.communities.find(c=>c.id===modalServerId):dialogCommunity;const members=modalServerId?modalMembers:dialogMembers;return (
        <div
          className={'modal-backdrop ' + (modalClosing ? 'is-closing' : '')}
          onMouseDown={e => {
            if (e.target === e.currentTarget) setModal(null);
          }}
        >
          <section
            key={modal}
            className={
              'modal ' +
              (modal === 'moderation-support'?'moderation-support-modal':modal === 'discovery'?'discovery-modal':modal==='message-search'||modal==='mentions'?'message-search-modal':modal === 'profile' || modal === 'member-profile'
                ? 'profile-modal flackle-profile-modal flackle-compact-profile'+(isSystemAccount(person)?' system-profile-modal':'')
                : modal === 'invite'
                ? 'flackle-invite-modal'
                : modal === 'friend-remove' ||
                  modal === 'block-confirm' ||
                  modal === 'channel-delete' ||
                  modal.startsWith('delete:')
                ? 'confirm-modal delete-msg-modal'
                : modal === 'owner-admin'
                ? 'owner-admin-modal'
                : modal === 'channel'
                ? 'create-channel-modal'
                : modal === 'account-switch'
                ? 'account-switcher-modal'
                : modal === 'bookmarks'
                ? 'saved-modal'
                : modal === 'settings'
                ? 'settings-modal'
                : modal === 'community-leave' ? 'server-leave-modal'
                : ['community-settings', 'community-delete'].includes(modal)
                ? 'server-settings-modal'
                : '')
            }
            role="dialog"
            aria-modal="true"
            aria-label={modal === 'account-switch' ? tr('Switch Account', 'Account wechseln') : isSystemAccount(person)&&['profile','member-profile'].includes(modal)?tr('Official MALVO account','Offizieller MALVO-Account'):'MALVO Dialog'}
          >
            {modal==='member-tools'&&managedMember&&community&&<><h2>{tr('Member moderation','Mitglied moderieren')}</h2><MemberControls expanded person={members.find(p=>p.id===managedMember.id)||managedMember} community={community} request={api} onRefresh={async()=>{await refresh();if(activeCommunity)await refreshMembers(activeCommunity)}}/></>}
            {!modal.startsWith('delete:') &&
              modal !== 'profile' &&
              modal !== 'member-profile' &&
              modal !== 'invite' && (
                <button className="close-modal" title={tr('Close', 'Schließen')} onClick={() => setModal(null)}>
                  <X size={20} />
                </button>
              )}

            {modal==='owner-admin'&&me.teamAccess&&<SupportAdmin request={api}/>}
            {modal==='discovery'&&<Discovery request={api} onOpen={async id=>{const next=await refresh(),server=next.communities.find((c:Community)=>c.id===id);if(!server)throw Error('Der Server ist nicht mehr verfügbar.');selectRoom(lastChannelOf(server),server.id);setModal(null)}}/>}
            {modal==='moderation-support'&&<ModerationSupport/>}
            {(modal==='message-search'||modal==='mentions')&&<MessageSearch request={api} initialRoom={modal==='message-search'?roomId||undefined:undefined} mentionsOnly={modal==='mentions'} rooms={[...data.communities.flatMap(c=>c.channels.filter(ch=>ch.kind==='text').map(ch=>({id:ch.id,name:c.name+' / #'+ch.name}))),...data.conversations.map(c=>({id:c.id,name:shownName(c.person)}))]} members={[...new Map([me,...members,...data.friends.map(f=>f.person),...messages.map(m=>m.author)].filter(Boolean).map(p=>[p!.id,p!])).values()]} onOpen={async message=>{const rid=message.channelId||message.conversationId,server=data.communities.find(c=>c.channels.some(ch=>ch.id===rid));pendingJump.current={roomId:rid,messageId:message.id};selectRoom(rid,server?.id||null);setModal(null);await loadMessages(rid,message.id);requestAnimationFrame(()=>{const el=document.getElementById('message-'+message.id);el?.scrollIntoView({block:'center'});el?.classList.add('search-highlight');setTimeout(()=>el?.classList.remove('search-highlight'),2000)});pendingJump.current=null}}/>}

            {modal === 'account-switch' && <AccountSwitcher accounts={savedAccounts} currentId={me.id}
              renderAvatar={account => <Avatar person={{...me, ...account}} size={44}/>}
              request={accountRequest} loading={accountsLoading} loadError={accountsError} onRetry={loadSavedAccounts} onComplete={() => location.reload()}/>}
            {modal === 'subscription' && <Subscription request={api} />}
            {modal === 'bookmarks' && (
              <SavedMessages
                request={api}
                onOpen={id => {
                  const c = data.communities.find(c => c.channels.some(ch => ch.id === id));
                  selectRoom(id, c?.id || null);
                  setModal(null);
                }}
              />
            )}
            {modal === 'friend-remove' && managedFriend && (
              <div className="flackle-delete-dialog">
                <h3>{tr('Remove Friend', 'Freund entfernen')}</h3>
                <p>
                  {tr('Are you sure you want to remove', 'Möchtest du')}{' '}
                  <b>{shownName(managedFriend.person)}</b>{' '}
                  {tr('from your friends?', 'wirklich aus deinen Freunden entfernen?')}
                </p>
                <div className="delete-modal-actions">
                  <button className="delete-no-btn" onClick={() => setModal(null)}>
                    No
                  </button>
                  <button
                    className="delete-yes-btn"
                    disabled={busy}
                    onClick={() =>
                      action(async () => {
                        await api('/friends/' + managedFriend.id, 'DELETE');
                        await refresh();
                        setModal(null);
                      })
                    }
                  >
                    Yes
                  </button>
                </div>
              </div>
            )}
            {modal === 'channel-delete' && channelToDelete && (
              <div className="flackle-delete-dialog">
                <h3>{tr('Delete Channel', 'Kanal löschen')}</h3>
                <p>
                  {tr('Are you sure you want to permanently delete', 'Möchtest du den Kanal')}{' '}
                  <b>#{channelToDelete.name}</b> {tr('?', 'wirklich unwiderruflich löschen?')}
                </p>
                <div className="delete-modal-actions">
                  <button className="delete-no-btn" onClick={() => setModal(null)}>
                    No
                  </button>
                  <button
                    className="delete-yes-btn"
                    disabled={busy}
                    onClick={() =>
                      action(async () => {
                        await api('/channels/' + channelToDelete.id, 'DELETE', { name: channelToDelete.name });
                        await refresh();
                        setChannelToDelete(null);
                        setModal(null);
                        setNotice(tr('Channel deleted.', 'Kanal gelöscht.'));
                      })
                    }
                  >
                    Yes
                  </button>
                </div>
              </div>
            )}
            {modal === 'community' && (
              <CommunityDialog
                request={api}
                onDone={async id => {
                  const b = await api('/bootstrap');
                  setData({...empty,...b,online:b.online||[]});
                  const c = b.communities.find((c: Community) => c.id === id);
                  selectRoom(c.channels.find((ch: Channel) => ch.kind === 'text')?.id || '', id);
                  setModal(null);
                }}
              />
            )}

            {/* Bild 1: Exact Flackle Invite Modal with Inline Expiration & Max Uses Editor */}
            {modal === 'invite-friends' && community && (
              <div className="invite-modal-content" style={{ width: '440px', padding: '24px', background: '#13131c', borderRadius: '16px' }}>
                <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#fff', margin: '0 0 8px' }}>
                  {tr('Invite Friends to ', 'Freunde einladen auf ')}{community.name}
                </h3>
                <p style={{ color: '#888896', fontSize: '13px', margin: '0 0 16px' }}>
                  {tr('Send an instant invite directly into their DMs with one click.', 'Sende mit einem Klick eine direkte Einladung in ihre DMs.')}
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '280px', overflowY: 'auto' }}>
                  {data.friends.filter((f: any) => f.status === 'accepted' || f.state === 'accepted').length === 0 ? (
                    <p style={{ color: '#888896', fontStyle: 'italic', fontSize: '13px' }}>
                      {tr('No friends found to invite.', 'Keine Freunde zum Einladen gefunden.')}
                    </p>
                  ) : (
                    data.friends.filter((f: any) => f.status === 'accepted' || f.state === 'accepted').map(f => {
                      const isInvited = invitedFriends.has(f.id);
                      return (
                        <div key={f.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: '#1c1d27', borderRadius: '10px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Avatar person={f.person} size={32} />
                            <div>
                              <b style={{ color: '#fff', fontSize: '13.5px' }}>{shownName(f.person)}</b>
                              <small style={{ color: '#888896', display: 'block', fontSize: '11px' }}>@{f.person.username}</small>
                            </div>
                          </div>
                          <button
                            type="button"
                            className={'invite-pill-btn ' + (isInvited ? 'active' : '')}
                            disabled={isInvited}
                            onClick={async () => {
                              try {
                                await api('/dm', 'POST', { userId: f.person.id }).then((d: any) =>
                                  seal(d.id, 'https://malvo.eu/i/' + (community.vanityInvite || community.invite)).then(body => api('/rooms/' + d.id + '/messages', 'POST', { body }))
                                );
                                setInvitedFriends(prev => new Set(prev).add(f.id));
                                setNotice(tr('Invite sent to ', 'Einladung gesendet an ') + shownName(f.person));
                              } catch (e) {
                                setError((e as Error).message);
                              }
                            }}
                          >
                            {isInvited ? tr('Invited ✓', 'Eingeladen ✓') : tr('Invite', 'Einladen')}
                          </button>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            )}
            {modal === 'invite' && community && (()=>{
              // The dialog can be opened for a server other than the one on screen, so the link comes from that server.
              const invitePath = community.id === 'malvo-official' ? '/malvo' : '/i/' + (community.vanityInvite || community.invite);
              const currentInviteUrl = location.origin + invitePath, currentInviteDisplay = 'malvo.eu' + invitePath;
              const landingChannel = community.channels?.some(c => c.id === channel?.id) ? channel!.name : '';
              return (
              <div className="flackle-invite-dialog-inner">
                <header className="flackle-invite-top">
                  <h2>
                    {tr('Invite friends to', 'Freunde einladen zu')} {community.name}
                  </h2>
                  <button
                    type="button"
                    className="flackle-invite-close"
                    onClick={() => setModal(null)}
                    aria-label="Close"
                  >
                    <X size={20} />
                  </button>
                </header>
                {landingChannel && <div className="flackle-invite-sub">
                  <span>{tr('Recipients will land in', 'Empfänger landen in')}</span>
                  <span className="flackle-invite-channel-pill">
                    <MessageCircle size={13} />
                    {landingChannel}
                  </span>
                </div>}
                <div className="flackle-invite-input-box">
                  <input readOnly value={currentInviteDisplay} aria-label="Invite Link" />
                  <button
                    type="button"
                    className={'flackle-invite-copy-btn ' + (inviteCopied ? 'is-copied' : '')}
                    onClick={async () => {
                      await copyToClipboard(currentInviteUrl);
                      setInviteCopied(true);
                      setNotice(tr('Invite link copied!', 'Einladungslink kopiert!'));
                      setTimeout(() => setInviteCopied(false), 2400);
                    }}
                  >
                    {inviteCopied ? tr('Copied', 'Kopiert') : tr('Copy', 'Kopieren')}
                  </button>
                </div>
                <div className="flackle-invite-footer">
                  <span>
                    {(() => {
                      const exp = community.inviteExpires || '5d';
                      const expMap: Record<string, string> = {
                        '30m': tr('Expires in 30 minutes', 'Läuft in 30 Minuten ab'),
                        '1h': tr('Expires in 1 hour', 'Läuft in 1 Stunde ab'),
                        '6h': tr('Expires in 6 hours', 'Läuft in 6 Stunden ab'),
                        '12h': tr('Expires in 12 hours', 'Läuft in 12 Stunden ab'),
                        '1d': tr('Expires in 1 day', 'Läuft in 1 Tag ab'),
                        '5d': tr('Expires in 5 days', 'Läuft in 5 Tagen ab'),
                        '7d': tr('Expires in 7 days', 'Läuft in 7 Tagen ab'),
                        never: tr('Never expires', 'Läuft nie ab')
                      };
                      const maxU = community.inviteMaxUses || 0;
                      return (
                        (expMap[exp] || expMap['5d']) +
                        (maxU > 0 ? ` · ${maxU} ${tr('uses max', 'Nutzungen max.')}` : '')
                      );
                    })()}
                  </span>
                  <button
                    type="button"
                    className="flackle-invite-edit-link"
                    onClick={() => {
                      setInviteExpDraft(community.inviteExpires || '5d');
                      setInviteMaxDraft(String(community.inviteMaxUses || 0));
                      setEditingInvite(!editingInvite);
                    }}
                  >
                    {editingInvite ? tr('Hide settings', 'Schließen') : tr('Edit invite link', 'Einladungslink bearbeiten')}
                  </button>
                </div>

                {editingInvite && (
                  <div className="flackle-invite-editor-drawer">
                    <div className="flackle-invite-editor-field">
                      <label>{tr('Expire After', 'Ablaufzeit')}</label>
                      <CustomSelect
                        value={inviteExpDraft}
                        onChange={setInviteExpDraft}
                        options={[
                          { value: '30m', label: tr('30 minutes', '30 Minuten') },
                          { value: '1h', label: tr('1 hour', '1 Stunde') },
                          { value: '6h', label: tr('6 hours', '6 Stunden') },
                          { value: '12h', label: tr('12 hours', '12 Stunden') },
                          { value: '1d', label: tr('1 day', '1 Tag') },
                          { value: '5d', label: tr('5 days', '5 Tage') },
                          { value: '7d', label: tr('7 days', '7 Tage') },
                          { value: 'never', label: tr('Never', 'Nie ablaufen') }
                        ]}
                      />
                    </div>
                    <div className="flackle-invite-editor-field">
                      <label>{tr('Max Number of Uses', 'Maximale Nutzungen')}</label>
                      <CustomSelect
                        value={inviteMaxDraft}
                        onChange={setInviteMaxDraft}
                        options={[
                          { value: '0', label: tr('No limit', 'Kein Limit') },
                          { value: '1', label: tr('1 use', '1 Nutzung') },
                          { value: '5', label: tr('5 uses', '5 Nutzungen') },
                          { value: '10', label: tr('10 uses', '10 Nutzungen') },
                          { value: '25', label: tr('25 uses', '25 Nutzungen') },
                          { value: '50', label: tr('50 uses', '50 Nutzungen') },
                          { value: '100', label: tr('100 uses', '100 Nutzungen') }
                        ]}
                      />
                    </div>
                    <div className="flackle-invite-editor-actions">
                      <button
                        type="button"
                        className="secondary"
                        disabled={busy || !isServerOwner}
                        onClick={() =>
                          action(async () => {
                            await api('/communities/' + community.id + '/invite', 'POST', {
                              expires: inviteExpDraft,
                              maxUses: Number(inviteMaxDraft) || 0,
                              regenerate: true,
                              forceRandom: community.id !== 'malvo-official'
                            });
                            await refresh();
                            setEditingInvite(false);
                            setNotice(tr('New invite link generated!', 'Neuer Einladungslink erstellt!'));
                          })
                        }
                      >
                        <RefreshCw size={14} /> {tr('Generate New Link', 'Neuen Link erstellen')}
                      </button>
                      <button
                        type="button"
                        className="primary"
                        disabled={busy || !isServerOwner}
                        onClick={() =>
                          action(async () => {
                            await api('/communities/' + community.id + '/invite', 'POST', {
                              expires: inviteExpDraft,
                              maxUses: Number(inviteMaxDraft) || 0,
                              regenerate: false
                            });
                            await refresh();
                            setEditingInvite(false);
                            setNotice(tr('Invite link settings saved.', 'Einladungs-Einstellungen gespeichert.'));
                          })
                        }
                      >
                        <Check size={15} /> {tr('Save', 'Speichern')}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            );})()}

            {modal==='custom-status'&&<CustomStatusEditor person={me} request={api} onSaved={async()=>{await loadMe();await refresh()}} onDone={()=>setModal(null)}/>}
            {modal==='channel'&&community&&<CreateChannel communityId={community.id} request={api} category={channelCategory} roles={(community.roles || []).filter((r: any) => !r.managed)} onCancel={()=>setModal(null)} onCreate={async v=>{await api('/communities/'+community.id+'/channels','POST',v);await refresh();setModal(null);}}/>}

            {modal==='community-leave'&&community&&<ServerLeaveDialog community={community} request={api} onCancel={()=>setModal(null)} onExit={()=>{const leftId=community.id;if(activeCommunity===leftId)home();if(call&&data.communities.find(c=>c.id===leftId)?.channels.some(ch=>ch.id===call.id))setCall(null);setModal(null);void refresh()}}/>}
            {['community-settings', 'community-delete'].includes(modal) && community && (
              <ServerSettings key={settingsFocus ? JSON.stringify(settingsFocus) : 'default'} focus={settingsFocus} onClose={()=>{try{sessionStorage.removeItem('malvo-server-settings-page:'+community.id)}catch{}setSettingsFocus(null);setModal(null);}}
                initialAction={
                  modal === 'community-delete' ? 'server' : modal === 'community-leave' ? 'leave' : undefined
                }
                community={community}
                members={members}
                me={me}
                request={api}
                onRefresh={async () => {
                  await refresh();
                  if (community?.id)
                    api('/communities/'+community.id+'/members').then(rows=>{if(modalServerId)setModalMembers(rows);else setMembers(rows)})
                      .catch(() => {});
                }}
                onExit={() => {
                  const leftId = community.id;
                  if(activeCommunity===leftId)home();
                  if (call && data.communities.find(c => c.id === leftId)?.channels.some(ch => ch.id === call.id)) setCall(null);
                  setModal(null);
                  refresh();
                }}
                onCreateChannel={() => setModal('channel')}
                onKick={p => {
                  setPerson(p);
                  setModal('kick');
                }}
              />
            )}

            {modal === 'kick' && community && person && (
              <div className="flackle-delete-dialog">
                <h3>
                  {tr('Kick', 'Kicken:')} {shownName(person)}?
                </h3>
                <p>
                  {tr('Are you sure you want to kick', 'Möchtest du')} <b>{shownName(person)}</b>{' '}
                  {tr('from the server?', 'wirklich vom Server entfernen?')}
                </p>
                <div className="delete-modal-actions">
                  <button className="delete-no-btn" onClick={() => setModal(null)}>
                    No
                  </button>
                  <button
                    className="delete-yes-btn"
                    onClick={() =>
                      action(async () => {
                        await api('/communities/' + community.id + '/members/' + person.id, 'DELETE');
                        await refresh();
                        setModal(null);
                      })
                    }
                  >
                    Yes
                  </button>
                </div>
              </div>
            )}

            {/* Bild 4: Compact Profile Card with Banner Top Buttons, Status Dot, Badges, Account Age & Inline Message Input */}
            {(modal === 'profile' || modal === 'member-profile') &&
              person &&
              (() => {
                const matchedMember = members.find(x => x.id === person.id);
                const livePerson: Person =
                  person.id === me.id
                    ? { ...person, ...matchedMember, ...me }
                    : { ...person, ...matchedMember };
                const bannerUrl = livePerson.banner ? `/api/files/${livePerson.banner}` : null;
                const isOnline = (livePerson.id === me.id || (data.online || []).includes(livePerson.id)) && livePerson.status !== 'invisible';
                const statusType = !isOnline ? 'invisible' : livePerson.status || 'online';
                const isSelf = livePerson.id === me.id;
                const isMalvo = !!livePerson.official;
                const friendship = data.friends.find(f => f.person.id === livePerson.id);
                const rolesList = (livePerson.customRoles || []).filter(
                  (r, idx, arr) => arr.findIndex(x => x.name.toLowerCase() === r.name.toLowerCase()) === idx
                );
                const inVoiceChannel = Object.entries(voiceRosters).find(([_, users]) => users.some(u => u.id === livePerson.id));
                const voiceChanName = inVoiceChannel ? (community?.channels?.find((c: any) => c.id === inVoiceChannel[0])?.name || 'Voice Talk') : null;

                return <ProfileView roleEditor={community&&matchedMember&&(community.role==='owner'||community.capabilities?.manageRoles)?<ProfileRoleEditor community={community} person={livePerson} actor={members.find(m=>m.id===me.id)||me} request={api} onChanged={async()=>{await refresh();await refreshMembers(community.id)}}/>:undefined} person={livePerson} me={me} online={isOnline} friendship={friendship} request={api}
                  onClose={()=>setModal(null)} onEdit={()=>{setSettingsTab('profile');setModal('settings');}}
                  onMessage={openDM} onOpenOfficialChat={data.conversations.some(conversation=>conversation.official)?()=>{selectRoom(OFFICIAL_CHAT_ID,null);setModal(null)}:undefined} onCommunity={(c:any)=>{const own=data.communities.find(g=>g.id===c.id);selectRoom(own?.channels?.find((ch:any)=>ch.kind==='text')?.id||'',c.id);setModal(null);}}
                  onMenu={(e:React.MouseEvent)=>openMemberContextMenu(e,livePerson)}
                  onFriend={()=>action(async()=>{if(friendship?.state==='accepted'){setManagedFriend(friendship);setModal('friend-remove');return;}if(friendship?.state==='pending'&&friendship.recipientId===me.id){await api('/friends/'+friendship.id+'/accept','POST',{});setNotice(tr('Friend request accepted. You can chat now!','Freundschaftsanfrage angenommen. Ihr könnt jetzt chatten!'));}else if(friendship)await api('/friends/'+friendship.id,'DELETE');else await api('/friends','POST',{username:livePerson.username});await refresh();})}/>;
              })()}

            {modal==='official-editor'&&me.canManageOfficial&&<OfficialBroadcasts request={api} onChanged={()=>void loadMessages(roomId!)}/>}
            {modal === 'settings' && (
              <SettingsPanel
                me={me}
                initialTab={settingsTab}
                onSwitchAccount={openAccountSwitcher}
                onBlocked={() => setModal('blocked')}
                billingAvailable={!!features.billing || !!me.supporter}
                request={api}
                upload={upload}
                onSaved={async () => {
                  const updatedMe = await loadMe();
                  if (person && person.id === me.id) setPerson(updatedMe);
                  await refresh();
                  if (activeCommunity) {
                    refreshMembers(activeCommunity)
                      .catch(() => {});
                  }
                }}
                onLogout={async () => {
                  await logout();
                  setCall(null);
                  setModal(null);
                }}
              />
            )}

            {modal === 'block-confirm' && person && (
              <div className="flackle-delete-dialog">
                <h3>
                  {tr('Block', 'Blockieren:')} {shownName(person)}?
                </h3>
                <p>
                  {tr(
                    'They will no longer be able to send you direct messages or call you.',
                    'Ihr könnt euch danach keine Direktnachrichten mehr schicken. Die Freundschaft wird entfernt. Nachrichten bleiben erhalten und lassen sich aufklappen.'
                  )}
                </p>
                <div className="delete-modal-actions">
                  <button className="delete-no-btn" onClick={() => setModal('profile')}>
                    No
                  </button>
                  <button
                    className="delete-yes-btn"
                    onClick={() =>
                      action(async () => {
                        await api('/blocks', 'POST', { userId: person.id });
                        await refresh();
                        setModal(null);
                      })
                    }
                  >
                    Yes
                  </button>
                </div>
              </div>
            )}

            {modal === 'blocked' && (
              <>
                <h2>{tr('Blocked Users', 'Blockierte Kontakte')}</h2>
                {!data.blocks.length && <p>{tr('You have not blocked anyone.', 'Du hast niemanden blockiert.')}</p>}
                {data.blocks.map(b => (
                  <button
                    key={b.targetId}
                    className="settings-row"
                    onClick={() =>
                      action(async () => {
                        await api('/blocks/' + b.targetId, 'DELETE');
                        await refresh();
                      })
                    }
                  >
                    {shownName(b.person) || 'User ' + b.targetId.slice(0, 8)}{' '}
                    <span>{tr('Unblock', 'Freigeben')}</span>
                  </button>
                ))}
              </>
            )}

            {modal.startsWith('delete:') && (
              <div className="flackle-delete-dialog">
                <h3>Delete Message</h3>
                <p>Are you sure you want to delete this message?</p>
                <div className="delete-modal-actions">
                  <button type="button" className="delete-no-btn" onClick={() => setModal(null)}>
                    No
                  </button>
                  <button
                    type="button"
                    className="delete-yes-btn"
                    disabled={busy}
                    onClick={() =>
                      action(async () => {
                        await api('/messages/' + modal.split(':')[1], 'DELETE');
                        await loadMessages(roomId!);
                        setModal(null);
                      })
                    }
                  >
                    Yes
                  </button>
                </div>
              </div>
            )}

            {modal === 'group-create' && <GroupCreate friends={data.friends.filter(f => f.state === 'accepted').map(f => f.person)} request={api} onCreated={async id => { await refresh(); selectRoom(id, null); setModal(null); }} />}
            {modal === 'group-manage' && dm?.group && <GroupManage upload={upload} key={dm.id} group={{ id: dm.id, ...dm.group }} me={me} friends={data.friends.filter(f => f.state === 'accepted').map(f => f.person)} request={api} onChanged={async () => { await refresh(); }} onLeft={async () => { setModal(null); home(); await refresh(); }} />}
            {modal.startsWith('reactions:') && <ReactionsDialog key={modal} messageId={modal.split(':')[1]} initial={modal.split(':').slice(2).join(':')} request={api} onPerson={p => { setPerson(p); setModal('profile'); }} />}

            {(modal.startsWith('report:')||modal.startsWith('report-user:')) && <ReportDialog key={modal} request={api} messageId={modal.startsWith('report:')?modal.split(':')[1]:undefined} targetId={modal.startsWith('report-user:')?modal.split(':')[1]:undefined} onClose={()=>setModal(null)} onDone={()=>{setNotice(tr('Report submitted.','Meldung gespeichert.'));setModal(null);}}/>}

            {/* Bild 2: Clean Download Modal with sleek typography & soft Beta pill */}
            {modal === 'about' && <DownloadsPanel />}
            {error && (
              <p className="form-error" role="alert">
                {error}
              </p>
            )}
          </section>
        </div>
      )})()}

      {lightbox&&<ImageViewer src={lightbox.src} name={lightbox.name} onCopy={()=>void copyImage(lightbox.src)} onClose={()=>setLightbox(null)}/>}
      {cropAttachment&&<AttachmentCrop file={cropAttachment} onClose={()=>setCropAttachment(null)} onSave={async file=>{setAttachment(await uploadAttachment(file))}}/>}

    </div>
  );
}

function Form({
  children,
  onSubmit,
  busy
}: {
  children: React.ReactNode;
  onSubmit: (values: Record<string, string>) => void;
  busy: boolean;
}) {
  return (
    <form
      className="form-stack"
      onSubmit={e => {
        e.preventDefault();
        onSubmit(Object.fromEntries(new FormData(e.currentTarget)) as Record<string, string>);
      }}
    >
      <fieldset disabled={busy}>{children}</fieldset>
    </form>
  );
}

const STREAM_QUALITIES = [
  { id: '720p30', label: '720p · 30 FPS', note: 'Smooth, low data', noteDe: 'Flüssig, wenig Daten', width: 1280, height: 720, fps: 30, bitrate: 2_500_000 },
  { id: '1080p30', label: '1080p · 30 FPS', note: 'Recommended', noteDe: 'Empfohlen', width: 1920, height: 1080, fps: 30, bitrate: 4_500_000 },
  { id: '1080p60', label: '1080p · 60 FPS', note: 'Games, fast motion', noteDe: 'Spiele, schnelle Bewegung', width: 1920, height: 1080, fps: 60, bitrate: 7_000_000 },
  { id: '1440p60', label: '1440p · 60 FPS', note: 'Best quality', noteDe: 'Beste Qualität', width: 2560, height: 1440, fps: 60, bitrate: 10_000_000 }
];

function MediaIndicators({ flags, tr }: { flags?: { camera: boolean; screen: boolean }; tr: (en: string, de: string) => string }) {
  if (!flags || (!flags.camera && !flags.screen)) return null;
  return (
    <span className="voice-media-indicators">
      {flags.screen && (
        <span className="voice-media-pill is-live" title={tr('Sharing screen', 'Teilt Bildschirm')}>
          <MonitorUp size={12} /> LIVE
        </span>
      )}
      {flags.camera && (
        <span className="voice-media-pill" title={tr('Camera on', 'Kamera an')}>
          <Video size={12} />
        </span>
      )}
    </span>
  );
}

function Voice(props: React.ComponentProps<typeof VoiceInner>) {
  const [ready, setReady] = useState(!!LK), [failed, setFailed] = useState(false);
  // Retries for ~20 s (e.g. while the server restarts for an update), then reloads once and rejoins the call.
  useEffect(() => {
    if (LK) { setReady(true); return; } let alive = true;
    (async () => {
      for (let i = 0; i < 6 && alive; i++) {
        try { await loadLK(); if (alive) setReady(true); return; } catch { await new Promise(r => setTimeout(r, 1000 * Math.min(8, 2 ** i))); }
      }
      if (!alive) return;
      let reloaded = false; try { reloaded = sessionStorage.getItem('malvo-lk-reload') === '1'; } catch {}
      if (!reloaded) { try { sessionStorage.setItem('malvo-lk-reload', '1'); rememberCall({ id: props.roomId, name: props.name }, true); } catch {} location.reload(); return; }
      setFailed(true);
    })();
    return () => { alive = false; };
  }, []);
  useEffect(() => { if (ready) try { sessionStorage.removeItem('malvo-lk-reload'); } catch {} }, [ready]);
  if (ready) return <VoiceInner {...props} />;
  return <div className="voice-room voice-v2 voice-loading" style={{ display: 'grid', placeItems: 'center', minHeight: 120, color: '#a0a0ad' }}>{failed ? <button type="button" onClick={() => location.reload()}>{translate('Call could not load – reload', 'Anruf konnte nicht laden – neu laden')}</button> : translate('Connecting…', 'Verbinde …')}</div>;
}
// Server tag (e.g. SIGMA) next to names on call tiles; ChannelBadges covers team badges, verified mark and profile badges.
function CallGuildTag({ person }: { person: Person }) {
  return (person as any)?.guildTags?.length ? <IdentityBadges person={{ guildTags: (person as any).guildTags }} /> : null;
}
function VoiceInner({
  muted,deafened,onMutedChange,onDeafenedChange,minimized,onMinimize,dragHandlers,floating,
  me,
  peer,
  waiting = [],
  ringing,
  members,
  roster = [],
  roomId,
  name,
  isExpanded,
  speakingUsers,
  soundboardUsers,
  onSpeakersChange,
  onParticipantLeft,
  onParticipantsChange,
  onClose,
  onExpand,
  onError,
  onOpenProfile,
  onMessage,
  onMemberActions
}: {
  muted:boolean;deafened:boolean;onMutedChange:(v:boolean)=>void;onDeafenedChange:(v:boolean)=>void;
  floating:boolean;minimized:boolean;onMinimize:()=>void;dragHandlers:React.HTMLAttributes<HTMLElement>;
  onOpenProfile?: (id: string) => void;
  onMessage?: (id: string) => void;
  onMemberActions?: (e: React.MouseEvent, id: string, anchor: { x: number; y: number }) => void;
  me: Person;
  peer?: Person | null;
  waiting?: Person[];
  ringing?: string[];
  members: Person[];
  roster?: Person[];
  roomId: string;
  name: string;
  isExpanded: boolean;
  speakingUsers?: Set<string>;
  soundboardUsers?: Set<string>;
  onSpeakersChange?: (s: Set<string>) => void;
  onParticipantLeft?: (id:string) => void;
  onParticipantsChange?: (participants:{id:string;name:string;avatar:string|null;color?:string}[]) => void;
  onClose: () => void;
  onExpand: () => void;
  onError: (s: string) => void;
}) {
  const { Room, RoomEvent, Track, VideoPresets, DisconnectReason } = LK!;
  // Full profiles (badges, verified mark, server tag) for everyone in the call; LiveKit itself only knows names.
  const fullPerson = (id: string): Person | null => roster.find(u => u.id === id) || members.find(m => m.id === id) || (peer?.id === id ? peer : null) || null;
  const [, , tr] = useLang();
  const [room, setRoom] = useState<Room | null>(null);
  const [status, setStatus] = useState('Connecting…');
  const [mic, setMic] = useState(false);
  const [micRetry,setMicRetry]=useState(0),[micPending,setMicPending]=useState(false);
  const [camera, setCamera] = useState(false);
  const [screen, setScreen] = useState(false);
  const [ownStreamHidden,setOwnStreamHidden]=useState(()=>{try{return localStorage.getItem('malvo-hide-own-stream')==='1'}catch{return false}});
  const ownStreamHiddenRef=useRef(ownStreamHidden);ownStreamHiddenRef.current=ownStreamHidden;
  const mediaSyncRef=useRef<(()=>void)|null>(null);
  useEffect(()=>{try{localStorage.setItem('malvo-hide-own-stream',ownStreamHidden?'1':'0')}catch{console.warn('Stream preview preference could not be saved.')}if(ownStreamHidden){mediaRef.current?.querySelectorAll('.live-track-tile.is-focused').forEach(tile=>tile.classList.remove('is-focused'));mediaRef.current?.removeAttribute('data-focus');stageRef.current?.removeAttribute('data-stream-focus')}mediaSyncRef.current?.()},[ownStreamHidden]);
  const [streamMode,setStreamMode]=useState<'all'|'selected'>('all'),[streamAllowed,setStreamAllowed]=useState<string[]>([]),[streamViewers,setStreamViewers]=useState<{id:string;name:string}[]>([]);
  const streamPolicy=useRef({mode:streamMode,selected:streamAllowed});streamPolicy.current={mode:streamMode,selected:streamAllowed};
  const updateStreamAccess=(r:Room)=>{const p=streamPolicy.current,value=streamPermissions(p.mode,p.selected,r.remoteParticipants.values(),r.localParticipant.trackPublications.values());r.localParticipant.setTrackSubscriptionPermissions(value.all,value.permissions);};
  useEffect(()=>{if(!room)return;const update=()=>updateStreamAccess(room);update();room.on(RoomEvent.ParticipantConnected,update);room.on(RoomEvent.LocalTrackPublished,update);room.on(RoomEvent.Reconnected,update);return()=>{room.off(RoomEvent.ParticipantConnected,update);room.off(RoomEvent.LocalTrackPublished,update);room.off(RoomEvent.Reconnected,update)}},[room,streamMode,streamAllowed]);
  useEffect(()=>{if(!room||!screen){setStreamViewers([]);return;}let live=true,busy=false;const controller=new AbortController();const refresh=()=>{if(busy)return;busy=true;void api('/rooms/'+encodeURIComponent(roomId)+'/call/viewers','GET',undefined,0,AbortSignal.any([controller.signal,AbortSignal.timeout(6000)])).then(v=>{if(live)setStreamViewers(Array.isArray(v?.viewers)?v.viewers:[])}).catch(e=>{if(!controller.signal.aborted)console.warn('Stream viewer list unavailable:',e?.status||'network')}).finally(()=>{busy=false})};refresh();const timer=setInterval(refresh,5000);return()=>{live=false;controller.abort();clearInterval(timer)}},[room,screen,roomId]);
  const deafen=deafened;
  const [people, setPeople] = useState(1);
  const [participants, setParticipants] = useState<
    { id: string; name: string; avatar: string | null; color?: string }[]
  >([]);
  const rosterInputs=useRef({members,peer,onParticipantsChange});rosterInputs.current={members,peer,onParticipantsChange};
  const [gameOpen, setGameOpen] = useState(false);
  const [hasVideoTrack, setHasVideoTrack] = useState(false);
  const [mediaFlags, setMediaFlags] = useState<Record<string, { camera: boolean; screen: boolean }>>({});
  const [qualityMenu,setQualityMenu,qualityClosing]=useAnimatedToggle();
  const [qualityAnchor,setQualityAnchor]=useState({left:8,top:8});
  const [streamQuality, setStreamQuality] = useState(() => {
    try { return localStorage.getItem('malvo-stream-quality') || '1080p30'; } catch { return '1080p30'; }
  });
  const deviceLocks=useRef(new Set<string>());
  const [deviceBusy,setDeviceBusy]=useState<string[]>([]);
  const [deviceHint,setDeviceHint]=useState('');
  const [screenPicker,setScreenPicker]=useState<{sources:ScreenSource[];browser?:boolean;resolve:(c:ScreenChoice|null)=>void}|null>(null);
  const [isBrowserFullscreen, setIsBrowserFullscreen] = useState(false);
  const [volMenu, setVolMenu] = useState<{ x: number; y: number; id: string; name: string; stream?:boolean; leave?:()=>void } | null>(null);
  const [volumes, setVolumes] = useState<Record<string, number>>(()=>{try{return JSON.parse(localStorage.getItem('malvo-volumes:'+me.id)||'{}');}catch{return {};}});
  const [streamVolumes,setStreamVolumes]=useState<Record<string,number>>(()=>{try{return JSON.parse(localStorage.getItem('malvo-stream-volumes:'+me.id)||'{}');}catch{return {};}});
  const streamVolumesRef=useRef(streamVolumes);streamVolumesRef.current=streamVolumes;
  useEffect(()=>{if(!volMenu)return;const close=(e:KeyboardEvent)=>{if(e.key==='Escape')setVolMenu(null);};window.addEventListener('keydown',close);return()=>window.removeEventListener('keydown',close);},[!!volMenu]);
  const audioRoomRef=useRef(room);audioRoomRef.current=room;
  const volumesRef=useRef(volumes);volumesRef.current=volumes;
  const mutedRef=useRef(muted);mutedRef.current=muted;
  const deafenedRef=useRef(deafened);deafenedRef.current=deafened;
  // Apply immediately to existing and newly attached audio, rather than waiting for a polling tick.
  // Layout effect: mute before the next paint, not a frame later.
  useLayoutEffect(()=>{const root=mediaRef.current;if(!root)return;const apply=()=>syncCallAudioMute(root,deafened);apply();const observer=new MutationObserver(apply);observer.observe(root,{childList:true,subtree:true});return()=>observer.disconnect();},[deafened,room]);
  // Deafen guard: any call audio that starts or resumes playing while deafened (reconnects, resubscribed tracks, LiveKit
  // re-attaching a new stream, stream audio moved outside the call view) is muted on the spot, wherever it lives in the page.
  useEffect(()=>{const guard=(e:Event)=>{const el=e.target;if(deafenedRef.current&&el instanceof HTMLMediaElement&&el.dataset.participant&&!el.muted)el.muted=true;};
    for(const type of ['play','playing','loadedmetadata','volumechange'])document.addEventListener(type,guard,true);
    return()=>{for(const type of ['play','playing','loadedmetadata','volumechange'])document.removeEventListener(type,guard,true);};},[]);
  const muteAllCallAudio=(on:boolean)=>{deafenedRef.current=on;for(const el of document.querySelectorAll<HTMLMediaElement>('audio[data-participant]'))el.muted=on;
    const r=audioRoomRef.current;if(r)for(const p of r.remoteParticipants.values())applyParticipantAudio(p,on,volumesRef.current[p.identity]??100,streamVolumesRef.current[p.identity]??100,Track.Source);};
  // Mic changes run one after another: overlapping publish calls right after joining could leave the mic unpublished.
  const micQueue=useRef<Promise<unknown>>(Promise.resolve());
  useEffect(()=>{if(!room)return;let cancelled=false;const want=!muted&&!deafened;setMicPending(true);micQueue.current=micQueue.current.catch(()=>{}).then(async()=>{
    if(cancelled)return;
    try{const fallback=await setCallMicrophone(room.localParticipant,want,microphoneOptions(),()=>cancelled);if(!cancelled){onError('');if(fallback)setDeviceHint(tr('The saved microphone is unavailable. The system microphone is being used for this call.','Das gespeicherte Mikrofon ist nicht verfügbar. Dieser Anruf verwendet das Systemmikrofon.'));}}
    catch(e){if(!cancelled){const reason=microphoneFailure(e);onError(reason==='permission'?tr('Microphone access is blocked. Allow it in the app or browser permissions, then press the microphone button to retry.','Der Mikrofonzugriff ist blockiert. Erlaube ihn in den App- oder Browserberechtigungen und drücke dann erneut auf das Mikrofon.'):reason==='missing'?tr('No usable microphone was found. Check your input device and press the microphone button to retry.','Kein nutzbares Mikrofon gefunden. Prüfe dein Eingabegerät und drücke erneut auf das Mikrofon.'):reason==='busy'?tr('The microphone could not start. Close other recording apps, check Android microphone access and press the microphone button to retry.','Das Mikrofon konnte nicht starten. Schließe andere Aufnahme-Apps, prüfe den Android-Mikrofonzugriff und drücke erneut auf das Mikrofon.'):tr('Microphone: ','Mikrofon: ')+(e as Error).message);}}
    finally{if(!cancelled){setMic(room.localParticipant.isMicrophoneEnabled);setMicPending(false);}}
  });return()=>{cancelled=true;};},[room,muted,deafened,micRetry]);
  useEffect(()=>{if(!room)return;const update=()=>{micQueue.current=micQueue.current.catch(()=>{}).then(async()=>{const track=room.localParticipant.getTrackPublication(Track.Source.Microphone)?.track;if(track)try{await track.restartTrack(microphoneOptions());}catch(e){onError(tr('Microphone settings could not be applied: ','Mikrofoneinstellungen konnten nicht übernommen werden: ')+(e as Error).message);}})};window.addEventListener('malvo-audio-processing',update);return()=>window.removeEventListener('malvo-audio-processing',update)},[room]);
  // Refresh only our own authoritative roster entry after publication/mute settles.
  useEffect(()=>{if(!room)return;const controller=new AbortController();const timer=setTimeout(()=>{void api('/rooms/'+encodeURIComponent(roomId)+'/call/media','POST',{deafened},0,controller.signal).catch(error=>{if(!controller.signal.aborted)console.warn('Voice media status refresh failed:',error?.status||'network');});},180);return()=>{clearTimeout(timer);controller.abort();};},[room,camera,screen,mic,deafened,roomId]);
  // Browsers block call audio until the page was clicked (e.g. after the automatic rejoin on update): offer a button and unlock on the first click or key.
  const [audioBlocked,setAudioBlocked]=useState(false);
  useEffect(()=>{if(!room)return;const sync=()=>setAudioBlocked(!room.canPlaybackAudio);sync();room.on(RoomEvent.AudioPlaybackStatusChanged,sync);const unlock=()=>{if(!room.canPlaybackAudio)void room.startAudio().catch(()=>{});};window.addEventListener('pointerdown',unlock,true);window.addEventListener('keydown',unlock,true);return()=>{room.off(RoomEvent.AudioPlaybackStatusChanged,sync);window.removeEventListener('pointerdown',unlock,true);window.removeEventListener('keydown',unlock,true);};},[room]);
  useEffect(()=>{if(!room)return;for(const p of room.remoteParticipants.values()){applyParticipantAudio(p,deafened,volumes[p.identity]??100,streamVolumes[p.identity]??100,Track.Source);}},[room,deafened,volumes,streamVolumes]);
  useEffect(()=>{if(!room)return;const h=()=>{for(const p of room.remoteParticipants.values())applyParticipantAudio(p,deafenedRef.current,volumesRef.current[p.identity]??100,streamVolumesRef.current[p.identity]??100,Track.Source);};window.addEventListener('malvo:output-volume',h);return()=>window.removeEventListener('malvo:output-volume',h);},[room]);
  useEffect(()=>{const listener=(e:Event)=>{const d=(e as CustomEvent).detail;setParticipantVolume(d.id,d.value);};window.addEventListener('malvo-participant-volume',listener);return()=>window.removeEventListener('malvo-participant-volume',listener);},[]);
  const mediaRef = useRef<HTMLDivElement>(null);
  const stageRef = useRef<HTMLElement>(null);
  useEffect(()=>{const media=mediaRef.current;if(!media)return;const sync=()=>{const tiles=[...media.querySelectorAll<HTMLElement>('.live-track-tile:not(.stream-watch-card)')];const chosen=tiles.find(t=>t.classList.contains('is-focused'))||tiles.find(t=>t.dataset.source==='screen_share')||tiles[0];for(const tile of tiles)tile.toggleAttribute('data-floating-active',tile===chosen);};sync();const observer=new MutationObserver(sync);observer.observe(media,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});return()=>observer.disconnect();},[floating,room]);

  useEffect(() => {
    const onFs = () => setIsBrowserFullscreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', onFs);
    return () => document.removeEventListener('fullscreenchange', onFs);
  }, []);

  const ringbackAnswered = useRef(false),outgoingTone=useRef<CallTone|null>(null);
  useEffect(() => {
    ringbackAnswered.current = false;outgoingTone.current=null;
    const answered = (event: Event) => {
      if ((event as CustomEvent<string>).detail !== roomId) return;
      ringbackAnswered.current = true;
      stopOutgoingRingtone();
    };
    window.addEventListener('malvo:call-answered', answered);
    return () => { window.removeEventListener('malvo:call-answered', answered); stopOutgoingRingtone(); };
  }, [roomId]);

  useEffect(() => {
    if (people > 1) ringbackAnswered.current = true;
    if ((!peer && !ringing?.length) || people > 1 || status !== 'Connected' || ringbackAnswered.current) return;
    const pulse = () => { if (!ringbackAnswered.current){outgoingTone.current ||= chooseCallTone();playOutgoingRingPulse(me.status,outgoingTone.current);} };
    pulse();
    const timer = setInterval(pulse, 2200);
    return () => { clearInterval(timer); stopOutgoingRingtone(); };
  }, [peer?.id, !!ringing?.length, people, status, me.status]);

  useEffect(() => {
    stopRingtone();
    // iOS 17+: tell Safari this is a call (low-latency play-and-record session) instead of media playback.
    const audioSession = (navigator as any).audioSession;
    try { if (audioSession) audioSession.type = 'play-and-record'; } catch {}
    const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const r = new Room({
      // Always ask for the browser's echo cancellation, noise suppression and auto gain (and voice isolation where supported):
      // without them you hear your own voice back from other people's speakers and every keyboard click.
      audioCaptureDefaults: microphoneOptions(),
      audioOutput: { deviceId: localStorage.getItem('malvo-audiooutput') || 'default' },
      adaptiveStream: !isIOS,
      dynacast: true,
      videoCaptureDefaults: { resolution: VideoPresets.h720.resolution },
      publishDefaults: { videoCodec:'vp8', screenShareEncoding: { maxBitrate: 3000000, maxFramerate: 15 } }
    });
    let disposed = false,joined=false;const announcedPeers=new Set<string>();
    const reportAbort=new AbortController(),watchReporter=createStreamWatchReporter((pid,watching)=>api('/rooms/'+encodeURIComponent(roomId)+'/call/watch','POST',{publisherId:pid,sessionId:r.localParticipant.sid,watching},0,AbortSignal.any([reportAbort.signal,AbortSignal.timeout(6000)])),e=>{if(!disposed)console.warn('Stream playback acknowledgement unavailable:',(e as any)?.status||'network')});
    const reportWatch=(pid:string,watching:boolean)=>{if(!disposed&&r.localParticipant.sid)watchReporter.report(pid,watching)};
    const watchHeartbeat=setInterval(()=>{for(const p of r.remoteParticipants.values())if(watchingScreen(p,Track.Source.ScreenShare))reportWatch(p.identity,true)},5000);

    const attached = new Map<string,{track:any,el:HTMLMediaElement,tile:HTMLElement,pid:string,source:string}>();
    const paused=new Map<string,HTMLElement>(),watchTimers=new Map<string,ReturnType<typeof setTimeout>>();
    const removePaused=(sid:string)=>{clearTimeout(watchTimers.get(sid));watchTimers.delete(sid);paused.get(sid)?.remove();paused.delete(sid);};
    const clearPausedSource=(pid:string,source:string)=>{for(const [sid,tile] of paused)if(tile.dataset.participant===pid&&tile.dataset.source===source)removePaused(sid);};
    const syncVideoState = () => {
      setHasVideoTrack([...attached.values()].some(x=>x.track.kind==='video'&&x.track.mediaStreamTrack?.readyState!=='ended'&&(!ownStreamHiddenRef.current||!x.tile.classList.contains('is-local-screen')))||!!mediaRef.current?.querySelector('.stream-watch-card'));
      const flags: Record<string, { camera: boolean; screen: boolean }> = {};
      for (const x of attached.values()) {
        if (x.track.kind !== 'video') continue;
        const id = x.pid === 'local' ? me.id : x.pid;
        flags[id] = flags[id] || { camera: false, screen: false };
        if (x.source === Track.Source.ScreenShare) flags[id].screen = true; else flags[id].camera = true;
      }
      for(const p of r.remoteParticipants.values())for(const pub of p.videoTrackPublications.values()){if(pub.isMuted)continue;flags[p.identity] ||= {camera:false,screen:false};if(pub.source===Track.Source.ScreenShare)flags[p.identity].screen=true;else flags[p.identity].camera=true;}
      setMediaFlags(flags);
    };
    mediaSyncRef.current=syncVideoState;
    // Discord-like focus: one stream big, everything else in a strip below. Clicking the focused one returns to the grid.
    const focusTile=(tile:HTMLElement|null)=>{const media=mediaRef.current;if(!media)return;const already=!!tile&&tile.classList.contains('is-focused');media.querySelectorAll('.live-track-tile.is-focused').forEach(t=>t.classList.remove('is-focused'));if(tile&&!already)tile.classList.add('is-focused');const on=!!media.querySelector('.live-track-tile.is-focused');media.toggleAttribute('data-focus',on);stageRef.current?.toggleAttribute('data-stream-focus',on);};
    const wantFocus=new Set<string>();
    const removeTrack = (key:string) => {
      const x=attached.get(key);if(!x)return;
      const wasFocused=x.tile.classList.contains('is-focused');
      x.track.detach(x.el);x.tile.remove();attached.delete(key);if(wasFocused)focusTile(null);syncVideoState();
    };
    const attach = (track:any,p:any) => {
      // TrackUnmuted is also emitted for our own mic. Never play local audio.
      if(track.kind==='audio'&&(!p||p.isLocal||p.identity===me.id))return;
      if(disposed||!mediaRef.current||track.isMuted||track.mediaStreamTrack?.readyState==='ended')return;
      const key=track.sid||track.mediaStreamTrack.id,pid=p?.identity||'local',current=p?.getTrackPublication?.(track.source);
      if(current?.trackSid&&track.sid&&current.trackSid!==track.sid||current?.permissionStatus==='not_allowed')return;
      if(p&&!p.isLocal&&track.sid&&p.trackPublications&&!p.trackPublications.has(track.sid))return;
      if(track.kind==='video'){clearPausedSource(pid,track.source||'');for(const stale of sourceKeys(attached,pid,track.source||'',key))removeTrack(stale);}
      const existing=attached.get(key);if(existing&&existing.track===track&&existing.tile.isConnected){if(track.kind==='audio'){existing.el.muted=deafenedRef.current;void existing.el.play().catch(e=>{if(e.name==='NotAllowedError')setAudioBlocked(true)});}syncVideoState();return;}
      removeTrack(key);
      const el=track.attach() as HTMLMediaElement;if(track.kind==='audio')el.muted=deafenedRef.current;if(track.kind==='audio'&&p&&!p.isLocal){applyParticipantAudio(p,deafenedRef.current,volumesRef.current[pid]??100,streamVolumesRef.current[pid]??100,Track.Source);}
      el.dataset.track=key;el.dataset.participant=pid;el.dataset.source=track.source||'';
      let tile:HTMLElement=el;
      if(track.kind==='video'){
        const video=el as HTMLVideoElement;video.autoplay=true;video.playsInline=true;video.muted=true;video.controls=false;video.disablePictureInPicture=true;
        tile=document.createElement('div');tile.className='live-track-tile';tile.dataset.source=track.source||'';tile.dataset.participant=pid;tile.append(video);
        // Who is this? Name + camera/screen marker on every live tile.
        const isScreen=track.source===Track.Source.ScreenShare;
        const who=p?.isLocal?me.displayName:(p?.name||members.find(m=>m.id===p?.identity)?.displayName||p?.identity||name);
        const label=document.createElement('div');label.className='live-track-label';
        label.innerHTML=isScreen?'<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>':'<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m16 13 5.2 3.1a.5.5 0 0 0 .8-.4V8.3a.5.5 0 0 0-.8-.4L16 11"/><rect x="2" y="6" width="14" height="12" rx="2"/></svg>';
        const nameEl=document.createElement('span');nameEl.textContent=isScreen?tr(who+"'s screen",'Bildschirm von '+who):who;label.append(nameEl);
        tile.append(label);
        if(isScreen){const live=document.createElement('span');live.className='live-track-badge';live.textContent='LIVE';tile.append(live);}
        if(p?.isLocal&&track.source===Track.Source.ScreenShare){
          // In fullscreen the own screen would film itself endlessly; this notice replaces the video there.
          tile.classList.add('is-local-screen');const guard=document.createElement('div');guard.className='mirror-guard';const guardText=document.createElement('p');guardText.textContent=tr('You are sharing your screen. Your own stream is hidden in fullscreen so it does not repeat itself endlessly.','Du teilst deinen Bildschirm. Im Vollbild wird deine eigene Übertragung ausgeblendet, damit sie sich nicht endlos selbst wiederholt.');guard.append(guardText);tile.append(guard);
          video.hidden=true;const summary=document.createElement('div');summary.className='local-share-summary';const text=document.createElement('p');text.textContent=tr('Your screen is being shared. Preview is hidden to avoid the mirror effect.','Dein Bildschirm wird geteilt. Die Vorschau ist ausgeblendet, um den Spiegeleffekt zu vermeiden.');const button=document.createElement('button');button.type='button';button.textContent=tr('Show live preview','Live-Vorschau anzeigen');button.onclick=e=>{e.stopPropagation();video.hidden=false;summary.remove();void video.play().catch(()=>{});};summary.append(text,button);tile.append(summary);
        }

        // Fullscreen the live tile, avoiding Chromium's native video-player mode.
        const fullscreenButton=document.createElement('button');fullscreenButton.type='button';fullscreenButton.className='live-track-fullscreen';fullscreenButton.setAttribute('aria-label',tr('Fullscreen stream','Stream im Vollbild'));fullscreenButton.title=tr('Fullscreen stream','Stream im Vollbild');fullscreenButton.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="18" height="18"><path d="M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5"/></svg>';fullscreenButton.onclick=e=>{e.stopPropagation();void toggleStreamFullscreen(tile);};tile.append(fullscreenButton);
        tile.ondblclick=e=>{e.preventDefault();e.stopPropagation();if((e.target as HTMLElement).closest('button'))return;void toggleStreamFullscreen(tile);};
        video.disableRemotePlayback=true;

        tile.oncontextmenu=e=>{e.preventDefault();e.stopPropagation();setVolMenu({x:e.clientX,y:e.clientY,id:pid,name:p?.name||name});};
        tile.onclick=e=>{if((e.target as HTMLElement).closest('button'))return;focusTile(tile);};
      }
      attached.set(key,{track,el,tile,pid,source:track.source||''});mediaRef.current.append(tile);
      if(track.kind==='video'&&wantFocus.delete(pid+':'+(track.source||'')))focusTile(tile);
      track.mediaStreamTrack?.addEventListener('ended',()=>removeTrack(key),{once:true});
      if(track.kind==='audio')void el.play().catch(e=>{if(e.name==='NotAllowedError')setAudioBlocked(true)});
      if(track.kind==='video'){void el.play().catch(()=>{});if(p&&!p.isLocal){const publication=p.getTrackPublication?.(track.source);if(publication)decorateRemoteVideo(track,publication,p);}}syncVideoState();
    };
    const removePublication=(pub:any,p?:any)=>{
      for(const key of publicationKeys(attached,pub,p?.identity))removeTrack(key);
    };
    const speakerIndicator=createSpeakingIndicator();let activeSpeakers=new Set<string>(),shownSpeakers=new Set<string>();
    const publishSpeakers=()=>{const inputs=[r.localParticipant,...r.remoteParticipants.values()].map(p=>({id:p.identity,active:activeSpeakers.has(p.identity),enabled:!!p.getTrackPublication(Track.Source.Microphone)&&!p.getTrackPublication(Track.Source.Microphone)?.isMuted&&(!p.isLocal||!mutedRef.current&&!deafenedRef.current)}));const next=speakerIndicator(inputs,performance.now());if(next.size!==shownSpeakers.size||[...next].some(id=>!shownSpeakers.has(id))){shownSpeakers=next;onSpeakersChange?.(next);}};
    r.on(RoomEvent.ActiveSpeakersChanged,(speakers:any[])=>{activeSpeakers=new Set(speakers.map(s=>s.identity));publishSpeakers();});
    const speakerTimer=setInterval(publishSpeakers,100);

    const pausePublication=(pub:any,p:any)=>{
      if(pub.kind!=='video'||!mediaRef.current||pub.isMuted)return;
      if(p.trackPublications&&!p.trackPublications.has(pub.trackSid))return;
      const current=p.getTrackPublication?.(pub.source);if(current?.trackSid&&current.trackSid!==pub.trackSid)return;
      if(pub.track&&pub.isSubscribed&&pub.permissionStatus!=='not_allowed'){attach(pub.track,p);return;}
      if(attached.has(pub.trackSid)&&pub.isDesired!==false&&pub.permissionStatus!=='not_allowed'){clearPausedSource(p.identity,pub.source);return;}
      if(paused.has(pub.trackSid))return;
      clearPausedSource(p.identity,pub.source);removePublication(pub,p);
      const tile=document.createElement('div');tile.className='live-track-tile stream-watch-card';tile.dataset.source=pub.source;tile.dataset.participant=p.identity;
      const label=document.createElement('span');label.className='live-track-label';label.textContent=p.name||p.identity;
      const title=document.createElement('b');title.className=pub.source===Track.Source.ScreenShare?'stream-watch-live':'stream-watch-title';title.textContent=pub.source===Track.Source.ScreenShare?'LIVE':tr('Camera hidden','Kamera ausgeblendet');
      try{const av=JSON.parse(p.metadata||'{}').avatar||members.find(m=>m.id===p.identity)?.avatar;const src=av?avatarSrc({avatar:av}):null;if(src)tile.style.setProperty('--stream-bg',`url("${src}")`);}catch{}
      const button=document.createElement('button');button.type='button';button.textContent=pub.source===Track.Source.ScreenShare?tr('Watch stream','Stream anschauen'):tr('Show camera','Kamera anzeigen');
      const connecting=()=>{clearTimeout(watchTimers.get(pub.trackSid));button.disabled=true;button.textContent=tr('Connecting…','Verbindung …');watchTimers.set(pub.trackSid,setTimeout(()=>{watchTimers.delete(pub.trackSid);if(tile.isConnected){button.disabled=false;button.textContent=tr('Try again','Erneut versuchen');}},10000));};
      button.onclick=()=>{if(button.disabled)return;wantFocus.add(p.identity+':'+pub.source);pub.setSubscribed(true);if(pub.source===Track.Source.ScreenShare)for(const audio of p.audioTrackPublications.values())if(audio.source===Track.Source.ScreenShareAudio)audio.setSubscribed(true);if(pub.track&&!pub.isMuted)attach(pub.track,p);else connecting();};
      tile.append(title,button,label);mediaRef.current.append(tile);paused.set(pub.trackSid,tile);if(pub.permissionStatus==='not_allowed'){button.disabled=true;button.textContent=tr('Not shared with you','Nicht für dich freigegeben');}else if(pub.isDesired)connecting();setHasVideoTrack(true);if(pub.source===Track.Source.ScreenShare&&takeStreamWatch(roomId,p.identity))button.click();
    };
    const watchRequested=()=>{for(const tile of paused.values())if(tile.dataset.source===Track.Source.ScreenShare&&takeStreamWatch(roomId,tile.dataset.participant||'')){tile.querySelector<HTMLButtonElement>('button')?.click();break;}};
    window.addEventListener('malvo-watch-stream',watchRequested);
    const initRemote=(pub:any,p:any)=>{if(pub.source===Track.Source.ScreenShareAudio){pub.setSubscribed(watchingScreen(p,Track.Source.ScreenShare));return;}if(pub.kind==='video'&&pub.source===Track.Source.ScreenShare)pausePublication(pub,p);else pub.setSubscribed(true);};
    function decorateRemoteVideo(track:any,pub:any,p:any){
      if(track.kind==='video'){const entry=attached.get(track.sid||track.mediaStreamTrack.id);if(entry&&!entry.tile.querySelector('.live-track-hide')){const hide=document.createElement('button');hide.className='live-track-hide';hide.type='button';hide.textContent=tr('Hide','Ausblenden');hide.onclick=e=>{e.stopPropagation();pub.setSubscribed(false);if(pub.source===Track.Source.ScreenShare)for(const a of p.audioTrackPublications.values())if(a.source===Track.Source.ScreenShareAudio)a.setSubscribed(false);pausePublication(pub,p);};entry.tile.append(hide);entry.tile.oncontextmenu=e=>{e.preventDefault();e.stopPropagation();if(pub.source===Track.Source.ScreenShare)openStreamMenu(e,p,()=>hide.click(),setVolMenu);else hide.click();};}}
    }
    r.on(RoomEvent.TrackPublished,(pub,p)=>{initRemote(pub,p);syncVideoState();});
    r.on(RoomEvent.TrackUnpublished,(pub,p)=>{removePaused(pub.trackSid);removePublication(pub,p);syncVideoState();});
    r.on(RoomEvent.TrackSubscribed,(track,pub,p)=>{removePaused(pub.trackSid);attach(track,p);if(pub.source===Track.Source.ScreenShare){reportWatch(p.identity,true);for(const audio of p.audioTrackPublications.values())if(audio.source===Track.Source.ScreenShareAudio)audio.setSubscribed(true);}
      decorateRemoteVideo(track,pub,p);
    });
    r.on(RoomEvent.LocalTrackPublished,(pub,p)=>{if(pub.track?.kind==='video')attach(pub.track,p);if(pub.source===Track.Source.Microphone)void applyMicGain(pub.track);});
    r.on(RoomEvent.TrackUnsubscribed,(track,pub,p)=>{removePublication(pub,p);if(pub.source===Track.Source.ScreenShare)reportWatch(p.identity,false);if(pub.source===Track.Source.ScreenShare)for(const audio of p.audioTrackPublications.values())if(audio.source===Track.Source.ScreenShareAudio)audio.setSubscribed(false);if(pub.kind==='video'&&!pub.isMuted&&pub.isDesired)pausePublication(pub,p);});
    r.on(RoomEvent.TrackSubscriptionPermissionChanged,(pub,status,p)=>{if(status==='not_allowed')removePublication(pub,p);if(pub.source!==Track.Source.ScreenShare)return;if(status==='not_allowed')reportWatch(p.identity,false);removePaused(pub.trackSid);pausePublication(pub,p);});
    r.on(RoomEvent.TrackSubscriptionFailed,(sid,p)=>{const pub=p.trackPublications.get(sid);if(!pub){removePaused(sid);return;}pausePublication(pub,p);clearTimeout(watchTimers.get(sid));watchTimers.delete(sid);const button=paused.get(sid)?.querySelector('button');if(button){button.disabled=false;button.textContent=tr('Try again','Erneut versuchen');}});
    r.on(RoomEvent.LocalTrackPublished,pub=>{if(pub.source===Track.Source.ScreenShare)playScreenShareStartSound(me?.status);});r.on(RoomEvent.LocalTrackUnpublished,(pub,p)=>{if(pub.source===Track.Source.ScreenShare)playScreenShareStopSound(me?.status);removePublication(pub,p);setCamera(r.localParticipant.isCameraEnabled);setScreen(r.localParticipant.isScreenShareEnabled);});
    r.on(RoomEvent.TrackMuted,(pub,p)=>{if(pub.kind==='video'){removePaused(pub.trackSid);removePublication(pub,p);syncVideoState();}});
    r.on(RoomEvent.TrackUnmuted,(pub,p)=>{if(pub.kind==='audio'&&pub.track)attach(pub.track,p);if(pub.kind==='video'){if(pub.track&&(p.isLocal||(pub as any).isDesired!==false))attach(pub.track,p);else if(!p.isLocal)pausePublication(pub,p);syncVideoState();}});

    const roster = () => {
      if(disposed)return;
      const inputs=rosterInputs.current;
      const current=[...r.remoteParticipants.values()].map(p=>{
        let avatar:string|null=null;
        try{const value=JSON.parse(p.metadata||'{}');if(typeof value.avatar==='string')avatar=value.avatar}catch{/* Optional remote metadata may be absent. */}
        const member=inputs.members.find(m=>m.id===p.identity)||(inputs.peer?.id===p.identity?inputs.peer:null);
        return {id:p.identity,name:shownName({id:p.identity,displayName:p.name})||shownName(member)||tr('Participant','Teilnehmer'),avatar:avatar||member?.avatar||null,color:member?.color||'#ef5252'};
      });
      setPeople(current.length+1);setParticipants(current);
      // The authenticated SFU session remains authoritative if the app socket reconnects.
      inputs.onParticipantsChange?.(current);
    };
    r.on(RoomEvent.ParticipantMetadataChanged,roster);
    r.on(RoomEvent.ParticipantNameChanged,roster);
    r.on(RoomEvent.ParticipantConnected, (p) => {
      roster();
      ringbackAnswered.current = true;
      stopOutgoingRingtone();
      const known=announcedPeers.has(p.identity);announcedPeers.add(p.identity);if(joined&&!known)playCallJoinSound(me.status);
      roster();
    });
    r.on(RoomEvent.ParticipantDisconnected, (p) => {
      roster();
      onParticipantLeft?.(p.identity);
      for(const [key,x] of attached)if(x.pid===p.identity)removeTrack(key);
      for(const [sid,tile] of paused)if(tile.dataset.participant===p.identity)removePaused(sid);syncVideoState();
      if(announcedPeers.delete(p.identity)&&joined)playCallLeaveSound(me.status);
      roster();
    });
    r.on(RoomEvent.Reconnecting, () => setStatus('Reconnecting…'));
    r.on(RoomEvent.Reconnected, () => {setStatus('Connected');recoverCallMicrophones(r.remoteParticipants.values(),Track.Source.Microphone,attach,p=>applyParticipantAudio(p,deafenedRef.current,volumesRef.current[p.identity]??100,streamVolumesRef.current[p.identity]??100,Track.Source));void r.startAudio().catch(()=>setAudioBlocked(true));roster();});
    // Removed by the server (timeout, kick, move without permission, room closed) or the connection gave up:
    // end the call cleanly so the person can simply click the channel again to rejoin.
    r.on(RoomEvent.Disconnected, (reason?: any) => {setStatus('Disconnected');onParticipantLeft?.(me.id);if(disposed||reason===DisconnectReason.CLIENT_INITIATED)return;onError(reason===DisconnectReason.PARTICIPANT_REMOVED?(longLiveOutage()?tr('Your connection to MALVO was interrupted for too long, so you were taken out of the voice channel. Click the channel to rejoin.','Deine Verbindung zu MALVO war zu lange unterbrochen, deshalb wurdest du aus dem Sprachkanal genommen. Klicke auf den Kanal, um wieder beizutreten.'):tr('You were removed from the voice channel, for example by a moderator or because you lost access.','Du wurdest aus dem Sprachkanal entfernt, zum Beispiel von einem Moderator oder weil dir der Zugriff fehlt.')):reason===DisconnectReason.DUPLICATE_IDENTITY?tr('You joined this call on another device.','Du bist dem Anruf auf einem anderen Gerät beigetreten.'):tr('Voice connection lost. Click the channel to rejoin.','Sprachverbindung verloren. Klicke auf den Kanal, um wieder beizutreten.'));setTimeout(()=>{if(!disposed)onClose();},300);});
    const stopPing = trackPing(r);

    const joinController=new AbortController();let joinId:string=crypto.randomUUID();
    // Another tab or device of this account can take over the pending join; try once more before reporting it.
    const requestJoin=(retried=false):Promise<any>=>api('/rooms/' + roomId + '/call','POST',{joinId},0,joinController.signal).catch(async e=>{
      if(e?.code!=='VOICE_JOIN_SUPERSEDED'||retried||disposed)throw e;
      await new Promise(res=>setTimeout(res,500));
      if(disposed)throw e;
      joinId=crypto.randomUUID();
      return requestJoin(true);
    });
    requestJoin()
      .then(async d => {
        socket?.emit('join', roomId);
        if (disposed) return;
        // The SDK owns signalling retries; a second outer retry loop multiplied waits.
        await r.connect(d.url,d.token,{autoSubscribe:false,maxRetries:1,websocketTimeout:10000,peerConnectionTimeout:15000});
        for(const p of r.remoteParticipants.values())for(const pub of p.trackPublications.values())initRemote(pub,p);
        if (disposed) {
          r.disconnect();
          return;
        }
        for(const p of r.remoteParticipants.values())announcedPeers.add(p.identity);joined=true;
        setRoom(r);
        roster();
        setStatus('Connected');
        playCallJoinSound(me.status);
        // The microphone is switched on by the mic effect as soon as the room is set (one publish, errors shown).
      })
      .catch(e => {
        if (disposed) return;
        const msg = String(e?.message || '');
        onError(/websocket|signal connection|could not establish/i.test(msg)
          ? tr('Could not connect to the voice server. Please check your connection and try again.', 'Keine Verbindung zum Sprachserver. Bitte prüfe deine Verbindung und versuche es erneut.')
          : e?.code==='VOICE_JOIN_SUPERSEDED'
          ? tr('This call is being joined on another of your devices. Please try again.', 'Du trittst diesem Anruf gerade auf einem anderen Gerät bei. Bitte versuche es erneut.')
          : msg);
        setStatus('Connection failed');
        onClose(); // A failed join must not trap the next click in an already-open call.
      });

    // Closing the tab skips the cleanup below, so tell the server while the page is going away.
    // The session id makes sure an old tab or device only ends its own connection, not a newer one of the same account.
    const leaveOnPageClose = () => { void fetch('/api/rooms/' + encodeURIComponent(roomId) + '/call/leave', { method: 'POST', keepalive: true, headers: { 'x-malvo': '1', 'content-type': 'application/json' }, body: JSON.stringify({ sid: r.localParticipant?.sid || undefined,joinId }) }).catch(() => {}); };
    window.addEventListener('pagehide', leaveOnPageClose);
    // Device picked in the quick menu of the user panel: switch the running call right away.
    const switchDevice = (e: Event) => { const { kind, id } = (e as CustomEvent).detail || {}; if (kind === 'audioinput' || kind === 'audiooutput') void r.switchActiveDevice(kind, id || 'default').catch(() => {}); };
    window.addEventListener('malvo:audio-device', switchDevice);
    // Hide the own screen-share preview while it is inside a fullscreen element (mirror effect).
    const guardMirror = () => { const fs = document.fullscreenElement; document.querySelectorAll<HTMLElement>('.live-track-tile.is-local-screen').forEach(t => t.classList.toggle('is-mirror-guarded', !!fs && fs.contains(t))); };
    document.addEventListener('fullscreenchange', guardMirror);

    return () => {
      disposed = true;joinController.abort();clearInterval(speakerTimer);clearInterval(watchHeartbeat);watchReporter.stop();reportAbort.abort();
      try { if (audioSession) audioSession.type = 'auto'; } catch {}
      window.removeEventListener('pagehide', leaveOnPageClose);
      window.removeEventListener('malvo:audio-device', switchDevice);
      document.removeEventListener('fullscreenchange', guardMirror);
      window.removeEventListener('malvo-watch-stream',watchRequested);
      stopRingtone();
      for(const sid of [...paused.keys()])removePaused(sid);
      for(const key of [...attached.keys()])removeTrack(key);
      stopPing();
      const ownSid = r.localParticipant?.sid || undefined;
      void r.disconnect();
      api('/rooms/'+roomId+'/call/leave','POST',{sid:ownSid,joinId}).catch(()=>{});
      onSpeakersChange?.(new Set());
    };
  }, [roomId]);

  function setParticipantVolume(pid:string,val:number){
    const bounded=clampAudioVolume(val);
    const p=audioRoomRef.current?.remoteParticipants.get(pid);if(p)applyParticipantAudio(p,deafenedRef.current,bounded,streamVolumesRef.current[pid]??100,Track.Source);
    setVolumes(prev=>{const next={...prev,[pid]:bounded};volumesRef.current=next;try{localStorage.setItem('malvo-volumes:'+me.id,JSON.stringify(next));}catch{}return next;});
  }

  function setStreamVolume(pid:string,val:number){
    const bounded=clampAudioVolume(val);
    setStreamVolumes(prev=>{const next={...prev,[pid]:bounded};streamVolumesRef.current=next;try{localStorage.setItem('malvo-stream-volumes:'+me.id,JSON.stringify(next));}catch{}return next;});
    const p=room?.remoteParticipants.get(pid);if(p)applyParticipantAudio(p,deafenedRef.current,volumesRef.current[pid]??100,bounded,Track.Source);
  }
  const menuVolume=volMenu?(volMenu.stream?streamVolumes:volumes)[volMenu.id]??100:100;
  const setMenuVolume=(value:number)=>{if(volMenu)(volMenu.stream?setStreamVolume:setParticipantVolume)(volMenu.id,value);};

  async function toggle(kind: 'mic' | 'camera' | 'screen') {
    if (!room||deviceLocks.current.has(kind)) return;
    deviceLocks.current.add(kind);setDeviceBusy([...deviceLocks.current]);setDeviceHint('');onError('');
    try {
      if (kind === 'mic') {
        if(micPending)return;
        const nextMuted=microphoneToggleMuted(mic,muted,deafened);onMutedChange(nextMuted);if(!nextMuted){onDeafenedChange(false);setMicRetry(value=>value+1);}
        playMuteToggleSound(nextMuted);
      }
      if (kind === 'camera') {
        try { await room.localParticipant.setCameraEnabled(!camera); }
        catch (camErr) {
          // "Requested device not found" / overconstrained: retry with the first camera that really exists.
          const n = (camErr as Error)?.name || '', m = String((camErr as Error)?.message || '');
          if (camera || !(n === 'NotFoundError' || n === 'OverconstrainedError' || /not found|overconstrained/i.test(m))) throw camErr;
          const cams = (await navigator.mediaDevices.enumerateDevices().catch(() => [] as MediaDeviceInfo[])).filter(d => d.kind === 'videoinput');
          if (!cams.length) { setDeviceHint(tr('No camera found. Check that a camera is connected and that camera access is allowed (Windows: Settings → Privacy & security → Camera → allow desktop apps and your browser).', 'Keine Kamera gefunden. Prüfe, ob eine Kamera angeschlossen ist und der Kamerazugriff erlaubt ist (Windows: Einstellungen → Datenschutz und Sicherheit → Kamera → Desktop-Apps und deinen Browser erlauben).')); return; }
          let ok = false;
          for (const cam of cams) { try { await room.localParticipant.setCameraEnabled(true, { deviceId: cam.deviceId || undefined, resolution: { width: 1280, height: 720 } }); ok = true; break; } catch {} }
          if (!ok) { try { await room.localParticipant.setCameraEnabled(true, { resolution: { width: 640, height: 480 } }); ok = true; } catch {} }
          if (!ok) { setDeviceHint(tr('The camera could not be started. Close other apps that use it (Zoom, Teams, OBS …) and try again.', 'Die Kamera konnte nicht gestartet werden. Schließe andere Programme, die sie benutzen (Zoom, Teams, OBS …), und versuche es erneut.')); return; }
        }
        setCamera(room.localParticipant.isCameraEnabled);
      }
      if (kind === 'screen') {
        // The desktop app lists screens and windows itself; browsers show their own picker.
        const desktop = (window as any).malvoDesktop;
        let qualityId = streamQuality, shareAudio = true, sourceId = '';
        if (!screen && desktop?.getScreenSources) {
          const sources: ScreenSource[] = await desktop.getScreenSources();
          const choice = await new Promise<ScreenChoice | null>(resolve => setScreenPicker({ sources, resolve }));
          setScreenPicker(null);
          if (!choice) return;
          qualityId = choice.quality; shareAudio = choice.audio;
          setStreamQuality(qualityId);
          try { localStorage.setItem('malvo-stream-quality', qualityId); } catch {}
          sourceId = choice.id;
          await desktop.selectScreenSource(choice.id, shareAudio);
        } else if (!screen && !/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
          // Browsers: prepare quality and sound, then the browser's own picker opens from the "Continue" click.
          // Safari only allows the picker directly inside a click, so it keeps opening right away.
          const choice = await new Promise<ScreenChoice | null>(resolve => setScreenPicker({ sources: [], browser: true, resolve }));
          setScreenPicker(null);
          if (!choice) return;
          qualityId = choice.quality; shareAudio = choice.audio;
          setStreamQuality(qualityId);
          try { localStorage.setItem('malvo-stream-quality', qualityId); } catch {}
        }
        const q = STREAM_QUALITIES.find(x => x.id === qualityId) || STREAM_QUALITIES[1];
        const share = (audio: boolean) => room.localParticipant.setScreenShareEnabled(!screen, {
          resolution: { width: q.width, height: q.height, frameRate: q.fps },
          audio:streamAudioConstraints(audio),
          selfBrowserSurface:'exclude',
          surfaceSwitching:'include'
        }, { screenShareEncoding: { maxBitrate: q.bitrate, maxFramerate: q.fps } });
        updateStreamAccess(room);
        try { await share(shareAudio); }
        catch (err) {
          // Some PCs cannot capture system sound (audio driver busy/exclusive, no loopback device):
          // start the stream without sound instead of failing completely.
          const m = String((err as Error)?.message || ''), n = (err as Error)?.name || '';
          if (screen || !shareAudio || !(/audio source|audio/i.test(m) || n === 'NotReadableError' || n === 'AbortError')) throw err;
          if (sourceId && desktop?.selectScreenSource) await desktop.selectScreenSource(sourceId, false);
          await share(false);
          setDeviceHint(tr('Your PC could not share its sound, so the stream runs without sound. Check Windows sound settings (e.g. disable exclusive mode) and try again.', 'Dein PC konnte den Ton nicht freigeben, der Stream läuft deshalb ohne Ton. Prüfe die Windows-Soundeinstellungen (z. B. exklusiven Modus deaktivieren) und versuche es erneut.'));
        }
        setScreen(room.localParticipant.isScreenShareEnabled);
        if(!screen&&shareAudio&&!room.localParticipant.getTrackPublication(Track.Source.ScreenShareAudio))setDeviceHint(tr('The selected source provides no audio. In the browser picker, enable audio sharing if available.','Die gewählte Quelle liefert keinen Ton. Aktiviere in der Browserauswahl die Tonfreigabe, falls sie angeboten wird.'));
      }
      onError('');
    } catch (e) {
      const err=e as Error;
      if(err.name==='NotAllowedError'||/permission denied|denied by user/i.test(err.message))setDeviceHint(kind==='screen'?tr('Screen selection cancelled or permission not granted.','Bildschirmauswahl abgebrochen oder Freigabe nicht erlaubt.'):tr('Device permission was not granted.','Geräteberechtigung wurde nicht erteilt.'));
      else if(kind==='camera'&&(err.name==='NotReadableError'||/could not start|in use|not readable/i.test(err.message)))setDeviceHint(tr('The camera is being used by another app (Zoom, Teams, OBS …). Close it and try again.','Die Kamera wird gerade von einem anderen Programm benutzt (Zoom, Teams, OBS …). Schließe es und versuche es erneut.'));
      else onError(tr('Device: ','Gerät: ')+err.message);
    } finally {deviceLocks.current.delete(kind);setDeviceBusy([...deviceLocks.current]);}
  }

  const previousSpeaker=useRef(me.id);
  const validSpeakers=new Set([me.id,...participants.map(p=>p.id)]);
  const currentSpeaker=[...(speakingUsers||[])].find(id=>validSpeakers.has(id));
  if(currentSpeaker)previousSpeaker.current=currentSpeaker;
  const previewSpeaker=validSpeakers.has(previousSpeaker.current)?previousSpeaker.current:me.id;
  const myAvatarSrc = avatarSrc(me);
  const remotePerson = participants[0] || (peer ? { id: peer.id, name: shownName(peer), avatar: peer.avatar, color: peer.color } : null);
  const remoteAvatarSrc = avatarSrc(remotePerson);

  return (
    <section
      ref={stageRef}
      data-floating={floating?'true':undefined}
      className={
        'voice-room voice-v2 ' +
        (minimized?'is-minimized ':isExpanded ? 'is-expanded ' : 'is-docked ') +
        (hasVideoTrack ? 'has-active-video ' : '')+(floating?'is-floating':'')
      }
    >
      <MutedSpeechHint active={status==='Connected'&&muted&&!deafened} onUnmute={()=>onMutedChange(false)}/>
      <header className="voice-v2-toolbar" {...(minimized?dragHandlers:{})}>
        {minimized?<GripHorizontal size={15}/>:<Volume2 size={15}/>}<strong>{name}</strong><span className="voice-v2-people">{people} {tr('participants','Teilnehmende')}</span>
        <CallElapsed startedAt={(roster?.[0] as any)?.callStartedAt}/><span className="voice-v2-connection">{status==='Connected'?tr('Connected','Verbunden'):status}</span>
        <button type="button" className="call-minimize-control" title={minimized?tr('Restore call','Anruf wiederherstellen'):tr('Float mini window','Mini-Fenster öffnen')} onClick={onMinimize}>{minimized?<PanelTopOpen size={17}/>:<PictureInPicture2 size={17}/>}</button>
      </header>
      {audioBlocked&&<button type="button" className="call-audio-unlock" onClick={()=>void room?.startAudio().catch(()=>{})}><Volume2 size={15}/>{tr('Your browser paused call audio. Click to turn sound on.','Dein Browser hat den Call-Ton pausiert. Klicke, um den Ton zu aktivieren.')}</button>}
      {screen&&<button type="button" className="own-stream-visibility" aria-pressed={ownStreamHidden} onClick={()=>setOwnStreamHidden(v=>!v)}><MonitorUp size={15}/>{ownStreamHidden?tr('Show my stream','Eigenen Stream anzeigen'):tr('Hide my stream','Eigenen Stream ausblenden')}<small>{tr('Sharing continues','Übertragung läuft weiter')}</small></button>}
      {/* Active video / screen share streams */}
      <div className={'voice-media ' + (hasVideoTrack ? 'has-video' : '')} data-hide-own-stream={ownStreamHidden?'true':undefined} ref={mediaRef} />

      {/* Bild 5: 2-Card Flackle Voice Stage */}
      <div className="flackle-voice-cards-row" data-count={participants.length + 1 + (participants.length === 0 && peer ? 1 : 0)}>
        {/* Card 1: Current User */}
        <TintedTile
          src={myAvatarSrc}
          data-preview-active={previewSpeaker===me.id?'true':undefined}
          className={'flackle-voice-card ' + (speakingUsers?.has(me.id) ? 'is-speaking' : '')+(soundboardUsers?.has(me.id)?' is-soundboard-playing':'')}
          style={{
            order:[me.id,...participants.map(p=>p.id)].sort().indexOf(me.id)
          }}
          onContextMenu={e => {
            e.preventDefault();
            setVolMenu({ x: e.clientX, y: e.clientY, id: me.id, name: me.displayName });
          }}
        >
          <div className="flackle-voice-card-avatar">
            {myAvatarSrc ? <img src={myAvatarSrc} alt="" /> : initial(me)}
            <i className={'status-dot status-' + (me.status || 'online')} />
          </div>
          <span className="flackle-voice-card-name"><span className="voice-card-name-text">{me.displayName}</span><ChannelBadges person={fullPerson(me.id) || me} /><CallGuildTag person={fullPerson(me.id) || me} /></span>
          <MediaIndicators flags={{camera,screen}} tr={tr} />
          {!mic && (
            <span className="flackle-voice-card-muted" title="Muted">
              <MicOff size={13} />
            </span>
          )}
        </TintedTile>

        {/* Card 2: Remote Participant OR "Get some friends in!" placeholder (Bild 5) */}
        {participants.length > 0 && (
          participants.map(p => {
            const pSrc = avatarSrc(p);
            return (
              <TintedTile
                key={p.id}
                data-preview-active={previewSpeaker===p.id?'true':undefined}
                src={pSrc}
                className={'flackle-voice-card ' + (speakingUsers?.has(p.id) ? 'is-speaking' : '')+(soundboardUsers?.has(p.id)?' is-soundboard-playing':'')}
                style={{
                  order:[me.id,...participants.map(p=>p.id)].sort().indexOf(p.id)
                }}
                onContextMenu={e => {
                  e.preventDefault();
                  setVolMenu({ x: e.clientX, y: e.clientY, id: p.id, name: shownName({id:p.id,displayName:p.name}) });
                }}
                onClick={()=>onOpenProfile?.(p.id)}
              >
                <div className="flackle-voice-card-avatar">
                  {pSrc ? <img src={pSrc} alt="" /> : p.name.slice(0, 2).toUpperCase()}
                  <i className="status-dot status-online" />
                </div>
                <span className="flackle-voice-card-name">
                  <span className="voice-card-name-text">{shownName({id:p.id,displayName:p.name})}</span>{fullPerson(p.id) && <><ChannelBadges person={fullPerson(p.id)!} /><CallGuildTag person={fullPerson(p.id)!} /></>}
                </span>
                <MediaIndicators flags={mediaFlags[p.id]} tr={tr} />
              </TintedTile>
            );
          })
        )}
        {/* Only people who are being rung get a tile; everyone else appears once they actually join. */}
        {waiting.filter(w => !participants.some(p => p.id === w.id) && (ringing ? ringing.includes(w.id) : !participants.length)).map(w => {
          const isRinging = true;
          const wSrc = avatarSrc(w);
          return (
            <div key={'wait-' + w.id} className={'flackle-voice-card is-waiting-card' + (isRinging ? ' is-ringing-card' : '')} style={{ background: `radial-gradient(circle at 50% 42%, ${w.color || '#ef5252'}28 0%, #14141b 78%)`, order: 999 }} onClick={() => onOpenProfile?.(w.id)}>
              <div className="flackle-voice-card-avatar">{wSrc ? <img src={wSrc} alt={shownName(w)} /> : initial(w)}</div>
              <span className="flackle-voice-card-name"><span className="voice-card-name-text">{shownName(w)}</span><ChannelBadges person={w} /><CallGuildTag person={w} /></span>
              <small className="flackle-voice-ringing-sub">{isRinging ? tr('Ringing…', 'Klingelt …') : tr('Not in call', 'Nicht im Anruf')}</small>
            </div>
          );
        })}
      </div>

      {/* Right-click Volume / Mute Context Popover for Participants & Screen Share */}
      {volMenu && (
        <>
          <button
            type="button"
            className="profile-menu-dismiss"
            onClick={() => setVolMenu(null)}
            aria-label="Close volume menu"
          />
          <div
            className="voice-volume-popover voice-user-menu"
            role="menu"
            style={{
              left: Math.min(window.innerWidth - 252, Math.max(12, volMenu.x)),
              top: Math.min(window.innerHeight - (volMenu.stream ? 310 : volMenu.id === me.id ? 110 : 250), Math.max(12, volMenu.y))
            }}
          >
            <div className="voice-menu-head"><b>{volMenu.name}</b></div>
            <button type="button" role="menuitem" className="voice-menu-item" onClick={() => { setVolMenu(null); onOpenProfile?.(volMenu.id); }}>
              <User size={15} /> {tr('Profile', 'Profil')}
            </button>
            {volMenu.id !== me.id && (
              <>
                <button type="button" role="menuitem" className="voice-menu-item" onClick={() => { setVolMenu(null); onMessage?.(volMenu.id); }}>
                  <MessageCircle size={15} /> {tr('Message', 'Nachricht')}
                </button>
                <div className="voice-menu-divider" />
                <div className="voice-menu-label">
                  <span>{volMenu.stream?tr('Stream volume','Stream-Lautstärke'):tr('User volume', 'Nutzerlautstärke')}</span>
                  <b>{menuVolume}%</b>
                </div>
                <input
                  className="voice-menu-range"
                  type="range"
                  min="0"
                  max="100"
                  step="1"
                  value={menuVolume}
                  style={{ '--val': `${menuVolume}%` } as React.CSSProperties}
                  onChange={e => setMenuVolume(Number(e.target.value))}
                  aria-label={volMenu.stream?tr('Stream volume','Stream-Lautstärke'):tr('User volume', 'Nutzerlautstärke')}
                />
                <button
                  type="button"
                  role="menuitemcheckbox"
                  aria-checked={menuVolume === 0}
                  className="voice-menu-item voice-menu-check"
                  onClick={() => setMenuVolume(menuVolume === 0 ? 100 : 0)}
                >
                  {menuVolume === 0 ? <VolumeX size={15} /> : <Volume2 size={15} />}
                  {menuVolume===0?tr('Unmute','Ton einschalten'):tr('Mute', 'Stummschalten')}
                  <span className={'voice-menu-box' + (menuVolume === 0 ? ' is-on' : '')}>
                    {menuVolume === 0 && <Check size={12} strokeWidth={3} />}
                  </span>
                </button>
                {!volMenu.stream && <SoundboardUserToggle id={volMenu.id} tr={tr} />}
                {!volMenu.stream && onMemberActions && <>
                  <div className="voice-menu-divider" />
                  <button type="button" role="menuitem" className="voice-menu-item" onClick={e => { const r = (e.currentTarget.closest('[role=menu]') || e.currentTarget).getBoundingClientRect(); const id = volMenu.id; setVolMenu(null); onMemberActions(e, id, { x: r.left, y: r.top }); }}>
                    <MoreHorizontal size={15} /> {tr('More actions', 'Weitere Aktionen')}
                  </button>
                </>}
              </>
            )}
            {volMenu.stream&&<button type="button" role="menuitem" className="voice-menu-item text-danger" onClick={()=>{volMenu.leave?.();setVolMenu(null);}}><MonitorOff size={15}/>{tr('Leave stream','Stream verlassen')}</button>}
          </div>
        </>
      )}

      {deviceHint&&<p className="device-status-hint" role="status">{deviceHint}</p>}
      {/* Bottom Floating Call Controls + Bottom-Right Fullscreen Toggle (Bild 5) */}
      <div className="flackle-voice-bottom-bar">
        <div className="call-controls flackle-call-controls">
          <button
            title={mic ? tr('Mute Microphone', 'Mikrofon stummschalten') : tr('Unmute Microphone', 'Mikrofon aktivieren')}
            className={mic ? 'on' : 'is-off'}
            disabled={!room || micPending || deviceBusy.includes('mic')} aria-busy={micPending} onClick={() => toggle('mic')}
          >
            {mic ? <Mic size={18} /> : <MicOff size={18} />}
          </button>
          <button
            title={deafen ? tr('Undeafen', 'Ton an') : tr('Deafen', 'Ton aus')}
            className={deafen ? 'is-off' : 'on'}
            onClick={() => {
              muteAllCallAudio(!deafened);
              onDeafenedChange(!deafened);
              playDeafenToggleSound(!deafened);
            }}
          >
            {deafen ? <HeadphonesOffIcon size={18} /> : <Headphones size={18} />}
          </button>
          <button
            data-hotkey="camera"
            title={camera ? tr('Turn Off Camera', 'Kamera ausschalten') : tr('Turn On Camera', 'Kamera aktivieren')}
            className={camera ? 'on' : ''}
            disabled={!room || deviceBusy.includes('camera')} onClick={() => toggle('camera')}
          >
            {camera ? <Video size={18} /> : <VideoOff size={18} />}
          </button>
          <button
            data-hotkey="screen"
            title={screen ? tr('Stop Screen Share', 'Freigabe beenden') : tr('Share Screen (1080p)', 'Bildschirm teilen')}
            className={screen ? 'is-sharing' : ''} aria-pressed={screen}
            disabled={!room || deviceBusy.includes('screen')} onClick={() => toggle('screen')}
          >
            {screen ? <MonitorOff size={18} /> : <MonitorUp size={18} />}
          </button>
          <div className="stream-quality-wrap">
            <button
              type="button"
              className={'stream-quality-btn' + (qualityMenu ? ' on' : '')}
              title={tr('Stream quality', 'Stream-Qualität')}
              aria-expanded={qualityMenu}
              onClick={e => {const r=e.currentTarget.getBoundingClientRect();setQualityAnchor({left:Math.max(8,Math.min(r.left,innerWidth-256)),top:Math.max(8,r.top-310)});setQualityMenu(!qualityMenu);}}
            >
              <ChevronDown size={14} />
            </button>
            {qualityMenu && createPortal(<><button type="button" className="quality-dismiss" aria-label="Close quality menu" onClick={()=>setQualityMenu(false)}/><div style={qualityAnchor} className={'stream-quality-menu call-quality-popover'+(qualityClosing?' is-closing':'')} role="menu">
                <b>{tr('Stream quality', 'Stream-Qualität')}</b>
                {STREAM_QUALITIES.map(q => (
                  <button
                    key={q.id}
                    type="button"
                    role="menuitemradio"
                    aria-checked={streamQuality === q.id}
                    className={streamQuality === q.id ? 'is-active' : ''}
                    onClick={() => {
                      setStreamQuality(q.id);
                      try { localStorage.setItem('malvo-stream-quality', q.id); } catch {}
                      setQualityMenu(false);
                    }}
                  >
                    <span>{q.label}</span>
                    <small>{tr(q.note, q.noteDe)}</small>
                    {streamQuality === q.id && <Check size={14} />}
                  </button>
                ))}
                {screen && <small className="stream-quality-hint">{tr('Applies to your next screen share.', 'Gilt ab der nächsten Bildschirmfreigabe.')}</small>}
              </div></>,document.fullscreenElement||document.body)}
          </div>
          <StreamAccess mode={streamMode} selected={streamAllowed} people={participants} viewers={streamViewers} active={screen} onChange={(mode,ids)=>{setStreamMode(mode);setStreamAllowed(ids)}}/>
          <SoundboardButton request={api} />
          <button
            title={tr('Games (Chess, Tic-Tac-Toe, Connect 4)', 'Minispiele (Schach, Drei Gewinnt)')}
            className={gameOpen ? 'on' : ''}
            onClick={() => setGameOpen(!gameOpen)}
          >
            <Gamepad2 size={18} />
          </button>
          <button data-hotkey="disconnect" title={tr('Disconnect', 'Auflegen')} className="hangup" onClick={onClose}>
            <PhoneOff size={18} />
          </button>
        </div>

        <button
          type="button"
          data-hotkey="expand-call"
          className="flackle-voice-expand-btn"
          title={
            isExpanded || isBrowserFullscreen
              ? tr('Back to chat layout', 'Zur Chat-Ansicht zurück')
              : tr('Expand call view', 'Anruf groß anzeigen')
          }
          onClick={() => {
            if (document.fullscreenElement) {
              document.exitFullscreen().catch(() => {});
            } else {
              const doc = document as any;
              if (doc.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                doc.startViewTransition(() => flushSync(onExpand));
              } else onExpand();
            }
          }}
        >
          {isExpanded || isBrowserFullscreen ? <Minimize2 size={18} /> : <Maximize2 size={18} />}
        </button>
      </div>

      {gameOpen && <FloatingWindow title={tr('Call games','Minispiele')} onClose={()=>setGameOpen(false)}><CallGames roomId={roomId} me={me} socket={socket} onClose={() => setGameOpen(false)} /></FloatingWindow>}
      {screenPicker && createPortal(<ScreenPicker sources={screenPicker.sources} browser={screenPicker.browser} qualities={STREAM_QUALITIES} quality={streamQuality} onPick={c=>screenPicker.resolve(c)} onCancel={()=>screenPicker.resolve(null)}/>, document.body)}
    </section>
  );
}

void initMonitoring();
createRoot(document.getElementById('root')!,{onUncaughtError:captureReactError,onCaughtError:captureReactError,onRecoverableError:captureReactError}).render(<AppRuntime>{location.pathname==='/updates'?<ReleasePage/>:location.pathname.startsWith('/developer') ? <DeveloperPortal /> : <App />}</AppRuntime>);

import './auth-clean.css';
import './interactions.css';
import './settings.css';

import './profile-view.css';
import './games-v2.css';

import './call-layout.css';

import './interface-polish.css';

import './management-layout.css';
import './developer.css';
import './themes.css';

import './sidebar-consistency.css';

import './overlay-chat-fixes.css';
import './mobile.css';
import './link-guard';
try{const d=(window as any).malvoDesktop;if(d?.isDesktop&&d.platform&&d.platform!=='win32')document.body.classList.add('malvo-no-selfupdate');}catch{}

import './platform-ui.css';

import './team-dashboard.css';

import './discovery-browser.css';
// Keep the phone layout after feature styles so desktop dimensions cannot override its structure.
import './phone-layout.css';
import './phone-polish.css';

import './reliability-ui.css';
import './big-update.css';
import './mobile-chat-repairs.css';

import './call-improvements.css';
import './ui-polish.css';
